<template>
  <section>
    <modal-subscription-detail :callCheckRequest="callCheckRequest"/>
    <modal-change-email :newFinancialEmail.sync="callNewFinancialEmail" :dataCompanyModal="dataCompanyModal"/>
    <modal-change-timezone :dataCompanyModal="dataCompanyModal"/>
    <modal-apply-recalc-points :dataCompanyModal="dataCompanyModal"/>
    <modal-workshift-timezone-bulk :dataCompanyModal="dataCompanyModal"/>
    <modal-manage-company-tags/>
    <modal-give-gain :dataGiveModal="dataGive"/>
    <modal-change-total-employee :newTotalEmployee.sync="callNewTotalEmployee" :dataCompanyModal="dataCompanyModal"/>
    <modal-churn :dataCompanyModal="dataCompanyModal"/>
    <modal-plan-type :dataPlanModal="dataPlanType"/>
    <modal-change-gps/>
    <modal-feature-edit :reloadFunction.sync="callReloadFunction" :objToModal="dataModalFeature"/>
    <modal-payment-history :reloadFunction.sync="callReloadFunction2" :objToModal="dataModalHistoryPayment"/>
    <!--    <modal-feature-type :resetInputPayment.sync="callResetPayment" :reloadFunction.sync="callReloadFunction3"-->
    <!--                        :objToModal="dataModalFeatureType"/>-->
    <!-- Boleto avulso do tipo Feature: so ESCOLHE as funcionalidades. O id e outro porque
         o fluxo de venda desta tela ainda chama $("#modalFeatureType"). -->
    <modal-feature-type select-only modal-id="modalUpsellFeatures" :objToModal="dataModalUpsellFeatures"
                        @selected="onUpsellFeaturesSelected"/>
    <modal-question-send :dores-select="doresItens" :objetivosSelect="objetivosItens"
                         :featuresCourtesySelect="featuresCourtesyItens" :objToModalFeature="dataModalFeatureType"/>
    <modal-default @modal-closed="reportPointsClosed" modal-title="Gerar Relatório" modal-id="reportPoints"
                   margin-top="200px">
      <template>
        <datapicker-global col="7" have-range-days-max="false" range-days-init="30" label="Data de início"
                           @initDate="value => initDateReport = value"
                           @endDate="value => endDateReport = value"/>
        <btn-custom col="5" btn-color="green" class="btn-report" label="Gerar Excel"
                    have-loading="true" :loading="loadingExcel"
                    :disabled="clickDisable"
                    @emit-click="createReportExcel()"/>
      </template>
    </modal-default>
    <modal-default @modal-closed="changeUserClosed" modal-title="Alterar Usuário Master" modal-id="changeUserMaster">
      <div class="modal-change-user">
        <p class="col-md-12">Nome: <span>{{ userAdminName }}</span></p>
        <p class="col-md-12">ID: <span>{{ userAdminId }}</span></p>
        <p class="col-md-12">E-mail: <span>{{ dataPaymentCompany.company.email }}</span></p>
      </div>
      <input-text col="12" type="text" placeholder="" label="ID do novo usuário:"
                  @contentText="value => newUserAdminId = value"/>

      <input-checkbox :is-checked="false" col="12" label="Remover o CPF e a data de nascimento do cadastro?"
                      @valueCheckbox="value => clearPersonalInfo = value"/>

      <btn-custom label="Salvar" col="12" which-side="right"
                  have-loading="true" :loading="loadingUserMaster"
                  @emit-click="changeUserMaster()"/>
    </modal-default>
    <modal-password subtitle-modal="Digite a senha para continuar:" :title-modal="titleModalPassword"
                    :run-function="handleNoteChange"/>
    <modal-default modal-title="Detalhes da fatura" modal-id="editInvoice" @modal-closed="cleanModal">
      <template>
        <div class="col-md-12">
          <label>ID da empresa:</label>
          <p class="invoice-text">{{ dataSendInvoice.companyId }}</p>
        </div>
        <div class="col-md-12">
          <label>ID da fatura:</label>
          <p class="invoice-text">{{ dataSendInvoice.id }}</p>
        </div>
        <input-select col="12" :options="trueOrFalse" label="Nota gerada:" :value-selected="true"
                      :content-value-selected="dataSendInvoice.invoiceGenerated"
                      @contentValueSelected="value => dataSendInvoice.invoiceGenerated = value"/>
        <div v-if="dataSendInvoice.invoiceGenerated === true">
          <div class="col-md-12" style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 10px;">Método de inserção:</label>
            <div style="display: flex; gap: 20px;">
              <label style="display: flex; align-items: center; cursor: pointer;">
                <input type="radio" v-model="invoiceUploadMode" value="manual" style="margin-right: 5px;"/>
                Inserir URL manual
              </label>
              <label style="display: flex; align-items: center; cursor: pointer;">
                <input type="radio" v-model="invoiceUploadMode" value="upload" style="margin-right: 5px;"/>
                Upload de arquivo
              </label>
            </div>
          </div>
          <div v-if="invoiceUploadMode === 'manual'">
            <input-text col="12" type="text" placeholder="Digite aqui..." label="Link da NF:" :is-required="true"
                        :value-default="dataSendInvoice.uri"
                        :error-validate="validateError"
                        :input-error="invoiceGenerateError" :font-error="true"
                        @contentText="value => dataSendInvoice.uri = value"/>
          </div>
          <div v-if="invoiceUploadMode === 'upload'" class="col-md-12" style="margin-bottom: 15px;">
            <label style="display: block; margin-bottom: 10px;">Selecione o arquivo:</label>
            <input type="file" ref="invoiceFileInput" @change="handleInvoiceFileSelect"
                   style="display: none;" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"/>
            <button type="button" @click="$refs.invoiceFileInput.click()"
                    class="btn btn-default" style="margin-bottom: 10px;">
              Escolher arquivo
            </button>
            <div v-if="selectedInvoiceFile" style="margin-top: 10px;">
              <p style="margin: 0;">Arquivo selecionado: {{ selectedInvoiceFile.name }}</p>
            </div>
            <div v-if="uploadingInvoice" style="margin-top: 10px;">
              <p style="margin: 0; color: #337ab7;">Enviando arquivo...</p>
            </div>
          </div>
        </div>
        <input-text v-if="dataSendInvoice.id" col="12" type="number" placeholder="Digite aqui..."
                    label="Número da fatura:"
                    :value-default="dataSendInvoice.rpSn"
                    @contentText="value => dataSendInvoice.rpSn = value"/>
        <btn-custom label="Enviar" which-side="right" :have-loading="true"
                    :loading="loadingEditInvoice || uploadingInvoice"
                    :disabled="loadingEditInvoice || uploadingInvoice"
                    @emit-click="editInvoice"/>
      </template>
    </modal-default>

    <ModalDefault modal-title="Alterar localidade" modal-id="changeLocale">
      <input-select col="12" :options="locale" label="Localidade"
                    @selectedOption="value => companyLocale = value"/>
      <btn-custom label="Alterar" which-side="right" :have-loading="true" :loading="loadingChangeLocale"
                  :disabled="loadingChangeLocale"
                  @emit-click="changeLocale"/>
    </ModalDefault>

    <modal-default modal-title="Alterar status da fatura" modal-id="updatePaymentStatusModal"
                   @modal-closed="cleanUpdateStatusModal">
      <template>
        <div class="col-md-12" v-if="updateStatusPayment">
          <div class="form-group">
            <label>Novo status</label>
            <select v-model="updateStatusForm.paymentStatus" class="form-control">
              <option v-for="opt in paymentStatusOptions" :key="opt.value" :value="String(opt.value)">{{
                  opt.label
                }}
              </option>
            </select>
            <span v-if="updateStatusError.paymentStatus" class="error-msg">{{ updateStatusError.paymentStatus }}</span>
          </div>
          <div class="form-group">
            <label>Observações (opcional)</label>
            <input v-model="updateStatusForm.notes" type="text" class="form-control"
                   placeholder="Observações sobre a alteração"/>
          </div>
          <div v-if="updateStatusForm.paymentStatus === '1'" class="form-group">
            <div class="input-group input-with-date">
              <label>Data do pagamento</label>
              <datepicker ref="programaticOpenUpdateStatusPaidAt" v-model="updateStatusForm.paidAt" :language="ptBR"
                          :format="customFormatter"/>
              <i v-on:click="openCalendarUpdateStatusPaidAt()" class="fa fa-calendar" aria-hidden="true"></i>
            </div>
            <span v-if="updateStatusError.paidAt" class="error-msg">{{ updateStatusError.paidAt }}</span>
          </div>
        </div>
        <btn-custom label="Confirmar" which-side="right" :have-loading="true" :loading="loadingUpdatePaymentStatus"
                    :disabled="loadingUpdatePaymentStatus"
                    @emit-click="submitUpdatePaymentStatus"/>
      </template>
    </modal-default>

    <modal-default modal-title="Criar mock de dados" modal-id="createMockData">
      <datapicker-global @initDate="value => mockData.initDate = value"
                         @endDate="value => mockData.endDate = value" have-range-days-max="false"
                         range-days-init="30" variable-name="created" label="Data inicial - Data final" col="6"/>
      <input-text
        placeholder="Numero de funcionarios"
        col="6"
        @contentText="value => mockData.total = value"
        :value-default="mockData.total" type="number"
        label="Quantidade de funcionários"
      />

      <btn-custom label="Alterar" which-side="right" :have-loading="true" :loading="loadingMockData"
                  :disabled="loadingMockData"
                  @emit-click="createMockData()"/>
    </modal-default>

    <ModalDefault modal-title="Gerar Nota" modal-id="generateNoteDate">
      <div class="col-md-6 padding-null offset-bottom-20">
        <div class="input-group input-with-date">
          <label>Data de emissão *</label>
          <datepicker ref="programaticOpen3" v-model="emissionDate" :language="ptBR"
                      :format="customFormatter"/>
          <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
        </div>
      </div>
      <btn-custom label="Continuar" which-side="right"
                  :disabled="!emissionDate"
                  @emit-click="openModalPasswordGenerateNote()"/>
    </ModalDefault>
    <ModalDefault modal-title="Inativar assinatura" modal-id="inactiveSubscription">
      <input-text col="12" type="text" placeholder="Digite aqui" label="Observação: *"
                  @contentText="value => inactiveSubscriptionData.notes = value"/>
      <btn-custom label="Continuar" which-side="right" :have-loading="true" :loading="loadingInactiveSubscription"
                  :disabled="!inactiveSubscriptionData.notes.length"
                  @emit-click="inactiveSubscription()"/>
    </ModalDefault>
    <ModalDefault modal-title="Antecipação de NFs" modal-id="anticipationSubscription">
      <input-select col="6" :options="trueOrFalse" :value-selected="false" label="Informar os dias?"
                    @selectedOption="value => anticipationSubscriptionData.hasInvoiceAnticipation = value"/>
      <input-text v-if="anticipationSubscriptionData.hasInvoiceAnticipation" col="6" type="number"
                  label="Dias para antecipação:"
                  placeholder="Qtd. dias (EX: 2)"
                  @contentText="value => anticipationSubscriptionData.anticipationInDays = +value"/>
      <input-text col="12" type="text" placeholder="Digite aqui" label="Observação: *"
                  @contentText="value => anticipationSubscriptionData.notes = value"/>
      <btn-custom label="Continuar" which-side="right" :have-loading="true" :loading="loadingAnticipation"
                  :disabled="!anticipationSubscriptionData.notes.length"
                  @emit-click="anticipationSubscription()"/>
    </ModalDefault>

    <ModalDefault modal-title="Forçar Ganho" modal-id="forceSubscriptionGain">
      <div class="col-md-6 size-input select-7">
        <div class="input-group input-with-date-filter">
          <label>Data de início:</label>
          <datepicker ref="programaticOpen3" v-model="forceSubscriptionGain.initDate" :language="ptBR"
                      :format="customFormatter" :clear-button="true" class="datepicker"/>
          <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
        </div>
      </div>
      <input-select col="6" :options="planType" :value-selected="false" label="Tipo do plano:"
                    @selectedOption="value => forceSubscriptionGain.planType = value"/>
      <input-text col="12" type="text" placeholder="Digite aqui" label="Link recebido:"
                  @contentText="value => forceSubscriptionGain.receiptUri = value"/>
      <input-text col="12" type="text"
                  label="Observação:"
                  placeholder="Digite aqui"
                  @contentText="value => forceSubscriptionGain.notes = value"/>
      <btn-custom label="Enviar" which-side="right" :have-loading="true" :loading="loadingForceSubscriptionGain"
                  :disabled="!forceSubscriptionGain.notes.length || !forceSubscriptionGain.receiptUri.length"
                  @emit-click="sendForceSubscriptionGain()"/>
    </ModalDefault>

    <ModalDefault modal-title="Mudar Faturamento MAM/BOH (Empresa)" modal-id="changeBillingCompany">
      <div class="col-md-12">
        <label>Faturamento: *</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" name="billingCompany" :value="0" v-model="changeBillingCompanyData.billing"/>
            <span>MAM</span>
          </label>
          <label class="radio-label">
            <input type="radio" name="billingCompany" :value="1" v-model="changeBillingCompanyData.billing"/>
            <span>BOH</span>
          </label>
        </div>
      </div>
      <input-text col="12" type="text" placeholder="Digite aqui" label="Observação: *"
                  @contentText="value => changeBillingCompanyData.notes = value"/>
      <input-text col="12" type="password" placeholder="Digite a senha" label="Senha: *"
                  @contentText="value => changeBillingCompanyData.password = value"/>
      <btn-custom label="Confirmar" which-side="right" :have-loading="true" :loading="loadingChangeBillingCompany"
                  :disabled="!changeBillingCompanyData.notes.length || !changeBillingCompanyData.password.length"
                  @emit-click="submitChangeBillingCompany()"/>
    </ModalDefault>

    <ModalDefault modal-title="Mudar Faturamento MAM/BOH (Assinatura)" modal-id="changeBillingSubscription">
      <div class="col-md-12">
        <label>Faturamento: *</label>
        <div class="radio-group">
          <label class="radio-label">
            <input type="radio" name="billingSubscription" :value="0" v-model="changeBillingSubscriptionData.billing"/>
            <span>MAM</span>
          </label>
          <label class="radio-label">
            <input type="radio" name="billingSubscription" :value="1" v-model="changeBillingSubscriptionData.billing"/>
            <span>BOH</span>
          </label>
        </div>
      </div>
      <input-text col="12" type="text" placeholder="Digite aqui" label="Observação: *"
                  @contentText="value => changeBillingSubscriptionData.notes = value"/>
      <input-text col="12" type="password" placeholder="Digite a senha" label="Senha: *"
                  @contentText="value => changeBillingSubscriptionData.password = value"/>
      <btn-custom label="Confirmar" which-side="right" :have-loading="true" :loading="loadingChangeBillingSubscription"
                  :disabled="!changeBillingSubscriptionData.notes.length || !changeBillingSubscriptionData.password.length"
                  @emit-click="submitChangeBillingSubscription()"/>
    </ModalDefault>

    <modal-default modal-title="Adicionar créditos" modal-id="modal-add-ai-credits"
                   @modal-closed="marqIAQuantityToAdd = null">
      <div class="col-md-12">
        <p><strong>Créditos mensais atuais:</strong> {{ isUnlimitedPlan ? 'Ilimitado' : marqIACredits.monthly.total }}</p>
      </div>
      <input-text col="12" type="number" placeholder="Digite a quantidade" label="Quantidade de créditos"
                  @contentText="value => marqIAQuantityToAdd = value"/>
      <input-checkbox :is-checked="false" col="12" label="Liberar acesso ilimitado"
                      @valueCheckbox="value => marqIAUnlimited = value"/>

      <btn-custom label="Confirmar" which-side="right" :have-loading="true" :loading="loadingAddCredits"
                  :disabled="loadingAddCredits"
                  @emit-click="confirmAddCredits()"/>
    </modal-default>

    <!-- Menu -->
    <top-menu/>

    <section>
      <!-- <page-header :headerName="'Empresa'" :showBtn="false" :btnName="''" :btnRoute="''"/> -->

      <div class="page-content">
        <div class="container-fluid">
          <div class="row">
            <!-- Page loading -->
            <full-loading v-if="loading"/>

            <!-- Company info -->
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
              <div
                v-if="dataPaymentCompany.default"
                class="inadimplencia-master-banner"
                role="alert"
              >
                <span class="inadimplencia-master-banner__badge">INADIMPLENTE</span>
                <span class="inadimplencia-master-banner__text">
                  Empresa bloqueada por inadimplência — usuários podem estar sem acesso ao sistema até regularização.
                </span>
              </div>
              <div
                :class="[
                  'col-xs-12',
                  'col-sm-12',
                  'col-md-12',
                  'box-detail-company',
                  { 'box-detail-company--inadimplente': dataPaymentCompany.default },
                ]"
              >
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p class="title-initial">
                    Dados da Empresa
                    <span class="company-benefits" style="background-color: #4EB934;">
                          {{ companyLocaleName }}
                          </span>
                    <span class="company-benefits" style="background-color: #3598DC;"
                          v-if="dataPaymentCompany.moduleType === 0">
                            {{ dataPaymentCompany.moduleTypeStr }}
                          </span>
                    <span class="company-benefits" style="background-color: #265389 ;"
                          v-if="dataPaymentCompany.moduleType === 1">
                            {{ dataPaymentCompany.moduleTypeStr }}
                          </span>
                    <span class="company-benefits" style="background-color: #4EB934;"
                          v-if="dataPaymentCompany.moduleType === 2">
                            {{ dataPaymentCompany.moduleTypeStr }}
                          </span>
                    <span class="company-benefits" style="background-color: #3598DC;"
                          v-if="dataPaymentCompany.billingTarget === 0">
                            Faturamento MarQ.
                          </span>
                    <span class="company-benefits" style="background-color: #FDD944 ;"
                          v-if="dataPaymentCompany.billingTarget === 1">
                            Faturamento BOH
                          </span>
                    <span class="company-benefits" style="background-color: #4EB934;"
                          v-if="dataPaymentCompany.billingTarget === 2">
                          Faturamento MarQ.+BOH
                          </span>
                    <button class="btn-change-billing" v-on:click="openModalChangeBillingCompany()">
                      Mudar MAM/BOH
                    </button>
                  </p>
                  <div class="box-infos">
                    <div class="company-profile">
                      <btn-change @emit-click="tooltipProfileOpenned = !tooltipProfileOpenned"
                                  :label="'Perfil ' + dataPaymentCompany.companyTier">
                        <template>
                          <tooltip-default @close-tooltip="tooltipProfileOpenned = !tooltipProfileOpenned"
                                           :show-tooltip="tooltipProfileOpenned" top="40px" left="-210px"
                                           have-icon="true"
                                           title="Perfil da empresa"
                                           icon="swap-horizontal-outline">
                            <template>
                              <div class="tooltip-body">
                                <div class="body-status">
                                  <div class="content-input">
                                    <input type="radio" class="onboarding" name="A" value="A"
                                           v-bind:checked="valueCurrentProfile === 'A'"
                                           @click="valueProfile('A')"/>
                                    <input type="radio" class="B" name="B" value="B"
                                           v-bind:checked="valueCurrentProfile === 'B'"
                                           @click="valueProfile('B')"/>
                                    <input type="radio" class="middle" name="C" value="C"
                                           v-bind:checked="valueCurrentProfile === 'C'"
                                           @click="valueProfile('C')"/>
                                    <input type="radio" class="ongoing" name="D" value="D"
                                           v-bind:checked="valueCurrentProfile === 'D'"
                                           @click="valueProfile('D')"/>
                                    <input type="radio" class="ongoing" name="E" value="E"
                                           v-bind:checked="valueCurrentProfile === 'E'"
                                           @click="valueProfile('E')"/>
                                  </div>
                                  <div class="content-span">
                                    <span class="span-trial">Perfil A</span>
                                    <span class="span-onboarding">Perfil B</span>
                                    <span class="span-mid">Perfil C</span>
                                    <span class="span-ongoing">Perfil D</span>
                                    <span class="span-ongoing">Perfil E</span>
                                  </div>
                                  <span class="btn-change-plan">
                                  <btn-blue @emit-click="setNewProfile" label="Alterar" have-loading="true"
                                            :loading="loadingChangePlan"/>
                                </span>
                                </div>
                              </div>
                            </template>
                          </tooltip-default>
                        </template>
                      </btn-change>
                    </div>
                    <span v-if="dataPaymentCompany.default" class="company-defaulting">Inadimplente</span>
                    <span v-if="dataPaymentCompany.companyNewPlan"
                          class="company-plan-nota">
                    <btn-change @emit-click="tooltipOpenned = !tooltipOpenned"
                                :label="dataPaymentCompany.companyNewPlan">
                      <template>
                        <tooltip-default @close-tooltip="tooltipOpenned = !tooltipOpenned"
                                         :show-tooltip="tooltipOpenned" top="40px" left="-200px" have-icon="true"
                                         title="Nossos Planos Disponíveis"
                                         icon="swap-horizontal-outline">
                          <template>
                            <div class="tooltip-body">
                              <div class="body-status">
                                <div class="content-input">
                                  <input type="radio" class="onboarding" name="Essencial" value="Essencial"
                                         v-bind:checked="valueCurrentPlan === 'Essencial'"
                                         @click="valuePlan('Essencial')"/>
                                  <input type="radio" class="onboarding" name="Básico" value="Básico"
                                         v-bind:checked="valueCurrentPlan === 'Básico'"
                                         @click="valuePlan('Básico')"/>
                                  <input type="radio" class="middle" name="Profissional" value="Profissional"
                                         v-bind:checked="valueCurrentPlan === 'Profissional'"
                                         @click="valuePlan('Profissional')"/>
                                  <input type="radio" class="ongoing" name="Premium" value="Premium"
                                         v-bind:checked="valueCurrentPlan === 'Premium'"
                                         @click="valuePlan('Premium')"/>
                                </div>
                                <div class="content-span">
                                  <span class="span-trial">Essencial</span>
                                  <span class="span-onboarding">Básico</span>
                                  <span class="span-mid">Profissional</span>
                                  <span class="span-ongoing">Premium</span>
                                </div>
                                <span class="btn-change-plan">
                                  <btn-blue @emit-click="setNewPlan" label="Alterar" have-loading="true"
                                            :loading="loadingChangePlan"/>
                                </span>
                              </div>
                            </div>
                          </template>
                        </tooltip-default>
                      </template>
                    </btn-change>
                  </span>
                    <span v-if="dataSubscription.planTypeStr" class="company-plan-str">
                      {{ dataSubscription.planTypeStr }}
                    </span>
                  </div>
                </div>
                <div class="company-info col-xs-12 col-sm-12 col-md-12">
                  <div class="button-b">
                    <p class="show-turn">
                      <a v-bind:href="'/alterar-dados/' + companyId + '/' + context">
                        Alterar dados da empresa
                      </a>
                    </p>
                  </div>

                  <h3>
                  <span>
                    {{ dataPaymentCompany.company.name }}
                    <small v-if="dataNps.npsText" v-bind:style="{ background: dataNps.npsColor }">
                      {{ dataNps.npsText }}</small>
                    <small v-if="!dataPaymentCompany.isActive && !loading" v-bind:style="{ background: 'red' }">DESATIVADA</small>
                  </span>
                  </h3>

                  <!-- Tageamento consolidado no topo: chips + remover (×) + adicionar + gerenciar -->
                  <div class="company-tags-line">
                    <strong>Tags:</strong>
                    <company-tags-chips :company-id="$route.params.idCompany" :editable="true"/>
                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 padding-null">
                    <div>
                      <strong>Nome da empresa</strong>
                      <span>: {{ dataPaymentCompany.company.name }}
                        ({{ dataPaymentCompany.company.id }})</span>
                    </div>
                    <div>
                      <strong>Nome de contato</strong>
                      <span>: {{ dataPaymentCompany.company.contactName }}</span>
                    </div>
                    <div>
                      <strong>Email</strong>
                      <span>: {{ dataPaymentCompany.company.email }}</span>
                      <button class="btn-change-email" @click="openModalChangeUser()">
                        <span>Alterar</span>
                      </button>
                    </div>
                    <div>
                      <strong>CNPJ</strong>
                      <span>:{{ dataPaymentCompany.company.bussinessInfo.cnpj | cpfOrCnpj }}</span>
                    </div>
                    <div>
                      <strong>Razao social</strong>
                      <span>:{{ dataPaymentCompany.company.bussinessInfo.representationName }}</span>
                    </div>
                    <div>
                      <strong>Plano escolhido</strong>
                      <span>: {{ dataSubscription.companyPlanStr }} - {{ dataSubscription.planTypeStr }}</span>
                    </div>

                    <div v-if="dataPaymentCompany.totalEmployee">
                      <strong>Funcionários </strong>
                      <span>: {{ dataPaymentCompany.totalEmployee }}</span>
                    </div>

                    <!--                     v-if="dataPaymentCompany.totalPlanEmployee"-->
                    <div>
                      <strong>Total funcionario maximo </strong>
                      <span>:{{ dataSubscription.maxTotalEmployeeInContract }}</span>
                      <button class="btn-change-email" v-on:click="changeTotalEmpoyee()">
                        <span v-if="dataPaymentCompany.company.financialEmail">Alterar</span>
                        <span v-else>Adicionar</span>
                      </button>
                    </div>

                    <div>
                      <strong>Timezone</strong>
                      <span>: {{ dataPaymentCompany.timeZone }}</span>
                      <button class="btn-change-email" v-on:click="changeTimezone()">
                        <span>Alterar Fuso</span>
                      </button>
                      <button class="btn-change-email" v-on:click="openWorkshiftTimezoneBulk()">
                        <span>Aplicar em massa nos turnos</span>
                      </button>
                    </div>

                    <div>
                      <strong>Precisão do GPS</strong>
                      <span>: {{ dataPaymentCompany.gpsAcurrate }}</span>
                      <button class="btn-change-email" v-on:click="changeGps()">
                        <span>Alterar GPS</span>
                      </button>
                    </div>

                    <div>
                      <strong>Configurações ESCALA</strong>
                      <button class="btn-change-email" v-on:click="openApplyRecalcPoints()">
                        <span>Configurar</span>
                      </button>
                    </div>

                    <div>
                      <strong>Regras de horas extras (fases)</strong>
                      <button class="btn-change-email" v-on:click="goToPhaseRules()">
                        <span>Configurar</span>
                      </button>
                    </div>

                    <div>
                      <strong>Regras de horas extras da empresa (padrão)</strong>
                      <button class="btn-change-email" v-on:click="goToCompanyPhaseRules()">
                        <span>Configurar</span>
                      </button>
                    </div>

                    <div>
                      <strong>Configurações avançadas + tolerância</strong>
                      <button class="btn-change-email" v-on:click="goToWorkshiftAdvanced()">
                        <span>Configurar</span>
                      </button>
                    </div>

                    <!-- FB6: bloco "HE3 (Fase extraordinária + adicional noturno)" ocultado.
                         Configuração de HE3 segue disponível em "Regras do ponto", mas o
                         atalho dedicado nessa tela foi removido a pedido do time. -->
                    <!--
                    <div>
                      <strong>HE3 (Fase extraordinária + adicional noturno)</strong>
                      <button class="btn-change-email" v-on:click="goToHE3()">
                        <span>Configurar HE3</span>
                      </button>
                    </div>
                    -->


                    <div>
                      <strong>Importação de saldo (CSV)</strong>
                      <button class="btn-change-email" v-on:click="goToBalanceImport()">
                        <span>Abrir</span>
                      </button>
                    </div>

                    <div class="full-width">
                      <company-nuance-badges :company-id="$route.params.idCompany" :context="$route.params.context"/>
                    </div>

                    <div class="imports-grid">
                    <div class="box-import">
                      <div class="">
                        <button class="btn-import-collaborators" @click="openFileSelector('inputImportCollaborators')">
                          <span v-if="!loadingImportCollaborators">Importar colaboradores</span>
                          <span v-else class="loading-btn">
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </span>
                        </button>
                        <input class="input-import-collaborators" type="file"
                               @change="handleFileUpload"
                               id="inputImportCollaborators">
                      </div>
                      <div class="">
                        <button class="btn-example-import" @click="downloadExample()">
                          <span>Exemplo de importação</span>
                        </button>
                      </div>
                    </div>

                    <div class="box-import">
                      <div class="">
                        <button class="btn-import-collaborators" @click="openFileSelector('inputImportCollaboratorsPortugal')">
                          <span v-if="!loadingImportCollaboratorsPortugal">Importar colaboradores (Portugal)</span>
                          <span v-else class="loading-btn">
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </span>
                        </button>
                        <input class="input-import-collaborators" type="file"
                               @change="handleFileUploadPortugal"
                               id="inputImportCollaboratorsPortugal">
                      </div>
                      <div class="">
                        <button class="btn-example-import" @click="downloadExamplePortugal()">
                          <span>Exemplo de importação</span>
                        </button>
                      </div>
                    </div>

                    <div class="box-import">
                      <div class="">
                        <button class="btn-import-collaborators"
                                @click="openFileSelector('inputImportCollaboratorsDataBenefits')">
                          <span v-if="!loadingImportCollaboratorsDataBenefits">Importar dados de benefícios</span>
                          <span v-else class="loading-btn">
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </span>
                        </button>
                        <input class="input-import-collaborators" type="file"
                               @change="handleFileUploadDataBenefits"
                               id="inputImportCollaboratorsDataBenefits">
                      </div>
                      <div class="">
                        <button class="btn-example-import" @click="downloadExampleImportOnlyDataBenefits()">
                          <span>Exemplo de importação</span>
                        </button>
                      </div>
                    </div>
                    </div>
                    <!-- /.imports-grid -->

                    <div class="report-points-row">
                      <button class="btn-example-import" @click="openModalReportPoints()">
                        <span>Relatório de Registros de ponto</span>
                      </button>
                    </div>

                  </div>

                  <div class="col-xs-12 col-sm-6 col-md-6 padding-null">
                    <div>
                      <strong>CEP</strong>
                      <span>:{{ dataPaymentCompany.company.address.zipCode }}</span>
                    </div>
                    <div>
                      <strong>Endereço</strong>
                      <span v-if="dataPaymentCompany.company.address.street">:
                        {{ dataPaymentCompany.company.address.street }},
                      {{ dataPaymentCompany.company.address.number }} -
                      {{ dataPaymentCompany.company.address.neighborhood }},
                      {{ dataPaymentCompany.company.address.city }} -
                      {{ dataPaymentCompany.company.address.state }}</span>
                    </div>
                    <div>
                      <strong>Telefone</strong>
                      <span>:
                      {{ dataPaymentCompany.company.phone.phoneNumber }}</span>
                    </div>
                    <div>
                      <strong>Data de criação</strong>
                      <span>:
                      {{ dataPaymentCompany.company.createdAt | formatDate }}</span>
                    </div>
                    <div>
                      <strong>Primeiro pagamento</strong>
                      <span>:
                      {{ dataPaymentCompany.company.firstPaymentAt | formatDateDefault }}</span>
                    </div>
                    <div v-if="dataPaymentCompany.lastLoginAdmin">
                      <strong>Data do último acesso do admin</strong>
                      <span>:
                      {{ dataPaymentCompany.lastLoginAdmin | formatDate }}</span>
                    </div>
                    <div>
                      <strong>Data de vencimento</strong>
                      <span v-if="dataSubscription.recurringDayStr">: {{ dataSubscription.recurringDayStr }}</span>
                      <span v-else>: -</span>
                    </div>
                    <div>
                      <strong>Valor</strong>
                      <span v-if="dataSubscription.totalCost">: R$ {{ dataSubscription.totalCost }}</span>
                      <span v-else>: -</span>
                    </div>
                    <div>
                      <strong>Último pagamento</strong>
                      <span v-if="dataSubscription.lastBankSlipPaidDateStr">:
                        {{ dataSubscription.lastBankSlipPaidDateStr }}</span>
                      <span v-else>: -</span>
                    </div>
                    <div>
                      <strong>Observações</strong>
                      <span>: {{ dataPaymentCompany.company.notes }}</span>
                    </div>

                    <p class="show-turn">
                      <a v-bind:href="
                          '/lista-turnos/' + companyId + '/' + context
                        ">Visualizar turnos da empresa</a>
                    </p>
                    <p class="show-turn">
                      <a v-bind:href="
                          '/lista-turnos-ciclico/' + companyId + '/' + context
                        ">Visualizar turnos cíclico da empresa</a>
                    </p>
                    <p class="show-turn">
                      <a v-bind:href="
                          '/avisos-da-empresa/' + companyId + '/' + context
                        ">Enviar e Visualizar Avisos</a>
                    </p>
                    <p class="show-turn">
                      <a v-bind:href="'/historico-de-faturas/' + companyId" target="_blank">Histórico de Faturas</a>
                    </p>
                    <p class="show-turn">
                      <a v-bind:href="'/lista-de-assinaturas/' + companyId" target="_blank">Ver Assinatura</a>
                    </p>
                    <p class="show-turn">
                      <a v-on:click="goToFunil(companyId)">Visualizar Funil</a>
                    </p>
                    <p class="show-turn">
                      <a v-bind:href="'/lista-unidades-negocio/' + companyId + '/' + context" target="_blank">
                        Ver unidades de negócio</a>
                    </p>
                    <p v-if="dataPaymentCompany.isTrial === true" class="show-turn">
                      <a v-on:click="changeGiveGain()"> Dar Ganho FREE</a>
                    </p>
                    <p class="show-turn">
                      <router-link :to="'/tickets/1/' + companyId + '/' + isActive" target="_blank">Visualizar Tickets
                      </router-link>
                    </p>
                    <p class="show-turn">
                      <router-link :to="'/lista-de-espelhos-de-ponto-personalizados/' + companyId + '/' + context"
                                   target="_blank">Visualizar espelhos
                        de ponto personalizados
                      </router-link>
                    </p>
                  </div>

                  <h3>
                  <span class="spacing-line">
                    <small></small>
                  </span>
                  </h3>

                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="form-group">
                      <div v-if="showNoteses">
                        <label>
                          Dados cadastrais utilizados para fins fiscais
                        </label>
                      </div>
                    </div>

                    <div v-if="showNotes" class="title col-xs-12 col-sm-12 col-md-12">
                      <p>Dados Fiscais</p>
                    </div>

                    <div v-if="showNotes" class="company-info col-xs-12 col-sm-12 col-md-12">
                      <div class="col-xs-12 col-sm-6 col-md-6 padding-null">
                        <div>
                          <strong>CNPJ para nota fiscal</strong>
                          <span>:{{ datafinancialInfo.financialInfo.cnpj }}</span>
                        </div>
                        <div>
                          <strong>razão social para nota fiscal</strong>
                          <span>:
                          {{ datafinancialInfo.financialInfo.representationName }}</span>
                        </div>
                        <div>
                          <strong>CEP para nota fiscal</strong>
                          <span>:
                          {{ datafinancialInfo.financialInfo.zipCode }}</span>
                        </div>
                        <div>
                          <strong>Endereço para nota fiscal</strong>
                          <span>:
                          {{ datafinancialInfo.financialInfo.street }}</span>
                        </div>
                        <div>
                          <strong>Número para nota fiscal</strong>
                          <span>:
                          {{ datafinancialInfo.financialInfo.number }}</span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-6 padding-null">
                        <div>
                          <strong>Email financeiro</strong>
                          <span>:
                          {{ dataPaymentCompany.company.financialEmail }}</span>
                        </div>
                        <div>
                          <strong>Complemento para nota fiscal</strong>
                          <span>:
                          {{ datafinancialInfo.financialInfo.complement }}</span>
                        </div>
                        <div>
                          <strong>Bairro para nota fiscal</strong>
                          <span>:{{ datafinancialInfo.financialInfo.neighborhood }}</span>
                        </div>
                        <div>
                          <strong>Cidade para nota fiscal</strong>
                          <span>:{{ datafinancialInfo.financialInfo.city }}</span>
                        </div>
                        <div>
                          <strong>Estado para nota fiscal</strong>
                          <span>: {{ datafinancialInfo.financialInfo.state }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Plan and Actions -->
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-detail-company">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    Planos e Churn
                    <span v-on:click="openDataPlans()">
                    <span v-if="showPlans">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                  <div v-if="showPlans" class="company-action col-xs-12 col-sm-12 col-md-12">
                    <div class="action">
                      <div class="form-group">
                        <label for="days">Adicionar mais X dias ao vencimento da empresa</label>
                        <valid-field :v="$v.days" :b-invalid="false" :b-success="false">
                          <input v-model="days" @blur="$v.days.$touch()" minlength="1" maxlength="2" type="text"
                                 class="form-control" id="days" name="days" required/>
                        </valid-field>
                      </div>
                      <button :disabled="loadingDays" v-bind:class="{ disable: loadingDays }" v-on:click="addDays()"
                              class="btn-with-input">
                        <span v-if="!loadingDays">Enviar</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div v-if="showPlans" class="
                      company-action
                      col-xs-12 col-sm-12 col-md-12
                      offset-top-20
                    ">
                    <div class="action">
                      <button v-on:click="clientOnboarding()">
                        <span v-if="!loadingClientOnboarding">Cliente fez onboarding</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div v-if="showPlans" class="company-action col-xs-12 col-sm-12 col-md-12">
                    <div class="content-obs">
                      <div class="content-churn">
                        <button v-on:click="validationModal()" data-backdrop="false">
                          Churn
                        </button>
                        <a v-if="isDebug" v-bind:href="
                            'http://marqponto-site-stag.azurewebsites.net/cancelamento#' +
                            context +
                            '&' +
                            companyId
                          " class="link" target="_blank">Link de cancelamento para o cliente</a>
                        <a v-if="!isDebug" v-bind:href="
                            'http://marqponto.com.br/cancelamento#' +
                            context +
                            '&' +
                            companyId
                          " class="link" target="_blank">Link de cancelamento para o cliente</a>
                      </div>
                      <div class="content-inadimplente">
                        <button v-on:click="openInadimplente()">
                          <span v-if="dataPaymentCompany.default">Remover inadimplência</span>
                          <span v-else>Tornar inadimplente</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--modal validation password-->
            <div class="modal fade" id="password-modal-churn" role="dialog">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">
                      &times;
                    </button>
                    <h4 class="title-modal">Confirmação de Permissão</h4>
                  </div>
                  <div class="modal-body text-center">
                    <div class="form-group">
                      <h4>Digite a senha para ter acesso</h4>
                    </div>
                    <input type="password" id="input-password" class="form-control" onfocus="this.value=''"
                           v-model="modalPassword" autocomplete="off" placeholder="Password"/>
                    <button class="btn btn-register" @click="passwordValidation()" data-dismiss="modal"
                            data-backdrop="false">
                      Confirmar
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-detail-company">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    Configuração do Backoffice
                    <span v-on:click="openDataBackoffice()">
                    <span v-if="showBackoffice">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>

                <div v-if="showBackoffice" class="company-action col-xs-12 col-sm-12 col-md-12">
                  <div class="col-xs-12 col-sm-3 col-md-3">
                    <div class="action">
                      <div class="checkbox checkbox-plans">
                        <input v-model="
                            dataPaymentCompany.company.isBlockedMarqboard
                          " id="registerTerms" type="checkbox"/>
                        <label v-on:click="
                            dataPaymentCompany.company.isBlockedMarqboard =
                              !dataPaymentCompany.company.isBlockedMarqboard
                          " class="minh">
                          MarQBoard bloqueada?
                        </label>
                      </div>

                      <button :disabled="loadingBloq" v-bind:class="{
                          disable: loadingBloq,
                          'btn-warning': isBlock,
                          'btn-danger': !isBlock,
                        }" v-on:click="changeBlock()">
                      <span v-if="!loadingBloq">
                        <span v-if="isBlock">Desbloquear</span>
                        <span v-else>Bloquear</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3">
                    <div class="action">
                      <p class="minh">Envio de upload de escala habilitado</p>
                      <button :disabled="loadingScale" v-bind:class="{
                          disable: loadingScale,
                          'btn-warning': isWorkshiftImportEnabled,
                        }" v-on:click="changeUploadScale()">
                      <span v-if="!loadingScale">
                        <span v-if="isWorkshiftImportEnabled">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3">
                    <div class="action">
                      <p class="minh">
                        Envio de upload de funcionários habilitado
                      </p>
                      <button :disabled="loadingEmp" v-bind:class="{
                          disable: loadingEmp,
                          'btn-warning': isUserImportEnabled,
                        }" v-on:click="changeUploadEmployer()">
                      <span v-if="!loadingEmp">
                        <span v-if="isUserImportEnabled">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3">
                    <div class="action">
                      <p class="minh">Saldo de Horas</p>
                      <button :disabled="loadingBalance" v-bind:class="{
                          disable: loadingBalance,
                          'btn-warning': isBalanceEnabled,
                        }" v-on:click="changeBalanceEnabled()">
                      <span v-if="!loadingBalance">
                        <span v-if="isBalanceEnabled">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-3 col-md-3 offset-top-20">
                    <div class="action">
                      <p class="minh">Precisa de foto no MarQTab?</p>
                      <button :disabled="loadingPhotoTab" v-bind:class="{
                          disable: loadingPhotoTab,
                          'btn-warning': needPhotoToMarQTab,
                        }" v-on:click="changeNeedPhotoToMarQTab()">
                      <span v-if="!loadingPhotoTab">
                        <span v-if="needPhotoToMarQTab">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3 offset-top-20">
                    <div class="action">
                      <p class="minh">Precisa de Localização no MarQTab?</p>
                      <button :disabled="loadingLocationTab" v-bind:class="{
                          disable: loadingLocationTab,
                          'btn-warning': needLocationToMarQTab,
                        }" v-on:click="changeNeedLocationToMarQTab()">
                      <span v-if="!loadingLocationTab">
                        <span v-if="needLocationToMarQTab">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3 offset-top-20">
                    <div class="action">
                      <p class="minh">Calendário está ativado?</p>
                      <button :disabled="loadingCalendar" v-bind:class="{
                          disable: loadingCalendar,
                          'btn-warning': isCalendarEnabled,
                        }" v-on:click="changeIsCalendarEnabled()">
                      <span v-if="!loadingCalendar">
                        <span v-if="isCalendarEnabled">Desabilitar</span>
                        <span v-else>Habilitar</span>
                      </span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-3 col-md-3 offset-top-20">
                    <div class="action">
                      <p class="minh">Alterar localidade</p>
                      <button v-on:click="openModalChangeLocale()">
                      <span>
                        <span>Alterar</span>
                      </span>
                      </button>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-3 col-md-3 offset-top-20">
                    <div class="action">
                      <p class="minh">Mock de dados</p>
                      <button v-on:click="openModalMockData()">
                      <span>
                        <span>Habilitar</span>
                      </span>
                      </button>
                    </div>
                  </div>

                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null"></div>
                </div>
                <div v-if="showBackoffice" class="
                    company-action
                    col-xs-12 col-sm-12 col-md-12
                    offset-top-30
                  ">
                  <p v-if="isUsingFaceRecognition" class="face-active">
                    Empresa com reconhecimento facial ativo
                  </p>
                </div>
              </div>
            </div>

            <!-- modal IUGU -->
            <div class="modal fade" id="iugu-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="create-outline"></ion-icon>
                        <h4 class="title-modal">Alterar vínculo cliente IUGU</h4>
                      </div>
                      <div class="subtitle">
                        <span>Altere o identificador do usuário no Iugu</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <input type="text" id="input-text" v-model="modalInputIugu" autocomplete="off"
                               placeholder="Novo ID"/>
                        <button class="btn-validate" @click="changeIdIugu()" data-dismiss="modal"
                                data-backdrop="false">
                          <span v-if="!loadingChangeIugu">Confirmar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal IUGU SUBS -->
            <div class="modal fade" id="iugu-sub-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="create-outline"></ion-icon>
                        <h4 class="title-modal">Alterar assinatura IUGU</h4>
                      </div>
                      <div class="subtitle">
                        <span>Altere a assinatura no Iugu</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <input type="text" id="input-text" v-model="modalInputIuguSub" autocomplete="off"
                               placeholder="Nova assinatura"/>
                        <button class="btn-validate" @click="changeIdIuguSub()" data-dismiss="modal"
                                data-backdrop="false">
                          <span v-if="!loadingChangeIuguSub">Confirmar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal ASAAS CUSTOMER -->
            <div class="modal fade" id="asaas-customer-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="create-outline"></ion-icon>
                        <h4 class="title-modal">Alterar vínculo cliente Asaas</h4>
                      </div>
                      <div class="subtitle">
                        <span>Altere o identificador do cliente no Asaas</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <input type="text" id="input-text" v-model="modalInputAsaasCustomer" autocomplete="off"
                               placeholder="Novo ID"/>
                        <button class="btn-validate" @click="changeAsaasCustomerId()" data-dismiss="modal"
                                data-backdrop="false">
                          <span v-if="!loadingChangeAsaasCustomer">Confirmar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal ASAAS SUBSCRIPTION -->
            <div class="modal fade" id="asaas-subscription-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="create-outline"></ion-icon>
                        <h4 class="title-modal">Alterar assinatura Asaas</h4>
                      </div>
                      <div class="subtitle">
                        <span>Altere a assinatura no Asaas</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <input type="text" id="input-text" v-model="modalInputAsaasSubscription" autocomplete="off"
                               placeholder="Nova assinatura"/>
                        <button class="btn-validate" @click="changeAsaasSubscriptionId()" data-dismiss="modal"
                                data-backdrop="false">
                          <span v-if="!loadingChangeAsaasSubscription">Confirmar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal BUSINESS UNIT -->
            <div class="modal fade" id="business-unit-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="create-outline"></ion-icon>
                        <h4 class="title-modal">Alterar unidade de negócio</h4>
                      </div>
                      <div class="subtitle">
                        <span>Altere a unidade de negócio da assinatura</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <select v-model="newBusinessUnit">
                          <option value="">Selecione</option>
                          <option v-for="(value, index) in unit" :key="index" :value="value.id">
                            {{ value.name }}
                          </option>
                        </select>
                        <button class="btn-validate" @click="changeSubscriptionBusinessUnit()" data-dismiss="modal"
                                data-backdrop="false">
                          <span v-if="!loadingChangeUnit">Confirmar</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal DELETE PAYMENT PASSWORD -->
            <div class="modal fade" id="delete-payment-password-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="trash-outline"></ion-icon>
                        <h4 class="title-modal">Confirmar Exclusão</h4>
                      </div>
                      <div class="subtitle">
                        <span>Digite a senha para continuar</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <input type="password" id="input-password-delete" v-model="deletePaymentPassword"
                               autocomplete="off"
                               placeholder="Digite a senha"/>
                        <span v-if="deletePaymentPasswordError"
                              style="color: #dc3545; font-size: 12px; display: block; margin-top: 5px;">{{
                            deletePaymentPasswordError
                          }}</span>
                        <button class="btn-validate" @click="validateDeletePaymentPassword()" data-dismiss="modal"
                                data-backdrop="false">
                          Confirmar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- modal DELETE PAYMENT NOTES -->
            <div class="modal fade" id="delete-payment-notes-modal" role="dialog">
              <div class="modal-dialog">
                <div class="modal-dialog">
                  <div class="modal-content content">
                    <div class="modal-header">
                      <a type="button" class="close-btn-password" data-dismiss="modal">
                        <ion-icon name="close"></ion-icon>
                      </a>
                      <div class="title-group">
                        <ion-icon name="trash-outline"></ion-icon>
                        <h4 class="title-modal">Confirmar Exclusão</h4>
                      </div>
                      <div class="subtitle">
                        <span>Descreva o motivo da exclusão</span>
                      </div>
                    </div>
                    <div class="modal-body">
                      <div class="password-validate">
                        <textarea v-model="deletePaymentNotes" placeholder="Descreva o motivo da exclusão..."
                                  style="width: 100%; padding: 8px; border: 1px solid #ddd; border-radius: 4px; min-height: 80px; resize: vertical; margin-bottom: 10px;"
                                  :class="{ 'error-border': deletePaymentNotesError }"></textarea>
                        <span v-if="deletePaymentNotesError"
                              style="color: #dc3545; font-size: 12px; display: block; margin-bottom: 10px;">{{
                            deletePaymentNotesError
                          }}</span>
                        <button class="btn-validate" @click="confirmDeletePayment()"
                                :disabled="loadingDeletePayment">
                          <span v-if="!loadingDeletePayment">Confirmar Exclusão</span>
                          <div class="loading-btn" v-else>
                            <div class="spinner-btn">
                              <div class="rect1"></div>
                              <div class="rect2"></div>
                              <div class="rect3"></div>
                              <div class="rect4"></div>
                              <div class="rect5"></div>
                            </div>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!--nps-->
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-nps" v-bind:class="{
                  'border-npsAverange-red': dataNps.npsAverange <= 4,
                  'border-npsAverange-orange':
                    dataNps.npsAverange >= 5 && dataNps.npsAverange <= 8,
                  'border-npsAverange-green': dataNps.npsAverange > 8,
                }">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    NPS
                    <span v-on:click="openDataNps()">
                    <span v-if="showNps">FECHAR</span>
                    <span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>
                <div v-if="showNps && !loadingNps" class="col-xs12 col-sm-12 col-md-5 info-nps">
                  <p>
                    Total de dias cadastrado:
                    <span>{{ dataNps.daysRegistered.toFixed(2) }}</span>
                  </p>
                  <p>
                    Total NPS respondido :
                    <span>{{ dataNps.totalNpsAnswered }}</span>
                  </p>
                  <p>
                    Média NPS : <span>{{ dataNps.npsAverange }}</span>
                  </p>
                </div>

                <div v-if="showNps && !loadingNps" class="col-xs12 col-sm-12 col-md-7 detail-nps">
                  <div v-for="nps in dataNps.nps" class="content">
                    <p>Nota: {{ nps.rating }}</p>
                    <p>Estagio: {{ nps.stage }}</p>
                    <p>Data: {{ nps.createdAt }}</p>
                    <p>Observação: {{ nps.message }}</p>
                  </div>
                </div>

                <div v-if="showNps && !loadingNps" class="col-xs-12 col-sm-3 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 month-nps">
                    <p>Mês 1: {{ dataNps.month1.month }}</p>
                    <p>
                      Total de pontos registrado:
                      {{ dataNps.month1.totalPoint }}
                    </p>
                    <p>Total de faltas: {{ dataNps.month1.totalFaults }}</p>
                    <p>
                      Total de ocorrência: {{ dataNps.month1.totalOcurrences }}
                    </p>
                  </div>
                </div>

                <div v-if="showNps && !loadingNps" class="col-xs-12 col-sm-3 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 month-nps">
                    <p>Mês 2: {{ dataNps.month2.month }}</p>
                    <p>
                      Total de pontos registrado:
                      {{ dataNps.month2.totalPoint }}
                    </p>
                    <p>Total de faltas: {{ dataNps.month2.totalFaults }}</p>
                    <p>
                      Total de ocorrência: {{ dataNps.month2.totalOcurrences }}
                    </p>
                  </div>
                </div>

                <div v-if="showNps && !loadingNps" class="col-xs-12 col-sm-3 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 month-nps">
                    <p>Mês 3: {{ dataNps.month3.month }}</p>
                    <p>
                      Total de pontos registrado:
                      {{ dataNps.month3.totalPoint }}
                    </p>
                    <p>Total de faltas: {{ dataNps.month3.totalFaults }}</p>
                    <p>
                      Total de ocorrência: {{ dataNps.month3.totalOcurrences }}
                    </p>
                  </div>
                </div>

                <div v-if="showNps && !loadingNps && dataNps.month4" class="col-xs-12 col-sm-3 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 month-nps">
                    <p>Mês 4: {{ dataNps.month4.month }}</p>
                    <p>
                      Total de pontos registrado:
                      {{ dataNps.month4.totalPoint }}
                    </p>
                    <p>Total de faltas: {{ dataNps.month4.totalFaults }}</p>
                    <p>
                      Total de ocorrência: {{ dataNps.month4.totalOcurrences }}
                    </p>
                  </div>
                </div>

                <div v-if="showNps && !loadingNps && dataNps.month5" class="col-xs-12 col-sm-3 col-md-4">
                  <div class="col-xs-12 col-sm-12 col-md-12 month-nps">
                    <p>Mês 5: {{ dataNps.month5.month }}</p>
                    <p>
                      Total de pontos registrado:
                      {{ dataNps.month5.totalPoint }}
                    </p>
                    <p>Total de faltas: {{ dataNps.month5.totalFaults }}</p>
                    <p>
                      Total de ocorrência: {{ dataNps.month5.totalOcurrences }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--beneficios-->
          <div class="row">
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-features">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    BENEFÍCIOS
                    <span v-on:click="openDataBenefits()">
                    <span v-if="showBenefits">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>
                <div v-if="showBenefits" class="col-xs-12 col-sm-12 col-md-12 btn-benefits"
                     style="display: flex; gap: 16px; flex-wrap: wrap;">
                  <button :disabled="loadingBenefits" v-bind:class="{
                      disable: loadingBenefits,
                      'btn-warning': isBenefitsWarning,
                    }" v-on:click="openValidateBenefitsModal()">
                    <span v-if="!loadingBenefits">Habilitar/Desativar benefícios</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                  <button :disabled="loadingPixOut" v-bind:class="{
                      disable: loadingPixOut,
                    }" v-on:click="openValidatePixOutModal()">
                    <span v-if="!loadingPixOut">Habilitar/Desativar Pix-Out</span>
                    <div class="loading-btn" v-else>
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="password-modal-benefits" role="dialog">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal">
                    &times;
                  </button>
                  <h4 class="title-modal">Confirmação de Permissão</h4>
                </div>
                <div class="modal-body text-center">
                  <div class="form-group">
                    <h4>Digite a senha para habilitar o benefícios</h4>
                  </div>
                  <input type="password" id="input-password-benefits" class="form-control" onfocus="this.value=''"
                         v-model="modalPasswordBenefits" autocomplete="off" placeholder="Password"/>
                  <button class="btn btn-register" @click="passwordValidationBenefits()" data-dismiss="modal"
                          data-backdrop="false">
                    Confirmar
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!--historico-->
          <div class="row">
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-features">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    Histórico de colaboradores
                    <span v-on:click="openDataHistory()">
                    <span v-if="showHistory">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>

                <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 filters padding-null">
                  <div v-if="showHistory" class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <h4>Filtrar</h4>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 padding-null">
                      <div class="input-group input-with-date">
                        <label>Data Inicial</label>
                        <datepicker ref="programaticOpen3" v-model="params1.init" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data Final</label>
                        <datepicker ref="programaticOpen4" v-model="params1.end" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo de movimentação</label>
                        <select v-model="params1.logCompanyEmployeeCountType">
                          <option value="0">Todas</option>
                          <option value="1">Pelo backoffice</option>
                          <option value="2">Por importação</option>
                          <option value="3">Importação youtility</option>
                          <option value="4">Demissão</option>
                          <option value="5">Readmissão</option>
                        </select>
                      </div>
                    </div>
                    <div v-if="!loading && showHistory" class="botton-a col-xs-12 col-sm-6 col-md-3 padding-null">
                      <button v-on:click="getHistory()" type="button">
                        <span v-if="!loadingList">Pesquisar</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>

                  <!-- No Result -->
                  <div v-if="
                      !loading &&
                      showHistory &&
                      dataPoint !== '' &&
                      !dataPoint.length &&
                      !failRequest
                    " class="col-xs-12 col-sm-12 col-md-12">
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        default-box
                        content-default
                      ">
                      <p>Sem resultado na pesquisa.</p>
                    </div>
                  </div>

                  <!-- Fail Request -->
                  <div v-if="!loading && failRequest" class="col-xs-12 col-sm-12 col-md-12">
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        default-box
                        content-default
                      ">
                      <p>Falha na requisição.</p>
                    </div>
                  </div>
                </div>
                <!--tabela-->
                <div v-if="!loading && showHistory && dataPoint.length"
                     class="portlet-body contate-table offset-top-40">
                  <div class="
                      table-scrollable table-scrollable-borderless
                      offset-top-40
                    ">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th>Data</th>
                        <th></th>
                        <th>Movimentação</th>
                        <th>Responsável</th>
                        <th>Funcionários cadastrados</th>
                        <th>Máx de Funcionários</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataPoint">
                        <td>{{ c.date }}</td>
                        <td>
                          <span class="bg-error" v-bind:class="{
                                'bg-warning':
                                  c.logCompanyEmployeeCountType != '1',
                                'bg-default':
                                  c.logCompanyEmployeeCountType == '4',
                                'bg-green':
                                  c.logCompanyEmployeeCountType == '5',
                              }"></span>
                        </td>
                        <td>{{ c.text }}</td>
                        <td>{{ c.whoCreated }}</td>
                        <td>{{ c.employeeRegistered }}</td>
                        <td>{{ c.employeeInContract }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--historico de alteração-->
          <div class="row">
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-features">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    Histórico de alterações do plano
                    <span v-on:click="openHistory()">
                    <span v-if="showHistoryPlan">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>

                <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 filters padding-null">
                  <div v-if="showHistoryPlan" class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <h4>Filtrar</h4>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3 padding-null">
                      <div class="input-group input-with-date">
                        <label>Data Inicial</label>
                        <datepicker ref="programaticOpen3" v-model="params2.init" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data Final</label>
                        <datepicker ref="programaticOpen4" v-model="params2.end" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo de alteração</label>
                        <select v-model="params2.filter">
                          <option value="100">Todos</option>
                          <option value="0">Funcionalidade adicionada</option>
                          <option value="1">Funcionalidade Removida</option>
                          <option value="2">
                            Funcionalidade adicionada para teste
                          </option>
                          <option value="3">Funcionalidade acabou trial</option>
                          <option value="4">Funcionário adicionado</option>
                          <option value="5">Funcionário removido</option>
                          <option value="6">Assinatura adicionada</option>
                          <option value="7">Assinatura renovada</option>
                          <option value="8">Assinatura cancelada</option>
                          <option value="9">
                            Assinatura atualizada por carência
                          </option>
                        </select>
                      </div>
                    </div>
                    <div v-if="!loading && showHistoryPlan" class="botton-a col-xs-12 col-sm-6 col-md-3 padding-null">
                      <button v-on:click="getHistoryPlan()" type="button">
                        <span v-if="!loadingPlan">Pesquisar</span>
                        <div class="loading-btn" v-else>
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                      </button>
                    </div>
                  </div>
                  <!-- No Result -->
                  <div v-if="
                      !loadingPlan &&
                      showHistoryPlan &&
                      dataPlan !== '' &&
                      !dataPlan.length &&
                      !failRequest
                    " class="col-xs-12 col-sm-12 col-md-12">
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        default-box
                        content-default
                      ">
                      <p>Sem resultado na pesquisa.</p>
                    </div>
                  </div>

                  <!-- Fail Request -->
                  <div v-if="!loadingPlan && failRequest && showHistoryPlan" class="col-xs-12 col-sm-12 col-md-12">
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        default-box
                        content-default
                      ">
                      <p>Falha na requisição.</p>
                    </div>
                  </div>
                </div>
                <!--tabela-->
                <div v-if="!loadingPlan && showHistoryPlan && dataPlan.length"
                     class="portlet-body contate-table offset-top-40">
                  <div class="
                      table-scrollable table-scrollable-borderless
                      offset-top-40
                    ">
                    <table class="table table-hover table-light table-icon">
                      <thead>
                      <tr>
                        <th></th>
                        <th>Movimentação</th>
                        <th>Responsável</th>
                        <th>Data</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="c in dataPlan">
                        <td>
                          <span class="bg-error" v-bind:class="{
                                'bg-green':
                                  c.paymentHistoryType ===
                                  'Funcionalidade adicionada',
                                'bg-default':
                                  c.paymentHistoryType ==
                                  'Funcionalidade removida',
                                'bg-default':
                                  c.paymentHistoryType ==
                                  'Funcionário demitido',
                                'bg-error-a':
                                  c.paymentHistoryType ==
                                  'Funcionalidade removida',
                              }"></span>
                        </td>
                        <td>{{ c.text }}</td>
                        <td>{{ c.whoCreatedName }}</td>
                        <td>{{ c.createdAt | formatDate }}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--marq ia-->
          <div class="row">
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-features">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    MARQ IA
                    <span v-on:click="openDataMarqIA()">
                      <span v-if="showMarqIA">FECHAR</span><span v-else>VISUALIZAR</span>
                    </span>
                  </p>
                </div>
                <div v-if="showMarqIA" class="col-xs-12 col-sm-12 col-md-12">
                  <div v-if="loadingMarqIA" class="text-center" style="padding: 16px;">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="marqia-plan-header">
                      <span class="marqia-plan-badge">
                        {{ marqIACredits.plan ? marqIACredits.plan.name : '—' }}
                      </span>
                    </div>

                    <div class="box-cards-ia">
                      <div class="card-credits-ia">
                        <p class="card-title">Créditos mensais</p>
                        <div class="card-stats">
                          <div>
                            <span>{{ isUnlimitedPlan ? 'Ilimitado' : Math.max(marqIACredits.monthly.total - marqIACredits.monthly.used, 0) }}</span>
                            <p>Disponíveis</p>
                          </div>
                          <div>
                            <span>{{ marqIACredits.monthly.used }}</span>
                            <p>Utilizados</p>
                          </div>
                        </div>
                      </div>

                      <div class="card-credits-ia">
                        <p class="card-title">Créditos avulsos</p>
                        <div class="card-stats">
                          <div>
                            <span>{{ marqIACredits.additional.total }}</span>
                            <p>Total</p>
                          </div>
                          <div>
                            <span>{{ marqIACredits.additional.used }}</span>
                            <p>Utilizados</p>
                          </div>
                        </div>
                      </div>

                      <div class="card-credits-ia">
                        <p class="card-title">Créditos totais</p>
                        <div class="card-stats">
                          <div>
                            <span>{{ isUnlimitedPlan ? 'Ilimitado' : marqIACredits.overall.total }}</span>
                            <p>Total</p>
                          </div>
                          <div>
                            <span>{{ marqIACredits.overall.used }}</span>
                            <p>Utilizados</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="marqIACredits.byFeature && marqIACredits.byFeature.length" class="marqia-features">
                      <p class="marqia-features-title">Uso por funcionalidade</p>
                      <div v-for="(feature, idx) in marqIACredits.byFeature" :key="idx" class="feature-row">
                        <span class="feature-label">{{ feature.label }}</span>
                        <div class="feature-bar">
                          <div class="feature-bar-fill" :style="{ width: feature.percentage + '%' }"></div>
                        </div>
                        <span class="feature-used">{{ feature.used }}</span>
                        <span class="feature-pct">{{ feature.percentage }}%</span>
                      </div>
                    </div>

                    <p class="marqia-obs">
                      <strong>Obs:</strong> Pelo master só é possível atualizar a quantidade de créditos do plano recorrente da empresa. Para créditos avulsos, o fluxo é pelo self-checkout via BackOffice.
                    </p>

                    <div class="btn-benefits">
                      <button v-on:click="openAddCreditsModal()">Atualizar créditos mensais</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12">
              <div class="col-xs-12 col-sm-12 col-md-12 box-features">
                <div class="title col-xs-12 col-sm-12 col-md-12">
                  <p>
                    FUNCIONALIDADES
                    <span v-on:click="openDataFeatures()">
                    <span v-if="showFeatures">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>
                <div v-if="showFeatures" class="col-xs-12 col-sm-12 col-md-12">
                  <full-loading v-if="loadingFeatures || loadingFeaturesActived" style="box-shadow: unset"/>

                  <div v-if="!loadingFeatures && !loadingFeaturesActived"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null plans">
                    <div class="col-md-12 feature-type-plans">
                      <span>Plano: </span>
                      {{ dataPaymentCompany.companyNewPlan }}
                    </div>
                    <div v-if="moduleJourneyControl" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Controle de Jornada</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in moduleJourneyControl">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{
                                feature.name
                              }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="modulePersonalDepartment" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Departamento Pessoal</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in modulePersonalDepartment">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{ feature.name }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="modulePeopleDevelopment" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Desenvolvimento de Pessoas</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in modulePeopleDevelopment">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{ feature.name }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="moduleCommunicationAndCulture" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Comunicação e Cultura</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in moduleCommunicationAndCulture">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{ feature.name }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="moduleCorporateBenefits" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Benefícios Corporativos</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in moduleCorporateBenefits">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{ feature.name }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="moduleExtra" class="col-md-12 first-col features-plans">
                      <div class="plans-header">
                        <div class="plans-title">Extras</div>
                      </div>
                      <div class="modules">
                        <div v-for="feature in moduleExtra">
                          <div class="new-checkbox">
                            <div v-if="feature.tooltip && feature.tooltip.length" class="tooltip-feature">
                              {{ feature.tooltip }}
                            </div>
                            <div class="switch-plans" v-on:click="checkAddOrRemoveFeature(feature)">
                              <input id="admissionDate" type="checkbox" v-model="feature.enabled"
                                     @click="feature.enabled = !feature.enabled" disabled>
                              <label for="switch-p"></label>
                            </div>
                            <label class="checkbox-label">{{ feature.name }}</label>
                            <ion-icon v-if="feature.tooltip && feature.tooltip.length"
                                      name="information-circle-outline"></ion-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12">
              <!-- Assinaturas -->
              <div v-if="subscriptions.length && !loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-10
                  list-subscriptions
                ">
                <div class="portlet-body">
                  <div class="mt-element-list">
                    <div class="portlet-body">
                      <div class="mt-element-list">
                        <div class="mt-list-head list-default border-payment">
                          <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12">
                              <div class="list-head-title-container">
                                <h3 class="list-title uppercase sbold">
                                  Assinaturas
                                  <span v-on:click="
                                      showSubscriptions = !showSubscriptions
                                    ">
                                  <span v-if="showSubscriptions">FECHAR</span>
                                  <span v-else>VISUALIZAR</span>
                                </span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div v-if="showSubscriptions" class="mt-list-container list-default">
                          <div v-for="(c, index) in subscriptions">
                            <div class="tab">
                              <input v-bind:id="'tab2' + index" type="checkbox" name="tabs"/>
                              <label v-bind:for="'tab2' + index">
                                {{ c.init }} - R${{ c.totalCost }}
                                <span v-bind:class="{
                                    'status-active': c.status === 1,
                                    'status-default': c.status !== 1,
                                  }">{{ c.statusStr }}</span>
                                <span v-if="c.businessUnitCNPJ" class="styleCompany">
                                CNPJ
                                {{ c.businessUnitCNPJ | cpfOrCnpj }}&nbsp; -
                                &nbsp;{{ c.businessUnitName }}
                                </span>
                                <span v-if="c.billingTarget === 0" style="background-color: #3598DC;"
                                      class="billing-tag ">
                                  MarQ.
                                </span>
                                <span v-if="c.billingTarget === 1" style="background-color: #FDD944"
                                      class="billing-tag ">
                                  BOH
                                </span>
                                <span v-if="c.billingTarget === 2" style="background-color: #4EB934"
                                      class="billing-tag ">
                                  MarQ.+BOH
                                </span>
                              </label>
                              <div class="tab-content">
                                <div class="subscription-actions">
                                  <button v-on:click="openModalPasswordAnticipation(c.id)">Antecipação de NFs
                                  </button>
                                  <button v-on:click="openModalPasswordInactiveSubscription(c.id)">Inativar
                                    assinatura
                                  </button>
                                  <button v-on:click="syncSubscription(c)">
                                    <span v-if="!loadingSyncSubscription">Forçar sincronização boletos IUGU</span>
                                    <div class="loading-btn" v-else>
                                      <div class="spinner-btn">
                                        <div class="rect1"></div>
                                        <div class="rect2"></div>
                                        <div class="rect3"></div>
                                        <div class="rect4"></div>
                                        <div class="rect5"></div>
                                      </div>
                                    </div>
                                  </button>
                                  <button v-on:click="syncSubscriptionAsaas(c)">
                                    <span v-if="!loadingSyncSubscriptionAsaas">Forçar sincronização boletos ASAAS</span>
                                    <div class="loading-btn" v-else>
                                      <div class="spinner-btn">
                                        <div class="rect1"></div>
                                        <div class="rect2"></div>
                                        <div class="rect3"></div>
                                        <div class="rect4"></div>
                                        <div class="rect5"></div>
                                      </div>
                                    </div>
                                  </button>
                                  <button v-if="c.status === 0"
                                          v-on:click="openModalForceGain(c.id)">FORÇAR GANHO
                                  </button>
                                  <button v-on:click="openModalChangeBillingSubscription(c)">Mudar MAM/BOH
                                  </button>
                                </div>
                                <div class="info">
                                  <div>
                                    <p>
                                      ID: <span>{{ c.id }}</span>
                                    </p>
                                    <p>
                                      Vendido por: <span>{{ c.soldBy }}</span>
                                    </p>
                                    <p>
                                      Inicio do contrato:
                                      <span>{{ c.init }}</span>
                                    </p>
                                    <p>
                                      Contrato valido até:
                                      <span>{{ c.contractValidUntil }}</span>
                                    </p>
                                    <p>
                                      Data da recorrencia:
                                      <span>{{ c.recurringDayToCharge }}</span>
                                    </p>
                                    <p>
                                      Preço por funcionario excedente:
                                      <span>{{ c.pricePerEmployee }}</span>
                                    </p>
                                    <p>
                                      Situação: <span>{{ c.status }}</span>
                                    </p>
                                    <p>
                                      Último boleto pago:
                                      <span>{{ c.lastBankSlipPaidDate }}</span>
                                    </p>
                                    <p>
                                      Último boleto gerado:
                                      <span>{{ c.lastBankSlipGeneratedDate }}</span>
                                    </p>
                                    <p>
                                      Data do vencimento do último boleto
                                      gerado:
                                      <span>{{ c.lastBankSlipExpireDate }}</span>
                                    </p>
                                    <p>
                                      Tipo do plano:
                                      <span>{{ c.planType }}</span>
                                    </p>
                                    <p>
                                      Pacote vendido:
                                      <span>{{ c.subscriptionCategory }}</span>
                                    </p>
                                    <p>
                                      Valor do 1º pagamento:
                                      <span>{{ c.firstPaymentPrice }}</span>
                                    </p>
                                    <p>
                                      Valor da recorrencia:
                                      <span>{{ c.totalCost }}</span>
                                    </p>
                                    <p>
                                      Gerando notas?:
                                      <span v-if="c.generateInvoice">Sim</span><span v-else>Não</span>
                                    </p>
                                    <p>
                                      Colaboradores no contrato:
                                      <span>{{ c.maxTotalEmployeeInContract }}</span>
                                    </p>
                                    <p>
                                      Colaboradores no contrato inícial:
                                      <span>{{ c.totalEmployeeFirstPayment }}</span>
                                    </p>
                                    <p>
                                      Tipo do pagamento:
                                      <span>{{ c.paymentMethod }}</span>
                                    </p>
                                    <p>
                                      Quantidade de vezes inadimplente:
                                      <span>{{ c.defaultQuantity }}</span>
                                    </p>
                                    <p>
                                      Notas interno:
                                      <span v-if="c.notes">{{ c.notes }}</span><span v-else>-</span>
                                    </p>
                                    <p>
                                      Gerado em: <span>{{ c.createdAt }}</span>
                                    </p>
                                    <p>
                                      Possui antecipação de NFs: <span>{{
                                        c.hasInvoiceAnticipation ? 'Sim' : 'Não'
                                      }}</span>
                                    </p>
                                    <p>
                                      Dias para antecipação: <span>{{
                                        c.antecipationInDays
                                      }}</span>
                                    </p>
                                    <div class="col-md-12 iugu-group">
                                      <div class="col-md-4 iugu-subscription">
                                        Asaas SubscriptionId{{ !c.asaasSubscriptionId ? ' (Sem vínculo)' : '' }}:
                                        <span class="iugu-group-content">
                                          <a v-if="c.asaasSubscriptionId"
                                             v-bind:href="'https://www.asaas.com/subscription/show/' + c.asaasSubscriptionId"
                                             target="_blank">Link</a>
                                          <span v-else style="color: #999;">-</span>
                                          <button v-on:click="changeAsaasIdSub(c.id)" class="btn-iugu">
                                            <span v-if="!loadingChangeAsaasSubscription">Alterar</span>
                                            <div class="loading-btn" v-else>
                                              <div class="spinner-btn">
                                                <div class="rect1"></div>
                                                <div class="rect2"></div>
                                                <div class="rect3"></div>
                                                <div class="rect4"></div>
                                                <div class="rect5"></div>
                                              </div>
                                            </div>
                                          </button>
                                        </span>
                                      </div>
                                      <div class="col-md-4 iugu-client">
                                        Asaas CustomerId{{ !c.asaasCustomerId ? ' (Sem vínculo)' : '' }}:
                                        <span class="iugu-group-content">
                                          <a v-if="c.asaasCustomerId"
                                             v-bind:href="'https://www.asaas.com/customerAccount/show/' + c.asaasCustomerId"
                                             target="_blank">Link</a>
                                          <span v-else style="color: #999;">-</span>
                                          <button v-on:click="changeAsaasId(c.id)" class="btn-iugu">
                                            <span v-if="!loadingChangeAsaasCustomer">Alterar</span>
                                            <div class="loading-btn" v-else>
                                              <div class="spinner-btn">
                                                <div class="rect1"></div>
                                                <div class="rect2"></div>
                                                <div class="rect3"></div>
                                                <div class="rect4"></div>
                                                <div class="rect5"></div>
                                              </div>
                                            </div>
                                          </button>
                                        </span>
                                      </div>
                                      <div class="col-md-4 iugu-client">
                                        IuguClient{{ !c.iuguClientLink ? ' (Sem vínculo)' : '' }}:
                                        <span class="iugu-group-content">
                                          <a v-if="c.iuguClientLink" v-bind:href="c.iuguClientLink"
                                             target="_blank">Link</a>
                                          <span v-else style="color: #999;">-</span>
                                          <button v-on:click="changeIuguId(c.id)" class="btn-iugu">
                                            <span v-if="!loadingChangeIugu">Alterar</span>
                                            <div class="loading-btn" v-else>
                                              <div class="spinner-btn">
                                                <div class="rect1"></div>
                                                <div class="rect2"></div>
                                                <div class="rect3"></div>
                                                <div class="rect4"></div>
                                                <div class="rect5"></div>
                                              </div>
                                            </div>
                                          </button>
                                        </span>
                                      </div>
                                      <div class="col-md-4 iugu-subscription">
                                        IuguSubscription{{ !c.iuguSubscriptionLink ? ' (Sem vínculo)' : '' }}:
                                        <span class="iugu-group-content">
                                          <a v-if="c.iuguSubscriptionLink" v-bind:href="c.iuguSubscriptionLink"
                                             target="_blank">Link</a>
                                          <span v-else style="color: #999;">-</span>
                                          <button v-on:click="changeIuguIdSub(c.id)" class="btn-iugu">
                                            <span v-if="!loadingChangeIuguSub">Alterar</span>
                                            <div class="loading-btn" v-else>
                                              <div class="spinner-btn">
                                                <div class="rect1"></div>
                                                <div class="rect2"></div>
                                                <div class="rect3"></div>
                                                <div class="rect4"></div>
                                                <div class="rect5"></div>
                                              </div>
                                            </div>
                                          </button>
                                        </span>
                                      </div>
                                      <div class="col-md-4 button-change" v-if="c.isFromBusinessUnit">
                                        Nome da unidade de negócio
                                        <span class="button-content">
                                          <span class="button-value" :title="c.businessUnitName">{{
                                              c.businessUnitName
                                            }}</span>
                                          <button @click="changeBusinessUnit(c.businessUnitId, c.id)">
                                            <span v-if="!loadingChangeUnit">Alterar</span>
                                            <div class="loading-btn" v-else>
                                              <div class="spinner-btn">
                                                <div class="rect1"></div>
                                                <div class="rect2"></div>
                                                <div class="rect3"></div>
                                                <div class="rect4"></div>
                                                <div class="rect5"></div>
                                              </div>
                                            </div>
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                    <div class="col-md-12 button-group">

                                      <div class="col-md-4 button-change" v-if="c.isFromBusinessUnit">
                                        CNPJ da unidade de negócio
                                        <span class="button-content">
                                          <span class="button-value"
                                                :title="c.businessUnitCNPJ">{{ c.businessUnitCNPJ | cpfOrCnpj }}</span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Historico de Pagamento-->
              <div v-if="dataPaymentCompany.payments.length && !loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-10
                  historic-payment
                ">
                <div class="portlet-body">
                  <div class="mt-element-list">
                    <div class="portlet-body">
                      <div class="mt-element-list">
                        <div class="mt-list-head list-default border-payment">
                          <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12">
                              <div class="list-head-title-container">
                                <h3 class="list-title uppercase sbold">
                                  Histórico de pagamentos
                                  <span v-on:click="openDataPayment()"><span v-if="showPayment">FECHAR</span><span
                                    v-else>VISUALIZAR</span></span>
                                </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div v-if="showPayment" class="mt-list-container list-default">
                          <div v-for="(n, index) in dataPaymentCompany.payments">
                            <div class="tab">
                              <input v-bind:id="'tab' + index" type="checkbox" name="tabs"/>
                              <label v-bind:for="'tab' + index">Situação do Pagamento: {{ n.paymentStatus }} R$
                                {{ n.totalCost }}
                                <span v-if="n.originName" style="background-color: #7B7878;"
                                      class="billing-tag ">{{ n.originName }}</span>
                                <span>{{ n.datePaymentReference }}</span></label>
                              <div class="tab-content">
                                <div class="info">
                                  <div>
                                    <i v-if="n.isPaid" class="icon-check"></i>
                                    <i class="icon-close" v-else></i>
                                  </div>

                                  <div>
                                    <div class="content-buttons">
                                      <button v-on:click="openDetail(n.id)" class="btn-send-fatura">
                                        Detalhes e nova fatura
                                      </button>
                                      <button class="btn-send-fatura"
                                              v-if="n.paymentStatus === 'Pendente'"
                                              v-on:click="sendEmailFatura(n.id)">
                                        <span v-if="!loadingFatura">Enviar fatura novamente</span>
                                        <div class="loading-btn" v-else>
                                          <div class="spinner-btn">
                                            <div class="rect1"></div>
                                            <div class="rect2"></div>
                                            <div class="rect3"></div>
                                            <div class="rect4"></div>
                                            <div class="rect5"></div>
                                          </div>
                                        </div>
                                      </button>
                                      <button class="btn-send-fatura" v-on:click="openEditInvoice(n)">Vínculo NF
                                      </button>
                                      <button class="btn-send-fatura" v-on:click="openModalUpdatePaymentStatus(n)">
                                        Alterar status
                                      </button>
                                      <button class="btn-send-fatura"
                                              v-if="n.origin >= 0 && n.invoiceId"
                                              v-on:click="syncPaymentStatus(n)">
                                        <span v-if="!syncingPaymentStatus[n.id]">Sincronizar status</span>
                                        <div class="loading-btn" v-else>
                                          <div class="spinner-btn">
                                            <div class="rect1"></div>
                                            <div class="rect2"></div>
                                            <div class="rect3"></div>
                                            <div class="rect4"></div>
                                            <div class="rect5"></div>
                                          </div>
                                        </div>
                                      </button>
                                      <button class="btn-send-fatura btn-delete" v-on:click="openDeletePayment(n)"
                                              style="background-color: #dc3545; color: white; border-color: #dc3545;">
                                        EXCLUIR
                                      </button>
                                    </div>
                                    <h3 v-if="n.paymentStatus !== 'Pago'">
                                      Valor a ser Pago: R$
                                      {{ n.totalCost | currency }}
                                    </h3>
                                    <h3 v-if="n.paymentStatusInt === 1">
                                      Valor Pago: R$
                                      {{ n.totalCost | currency }}
                                    </h3>
                                    <p v-if="n.installment >= 1 && n.price > n.totalCost">
                                      Parcelado:
                                      <strong>Sim — parcela {{ n.installment }}</strong>
                                    </p>
                                    <p v-if="n.installment >= 1 && n.price > n.totalCost">
                                      Valor total do plano: R$ {{ n.price | currency }}
                                    </p>
                                    <p v-if="n.installment >= 1 && n.price > n.totalCost">
                                      Valor da parcela: R$ {{ n.totalCost | currency }}
                                    </p>
                                    <p>
                                      Tipo da fatura:
                                      <strong>{{ n.subscriptionPaymentHistoryTypeStr }}</strong>
                                    </p>
                                    <p v-if="n.soldFeatures">
                                      Features vendidas: <strong>{{ n.soldFeatures }}</strong>.<span
                                        v-if="n.soldFeaturesBy"> Por {{ n.soldFeaturesBy }}</span>
                                    </p>
                                    <p>ID do pagamento: {{ n.id }}</p>
                                    <p>
                                      Pagamento referente a:
                                      {{ n.datePaymentReference }}
                                    </p>
                                    <p>
                                      Data Vencimento:
                                      {{ n.expireAt | formatDate }}
                                    </p>
                                    <p v-if="n.paymentStatusInt === 1">
                                      Data Pagamento:
                                      {{ n.datePaid | formatDate }}
                                    </p>
                                    <p>Tipo Pagamento: {{ n.paymentType }}</p>
                                    <p>
                                      Nota gerada?
                                      <span v-if="n.invoiceGenerated">Sim</span>
                                      <span v-else>Não</span>
                                    </p>
                                    <p>
                                      Quem gerou:
                                      {{ n.createdBy }}
                                    </p>
                                    <p v-if="n.bankSlipUri">
                                      Link boleto:
                                      <a v-bind:href="n.bankSlipUri" target="_blank">
                                        Clique aqui
                                      </a>
                                    </p>
                                    <p>
                                      Valor por Funcionário: R$
                                      {{ n.valuePerEmployee | currency }}
                                    </p>
                                    <p>
                                      Total de funcionários no dia do
                                      vencimento: {{ n.totalEmployee }}
                                    </p>
                                    <p>Observação: {{ n.notes }}</p>

                                    <div class="block-note">
                                      <h6>Notas</h6>

                                      <p v-on:click="openModalHistoryPayment(n)" class="change-data">
                                        Alteração de data
                                      </p>

                                      <a v-if="n.invoiceGenerated" v-on:click="openPasswordModalCancel(n)">CANCELAR
                                        NOTA</a>
                                      <a v-if="!n.invoiceGenerated" v-on:click="openPasswordModal(n)">GERAR NOTA</a>
                                      <a v-if="
                                          n.invoiceGenerated && !n.invoiceUri
                                        " v-on:click="getLinkNote(n)">OBTER LINK DA NOTA</a>
                                      <a v-if="
                                          n.invoiceGenerated && n.invoiceUri
                                        " v-bind:href="n.invoiceUri" target="_blank">Link Nota</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Form -->
              <div v-if="!loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-30
                  default-box
                  filters
                  billet
                ">
                <div class="col-xs-12 col-sm-12 col-md-12 title">
                  <p>
                    Faturas
                    <span v-on:click="openBillet()">
                    <span v-if="showBillet">FECHAR</span><span v-else>VISUALIZAR</span>
                  </span>
                  </p>
                </div>

                <div v-if="showBillet" class="
                    col-xs-12 col-sm-12 col-md-12
                    offset-top-20
                    padding-null
                  ">
                  <!-- Gerar Boleto -->
                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <span class="titles">Gerar Boleto</span>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Assinatura</label>
                        <select v-model="dataAssign.subscriptionId" id="dataAssign" name="dataAssign">
                          <option value="">Selecione</option>
                          <option v-for="(s, index) in listDataSub" v-bind:value="s.id">
                            R$ {{ s.totalCost }} - {{ s.initDateStr }}
                          </option>
                        </select>
                        <span v-if="errorPrice2.subscriptionId" class="error-msg">{{
                            errorPrice2.subscriptionId
                          }}</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="price">Preço</label>
                        <input v-model.lazy="dataAssign.price" v-money="money1" type="text" class="form-control"
                               id="price" name="price" required/>
                        <span v-if="errorPrice2.price" class="error-msg">{{ errorPrice2.price }}</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="month">Mês</label>
                        <input v-model="dataAssign.month" v-mask="['##']" type="text" class="form-control" id="month"
                               placeholder="Ex: 05" name="month" required/>
                        <span v-if="errorPrice2.month" class="error-msg">{{ errorPrice2.month }}</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="year">Ano</label>
                        <input v-model="dataAssign.year" v-mask="['####']" type="text" class="form-control" id="year"
                               placeholder="Ex: 2020" name="year" required/>
                        <span v-if="errorPrice2.year" class="error-msg">{{ errorPrice2.year }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Vencimento do boleto</label>
                        <datepicker ref="programaticOpen8" v-model="dataAssign.expireAt" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar8()" class="fa fa-calendar" aria-hidden="true"></i>
                        <span v-if="errorPrice2.expireAt" class="error-msg">{{ errorPrice2.expireAt }}</span>
                      </div>
                    </div>
                    <div v-if="dataAssign.generateInvoice === 'true'" class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data de emissão</label>
                        <datepicker ref="programaticOpen10" v-model="dataAssign.invoiceDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar10()" class="fa fa-calendar" aria-hidden="true"></i>
                        <span v-if="errorPrice2.invoiceDate" class="error-msg">{{ errorPrice2.invoiceDate }}</span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>
                          Tipo da fatura
                          <ion-icon v-if="dataAssign.subscriptionPaymentHistoryType === '9'"
                                    name="help-circle-outline"
                                    style="cursor: pointer; color: #337ab7; margin-left: 5px; font-size: 18px; vertical-align: middle;"
                                    @click="tooltipPaymentExternalOpenned = !tooltipPaymentExternalOpenned"></ion-icon>
                        </label>
                        <select v-model="dataAssign.subscriptionPaymentHistoryType" id="subscriptionPaymentHistoryType"
                                name="subscriptionPaymentHistoryType">
                          <option value="">Selecione</option>
                          <option value="0">Não informado</option>
                          <option value="3">Renovacao</option>
                          <option value="4">Feature</option>
                          <option value="5">Funcionário</option>
                          <option value="9">Pagamento Externo</option>
                        </select>
                        <span v-if="errorPrice2.subscriptionPaymentHistoryType"
                              class="error-msg">{{ errorPrice2.subscriptionPaymentHistoryType }}</span>
                        <tooltip-default v-if="dataAssign.subscriptionPaymentHistoryType === '9'"
                                         @close-tooltip="tooltipPaymentExternalOpenned = false"
                                         :show-tooltip="tooltipPaymentExternalOpenned"
                                         top="30px"
                                         left="-250px"
                                         have-icon="true"
                                         title="Pagamento Externo"
                                         icon="help-circle-outline">
                          <template>
                            <div class="tooltip-body">
                              <div style="padding: 10px;">
                                <p style="margin-bottom: 10px;"><strong>O que é:</strong></p>
                                <p style="margin-bottom: 15px;">Permite vincular um pagamento realizado externamente
                                  (por exemplo, via PIX manual) a uma assinatura.</p>

                                <p style="margin-bottom: 10px;"><strong>Para que serve:</strong></p>
                                <p style="margin-bottom: 15px;">Quando um cliente faz um pagamento fora dos gateways de
                                  pagamento do sistema, você pode criar uma fatura vinculando o comprovante de
                                  pagamento.</p>

                                <p style="margin-bottom: 10px;"><strong>Como funciona:</strong></p>
                                <ul style="margin-left: 20px; margin-bottom: 0;">
                                  <li>Selecione a assinatura e preencha os dados da fatura</li>
                                  <li>Escolha "Inserir URL manual" para colar um link do comprovante ou "Upload de
                                    arquivo" para enviar o arquivo
                                  </li>
                                  <li>Informe a data em que o pagamento foi realizado</li>
                                  <li>O sistema criará a fatura marcando o pagamento como realizado na data informada
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </template>
                        </tooltip-default>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Gerar Nota?</label>
                        <select v-model="dataAssign.generateInvoice" id="generateInvoice1" name="generateInvoice1">
                          <option value="">Não</option>
                          <option value="true">Sim</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="notes1">Observação</label>
                        <input v-model="dataAssign.notes" type="text" class="form-control" id="notes1" name="notes"/>
                        <span v-if="errorPrice2.notes" class="error-msg">{{ errorPrice2.notes }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- Campos específicos para Pagamento Externo (tipo 9) -->
                  <div v-if="dataAssign.subscriptionPaymentHistoryType === '9'"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null" style="margin-top: 20px;">
                    <!-- Data do pagamento à esquerda -->
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data do pagamento</label>
                        <datepicker ref="programaticOpenPaymentDate" v-model="dataAssign.paymentDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendarPaymentDate()" class="fa fa-calendar" aria-hidden="true"></i>
                        <span v-if="errorPrice2.paymentDate" class="error-msg">{{ errorPrice2.paymentDate }}</span>
                      </div>
                    </div>
                  </div>
                  <!-- Seção de comprovante abaixo -->
                  <div v-if="dataAssign.subscriptionPaymentHistoryType === '9'"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null" style="margin-top: 20px;">
                    <div class="col-xs-12 col-sm-12 col-md-12" style="margin-bottom: 15px;">
                      <label style="display: block; margin-bottom: 10px;">Método de inserção do comprovante:</label>
                      <div style="display: flex; gap: 20px;">
                        <label style="display: flex; align-items: center; cursor: pointer;">
                          <input type="radio" v-model="dataAssign.paymentUploadMode" value="manual"
                                 style="margin-right: 5px;"/>
                          Inserir URL manual
                        </label>
                        <label style="display: flex; align-items: center; cursor: pointer;">
                          <input type="radio" v-model="dataAssign.paymentUploadMode" value="upload"
                                 style="margin-right: 5px;"/>
                          Upload de arquivo
                        </label>
                      </div>
                    </div>
                    <div v-if="dataAssign.paymentUploadMode === 'manual'" class="col-xs-12 col-sm-12 col-md-12">
                      <div class="form-group">
                        <label for="bankSlipUri">Link do pagamento:</label>
                        <input v-model="dataAssign.bankSlipUri" type="text" class="form-control" id="bankSlipUri"
                               placeholder="https://..." name="bankSlipUri"/>
                        <span v-if="errorPrice2.bankSlipUri" class="error-msg">{{ errorPrice2.bankSlipUri }}</span>
                      </div>
                    </div>
                    <div v-if="dataAssign.paymentUploadMode === 'upload'" class="col-xs-12 col-sm-12 col-md-12">
                      <div class="form-group">
                        <label>Selecione o arquivo:</label>
                        <input type="file" ref="paymentFileInput" @change="handlePaymentFileSelect"
                               style="display: none;" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"/>
                        <button type="button" @click="$refs.paymentFileInput.click()"
                                class="btn btn-default" style="margin-bottom: 10px;">
                          Escolher arquivo
                        </button>
                        <div v-if="selectedPaymentFile" style="margin-top: 10px;">
                          <p style="margin: 0;">Arquivo selecionado: {{ selectedPaymentFile.name }}</p>
                        </div>
                        <div v-if="uploadingPayment" style="margin-top: 10px;">
                          <p style="margin: 0; color: #337ab7;">Enviando arquivo...</p>
                        </div>
                        <span v-if="errorPrice2.bankSlipUri" class="error-msg">{{ errorPrice2.bankSlipUri }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="dataAssign.generateInvoice === 'true'" class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="notes2">Observação da nota</label>
                        <input v-model="dataAssign.invoiceNotes" type="text" class="form-control" id="notes2"
                               name="notes"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-12 padding-null col-md-12">
                    <button :disabled="loadingAssign" v-bind:class="{ disable: loadingAssign }"
                            v-on:click="sendAssign()">
                      <span v-if="!loadingAssign">Enviar</span>
                      <span v-else>Enviando... <i class="fa fa-spinner spinning"></i></span>
                    </button>
                  </div>

                  <!-- Alterar assinatura -->
                  <div v-if="listDataSub.length" class="
                      col-xs-12 col-sm-12 col-md-12
                      offset-top-40
                      padding-null
                    ">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <span class="titles">Alterar Assinatura</span>
                    </div>
                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label>Assinatura</label>
                          <select v-model="subscriptionId" id="changeDataAssign" name="dataAssign">
                            <option value="">Selecione</option>
                            <option v-for="(s, index) in listDataSub" v-bind:value="s">
                              R$ {{ s.totalCost }} - {{ s.initDateStr }}
                            </option>
                          </select>
                          <span v-if="errorPrice3.subscriptionId" class="error-msg">{{
                              errorPrice3.subscriptionId
                            }}</span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label for="changePrice">Preço</label>
                          <input v-model.lazy="changeDataAssign.price" v-money="money1" type="text" class="form-control"
                                 id="changePrice" name="price" required/>
                          <span v-if="errorPrice3.price" class="error-msg">{{ errorPrice3.price }}</span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label for="pricePerEmployee1">Valor por Funcionário</label>
                          <input v-model.lazy="changeDataAssign.pricePerEmployee" v-money="money1" type="text"
                                 class="form-control" id="pricePerEmployee1" name="price" required/>
                          <span v-if="errorPrice3.pricePerEmployee" class="error-msg">{{
                              errorPrice3.pricePerEmployee
                            }}</span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="input-group input-with-date">
                          <label>Data do vencimento</label>
                          <datepicker ref="programaticOpen9" v-model="changeDataAssign.expireAt" :language="ptBR"
                                      :format="customFormatter"/>
                          <i v-on:click="openCalendar9()" class="fa fa-calendar" aria-hidden="true"></i>
                          <span v-if="errorPrice3.expireAt" class="error-msg">{{ errorPrice3.expireAt }}</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                      <div class="col-xs-12 col-sm-6 col-md-3">
                        <div class="form-group">
                          <label for="year">Observação</label>
                          <input v-model="changeDataAssign.notes" type="text" class="form-control" id="changeNotes"
                                 name="notes"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="listDataSub.length" class="col-xs-12 col-sm-12 padding-null col-md-12">
                    <button :disabled="loadingPayment" v-bind:class="{ disable: loadingChangeAssign }"
                            v-on:click="changeAssign()">
                      <span v-if="!loadingChangeAssign">Enviar</span>
                      <span v-else>Enviando... <i class="fa fa-spinner spinning"></i></span>
                    </button>
                  </div>

                  <!-- Renovação -->
                  <div v-if="listDataSub.length" class="
                      col-xs-12 col-sm-12 col-md-12
                      offset-top-40
                      padding-null
                    ">
                    <div class="col-xs-12 col-sm-12 col-md-12">
                      <span class="titles">Renovação</span>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Renovação</label>
                        <select v-model="dataNovation.renew" id="novation" name="novation" required>
                          <option value="">Selecione</option>
                          <option value="true">Sim</option>
                          <option value="false">Não</option>
                        </select>
                        <span v-if="errorNovation.renew" class="error-msg">{{ errorNovation.renew }}</span>
                      </div>
                    </div>
                    <div v-if="dataNovation.renew === 'true'" class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Assinatura</label>
                        <select v-model="subscriptionId2" id="changeDataAssign2" name="dataAssign">
                          <option value="">Selecione</option>
                          <option v-for="(s, index) in listDataSub" v-bind:value="s">
                            R$ {{ s.totalCost }} - {{ s.initDateStr }}
                          </option>
                        </select>
                        <span v-if="errorNovation.subscriptionId" class="error-msg">{{
                            errorNovation.subscriptionId
                          }}</span>
                      </div>
                    </div>
                    <div v-if="dataNovation.renew === 'true'" class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Plano</label>
                        <select v-model="dataNovation.planId" id="planTypeRenew" name="dataAssign">
                          <option value="">Selecione</option>
                          <option v-for="(s, index) in listPlansType" v-bind:value="s.id">
                            {{ s.name }}
                          </option>
                        </select>
                        <!--                        <span v-if="errorPrice.planId" class="error-msg">{{-->
                        <!--                            errorPrice.planId-->
                        <!--                          }}</span>-->
                        <span v-if="errorNovation.planId" class="error-msg">{{ errorNovation.planId }}</span>
                      </div>
                    </div>
                    <div v-if="dataNovation.renew === 'true'" class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label>Tipo do Plano</label>
                        <select v-model="dataNovation.ePlanType" id="ePlanType" name="ePlanType" required>
                          <option value="">Selecione</option>
                          <option value="1">Mensal</option>
                          <option value="4">Semestral</option>
                          <option value="2">Bimestral</option>
                          <option value="3">Trimestral</option>
                          <option value="5">Anual</option>
                          <option value="6">BiAnual</option>
                        </select>
                        <span v-if="errorPrice.ePlanType" class="error-msg">{{ errorPrice.ePlanType }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="listDataSub.length && dataNovation.renew === 'true'"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div v-if="dataNovation.renew === 'true'" class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="employees">Total de Funcionários</label>
                        <input v-model="dataNovation.totalEmployees" v-mask="['#####']" type="text" class="form-control"
                               id="totalEmployees" name="totalEmployees" placeholder="Ex: 10" required/>
                        <span v-if="errorNovation.totalEmployee" class="error-msg">
                          {{ errorNovation.totalEmployees }}
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="priceToCharge">Preço de Cobrança</label>
                        <input v-model.lazy="dataNovation.priceToCharge" v-money="money1" type="text"
                               class="form-control" id="priceToCharge1" name="priceToCharge1" required/>
                        <span v-if="errorNovation.priceToCharge" class="error-msg">
                          {{ errorNovation.priceToCharge }}
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="recurringPrice">Preço Recorrente</label>
                        <input v-model.lazy="dataNovation.recurringPrice" v-money="money1" type="text"
                               class="form-control" id="recurringPrice1" name="recurringPrice1" required/>
                        <span v-if="errorNovation.recurringPrice" class="error-msg">
                          {{ errorNovation.recurringPrice }}
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Começa em</label>
                        <datepicker ref="programaticOpen12" v-model="dataNovation.startAt" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar12()" class="fa fa-calendar" aria-hidden="true"></i>
                        <span v-if="errorNovation.startAt" class="error-msg">{{ errorNovation.startAt }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="listDataSub.length && dataNovation.renew === 'true'"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="form-group">
                        <label for="recurringPrice">Valor por Funcionário</label>
                        <input v-model="dataNovation.employeeRenewPrice" v-money="money1" type="text"
                               class="form-control" id="pricePerEmployeeRenew" name="pricePerEmployeeRenew" required/>
                        <span v-if="errorNovation.employeeRenewPrice" class="error-msg">
                          {{ errorNovation.employeeRenewPrice }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div v-if="listDataSub.length && dataNovation.renew === 'true'"
                       class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <button :disabled="loadingNovation" v-bind:class="{ disable: loadingNovation }"
                            v-on:click="sendNovation()">
                      <span v-if="!loadingNovation">Enviar</span>
                      <span v-else>Enviando... <i class="fa fa-spinner spinning"></i></span>
                    </button>
                  </div>

                  <!-- Gerar Venda -->
                  <!--                  <div class="-->
                  <!--                      col-xs-12 col-sm-12 col-md-12-->
                  <!--                      padding-null-->
                  <!--                      offset-top-40-->
                  <!--                    ">-->
                  <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
                    <span class="titles">Gerar Venda</span>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 link-sale-page">
                    <p>Você pode encontrar o novo local de venda acessando o menu PAGAMENTOS
                      <ion-icon name="arrow-forward-outline"></ion-icon>
                      NOVA VENDA, ou clique no
                      link
                      <router-link :to="'/nova-venda/' + companyId + '/' + context" target="_blank">acessar a página!
                      </router-link>
                    </p>
                  </div>
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label>Plano</label>-->
                  <!--                        <select v-model="dataPrice.planId" id="planType" name="dataAssign">-->
                  <!--                          <option value="">Selecione</option>-->
                  <!--                          <option v-for="(s, index) in listPlansType" v-bind:value="s.id">-->
                  <!--                            {{ s.name }}-->
                  <!--                          </option>-->
                  <!--                        </select>-->
                  <!--                        <span v-if="errorPrice.planId" class="error-msg">{{ errorPrice.planId }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label>Essa venda vai para qual mês</label>-->
                  <!--                        <select v-model="dataPrice.month" id="montht" name="dataAssign">-->
                  <!--                          <option value="">Selecione</option>-->
                  <!--                          <option v-bind:value="1">Janeiro</option>-->
                  <!--                          <option v-bind:value="2">Fevereiro</option>-->
                  <!--                          <option v-bind:value="3">Março</option>-->
                  <!--                          <option v-bind:value="4">Abril</option>-->
                  <!--                          <option v-bind:value="5">Maio</option>-->
                  <!--                          <option v-bind:value="6">Junho</option>-->
                  <!--                          <option v-bind:value="7">Julho</option>-->
                  <!--                          <option v-bind:value="8">Agosto</option>-->
                  <!--                          <option v-bind:value="9">Setembro</option>-->
                  <!--                          <option v-bind:value="10">Outubro</option>-->
                  <!--                          <option v-bind:value="11">Novembro</option>-->
                  <!--                          <option v-bind:value="12">Dezembro</option>-->
                  <!--                        </select>-->
                  <!--                        <span v-if="errorPrice.month" class="error-msg">{{ errorPrice.month }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label>Tipo do Plano</label>-->
                  <!--                        <select v-model="dataPrice.planType" id="duration" name="duration" required>-->
                  <!--                          <option value="">Selecione</option>-->
                  <!--                          <option value="1">Mensal</option>-->
                  <!--                          <option value="4">Semestral</option>-->
                  <!--                          <option value="2">Bimestral</option>-->
                  <!--                          <option value="3">Trimestral</option>-->
                  <!--                          <option value="5">Anual</option>-->
                  <!--                          <option value="6">BiAnual</option>-->
                  <!--                        </select>-->
                  <!--                        <span v-if="errorPrice.planType" class="error-msg">{{ errorPrice.planType }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="input-group input-with-date">-->
                  <!--                        <label>Começa em</label>-->
                  <!--                        <datepicker ref="programaticOpen6" v-model="dataPrice.startAt" :language="ptBR"-->
                  <!--                                    :format="customFormatter"/>-->
                  <!--                        <i v-on:click="openCalendar6()" class="fa fa-calendar" aria-hidden="true"></i>-->
                  <!--                        <span v-if="errorPrice.startAt" class="error-msg">{{ errorPrice.startAt }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->

                  <!--                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="input-group input-with-date">-->
                  <!--                        <label>Vencimento do boleto</label>-->
                  <!--                        <datepicker ref="programaticOpen5" v-model="dataPrice.expireAt" :language="ptBR"-->
                  <!--                                    :format="customFormatter"/>-->
                  <!--                        <i v-on:click="openCalendar5()" class="fa fa-calendar" aria-hidden="true"></i>-->
                  <!--                        <span v-if="errorPrice.expireAt" class="error-msg">{{ errorPrice.expireAt }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->

                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="recurringPrice">Dia Recorrente</label>-->
                  <!--                        <input v-model="dataPrice.recurringDay" v-mask="['##']" type="text" class="form-control"-->
                  <!--                               id="recurringDay" placeholder="Ex: 05" name="recurringDay" required/>-->
                  <!--                        <span v-if="errorPrice.recurringDay" class="error-msg">{{ errorPrice.recurringDay }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="priceToCharge">Preço de Cobrança</label>-->
                  <!--                        <input v-model.lazy="dataPrice.priceToCharge" v-money="money1" type="text" class="form-control"-->
                  <!--                               id="priceToCharge" name="priceToCharge" required/>-->
                  <!--                        <span v-if="errorPrice.priceToCharge" class="error-msg">{{ errorPrice.priceToCharge }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="recurringPrice">Preço Recorrente</label>-->
                  <!--                        <input v-model.lazy="dataPrice.recurringPrice" v-money="money1" type="text" class="form-control"-->
                  <!--                               id="recurringPrice" name="recurringPrice" required/>-->
                  <!--                        <span v-if="errorPrice.recurringPrice" class="error-msg">{{ errorPrice.recurringPrice }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="employees">Total de Funcionários</label>-->
                  <!--                        <input v-model="dataPrice.totalEmployee" v-mask="['#####']" type="text" class="form-control"-->
                  <!--                               id="employees" name="employees" placeholder="Ex: 10" required/>-->
                  <!--                        <span v-if="errorPrice.totalEmployee" class="error-msg">{{ errorPrice.totalEmployee }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="pricePerEmployee">Valor por Funcionário</label>-->
                  <!--                        <input v-model.lazy="dataPrice.pricePerEmployee" v-money="money1" type="text"-->
                  <!--                               class="form-control" id="pricePerEmployee" name="pricePerEmployee" required/>-->
                  <!--                        <span v-if="errorPrice.pricePerEmployee" class="error-msg">-->
                  <!--                          {{ errorPrice.pricePerEmployee }}-->
                  <!--                        </span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label>Gerar Nota?</label>-->
                  <!--                        <select v-model="dataPrice.generateInvoice" id="generateInvoice" name="generateInvoice">-->
                  <!--                          <option value="">Não</option>-->
                  <!--                          <option value="true">Sim</option>-->
                  <!--                        </select>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label>Unidade de Negócio</label>-->
                  <!--                        <select v-model="dataPrice.businessUnitId">-->
                  <!--                          <option value="">Selecione</option>-->
                  <!--                          <option v-for="(ti, index) in unit" v-bind:key="index" v-bind:value="ti.id">-->
                  <!--                            {{ ti.name }} - {{ ti.bussinessInfo.cnpj | cpfOrCnpj }}-->
                  <!--                          </option>-->
                  <!--                        </select>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                    <div class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div v-if="dataPrice.generateInvoice === 'true'" class="input-group input-with-date">-->
                  <!--                        <label>Data de emissão</label>-->
                  <!--                        <datepicker ref="programaticOpen11" v-model="dataPrice.invoiceDate" :language="ptBR"-->
                  <!--                                    :format="customFormatter"/>-->
                  <!--                        <i v-on:click="openCalendar11()" class="fa fa-calendar" aria-hidden="true"></i>-->
                  <!--                        <span v-if="errorPrice.invoiceDate" class="error-msg">{{ errorPrice.invoiceDate }}</span>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">-->
                  <!--                    <div v-if="dataPrice.generateInvoice === 'true'" class="col-xs-12 col-sm-6 col-md-3">-->
                  <!--                      <div class="form-group">-->
                  <!--                        <label for="notes3">Observação da nota</label>-->
                  <!--                        <input v-model="dataPrice.invoiceNotes" type="text" class="form-control" id="notes3"-->
                  <!--                               name="notes"/>-->
                  <!--                      </div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                </div>
                <!--                <div v-show="uriBoleto" class="col-xs-12 col-sm-12 col-md-12 padding-null boleto">-->
                <!--                  <a v-bind:href="uriBoleto" target="_blank">BOLETO GERADO.</a>-->
                <!--                </div>-->
                <!--                <div v-if="showBillet" class="col-xs-12 col-sm-12 padding-null col-md-12">-->
                <!--                  <button :disabled="loadingPayment" v-bind:class="{ disable: loadingPayment }"-->
                <!--                          v-on:click="sendValue()">-->
                <!--                    <span v-if="!loadingPayment">Enviar</span>-->
                <!--                    <span v-else>Enviando... <i class="fa fa-spinner spinning"></i></span>-->
                <!--                  </button>-->
                <!--                </div>-->
              </div>

              <!-- Remove periodo de teste -->
              <div v-if="!loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-20
                  default-box
                  filters
                ">
                <div class="col-xs-12 col-sm-12 col-md-12 content-normalization">
                  <div class="title">
                    <p>
                      Excluir período de teste
                      <span v-on:click="openTestPeriod()">
                      <span v-if="showTestPeriod">FECHAR</span><span v-else>VISUALIZAR</span>
                    </span>
                    </p>
                  </div>

                  <div v-if="showTestPeriod" class="">
                    <p>
                      Deletar até o período:
                      <span v-if="untilTestPeriod" style="display: inline-block">
                        {{ untilTestPeriod | formatDate }}
                      </span>
                      <span v-else style="display: inline-block">"Selecione uma data."</span>
                    </p>
                  </div>
                </div>

                <form v-if="showTestPeriod" name="form" class="form-n" novalidate>
                  <!-- Inputs -->
                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data do Período</label>
                        <datepicker ref="programaticOpen3" v-model="untilTestPeriod" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar7()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <!-- Button Search -->
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        offset-top-20 offset-bottom-20
                        padding-null
                      ">
                      <button v-bind:disabled="loadingTestPeriod" v-on:click="sendTestPeriod()" class="default-btn-bue"
                              type="button">
                        <div v-if="loadingTestPeriod" class="loading-btn">
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                        <span v-else>Enviar</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Normalization -->
              <div v-if="!loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-20
                  default-box
                  filters
                ">
                <div class="col-xs-12 col-sm-12 col-md-12 content-normalization">
                  <div class="title">
                    <p>
                      Normalização retroativa
                      <span v-on:click="openDataNormalization()">
                      <span v-if="showNormalization">FECHAR</span><span v-else>VISUALIZAR</span>
                    </span>
                    </p>
                  </div>
                  <div v-if="showNormalization">
                    <p>
                      A normalização arruma retroativamente as horas extras
                      sobre as parametrizações de Hora Extra 1, Hora Extra 2,
                      Adicional Noturno, Domingos e Feriados e Tolerância.
                    </p>

                    <p>
                      A porcentagem da HE1, HE2 e AN são feitas a partir dos
                      dados configurados no
                      <a href="https://app.marqponto.com.br/regra-do-ponto" target="_blank">app.marqponto.com.br/regra-do-ponto</a>,
                      por isso certifique-se que estão corretos.
                    </p>

                    <p>
                      O período de horas que devem conter em cada faixa de HE1 e
                      HE2 estão nos dias do turno
                      <a
                        href="http://master.marqponto.com.br/lista-de-dias-do-turno/00A5D399CE9347C0905D10A483C3BD22/109B5EBE4AD742929C3D7C164D1B25B0/2/AAAA"
                        target="_blank">master.marqponto.com.br/lista-de-dias-do-turno</a>
                      no campo FirstPeriodDuration.
                      <span><b><i>O Link acima é apenas um exemplo, MUDA para toda
                          empresa</i></b></span>
                      <span class="offset-top-10">O tipo de configuração (se é Banco de Horas, Hora Extra
                      ou Compensação) é no turno no campo
                      RemunerateType.</span>
                      <span>O tipo de configuração de domingos e feriados é no
                      campo ExtraordinaryPhase.</span>
                    </p>

                    <p>
                    <span>O tipo de configuração (se é Banco de Horas, Hora Extra
                      ou Compensação) é no turno no campo
                      RemunerateType.</span>
                      <span>O tipo de configuração de domingos e feriados é no
                      campo ExtraordinaryPhase.</span>
                      <span>Os dois podem ser encontrados no
                      <a v-bind:href="
                            '/lista-turnos/' + companyId + '/' + context
                          " target="_blank">master.marqponto.com.br/lista-turnos</a>
                      clicando na ação de edição.</span>
                    </p>

                    <p>
                      <span>Algumas observações:</span>
                      <span>Evitar rodar em horários de alto fluxo de pontos, que
                      são:</span>
                      <span>- 08-09</span>
                      <span>- 11-14</span>
                      <span>- 17-18</span>
                    </p>
                  </div>
                </div>

                <form v-if="showNormalization" name="form" class="form-n" novalidate>
                  <!-- Inputs -->
                  <div class="col-xs-12 col-sm-12 col-md-12 padding-null">
                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data Inicial</label>
                        <datepicker ref="programaticOpen3" v-model="normalization.initialDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar3()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <div class="col-xs-12 col-sm-6 col-md-3">
                      <div class="input-group input-with-date">
                        <label>Data Final</label>
                        <datepicker ref="programaticOpen4" v-model="normalization.finalDate" :language="ptBR"
                                    :format="customFormatter"/>
                        <i v-on:click="openCalendar4()" class="fa fa-calendar" aria-hidden="true"></i>
                      </div>
                    </div>

                    <!-- Button Search -->
                    <div class="
                        col-xs-12 col-sm-12 col-md-12
                        offset-top-20 offset-bottom-20
                        padding-null
                      ">
                      <button v-bind:disabled="loadingNormalization" v-on:click="sendNormalization()"
                              class="default-btn-bue" type="button">
                        <div v-if="loadingNormalization" class="loading-btn">
                          <div class="spinner-btn">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                          </div>
                        </div>
                        <span v-else>Enviar</span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>

              <!-- Table -->
              <div v-if="!loading" class="
                  col-xs-12 col-sm-12 col-md-12
                  offset-top-20
                  tt-employers
                  padding-null
                ">
                <div class="portlet light">
                  <div class="portlet-title">
                    <div class="caption">
                      <h3 class="caption-subject bold uppercase">
                        Quantidade total de colaboradores
                        <span v-on:click="openEmployers()">
                        <span v-if="showEmployers">FECHAR</span><span v-else>VISUALIZAR</span>
                      </span>
                      </h3>
                    </div>
                  </div>

                  <div v-if="showEmployers" class="
                      col-xs-12 col-sm-12 col-md-12
                      padding-null
                      offset-bottom-20 offset-top-10
                    ">
                    <div class="checkbox">
                      <input type="checkbox" id="checkbox" v-model="checked" v-on:click="selectAllCheck()"/>
                      <label v-bind:style="{
                          'font-weight': '600',
                          'font-size': '13px',
                          color: '#93A2A9',
                          'padding-left': '10px',
                        }" for="checkbox">SELECIONAR TODOS</label>
                    </div>
                  </div>

                  <div v-if="showEmployers" class="search-employers">
                    <a v-bind:href="
                        '/usuarios-desativados/' + dataPaymentCompany.company.id
                      " class="user-disabled">Visualizar funcionários desativados</a>
                    <form>
                      <label>Quantidade de funcionario</label>
                      <input v-model="qtdEmployer" type="number" class="form-control" placeholder="30"/>
                      <button v-on:click="getInfo()" type="button">
                        Buscar
                      </button>
                    </form>
                  </div>

                  <div v-if="showEmployers" class="portlet-body contate-table offset-top-20">
                    <div class="table-scrollable table-scrollable-borderless">
                      <table cellspacing="0" class="table table-hover table-light table-icon">
                        <thead>
                        <tr>
                          <th>SELECIONE</th>
                          <th colspan="1" rowspan="1">NOME</th>
                          <th>NEED REGISTER</th>
                          <th>TOTAL DE PONTOS</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="c in dataCompany">
                          <td>
                            <div class="checkbox">
                              <input v-on:click="addRemoveUser(c)" v-bind:id="c.code" type="checkbox"/>
                              <label></label>
                            </div>
                          </td>
                          <td>{{ c.name }}</td>
                          <td>{{ c.needRegister }}</td>
                          <td>{{ c.totalPoints }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Box Filter -->
    <div v-if="listFromUser.length" class="container">
      <div class="row">
        <div class="col-md-12 box-content offset-top-20 offset-bottom-40">
          <!--Info -->
          <div class="col-md-12">
            <div class="info-card-blue">
              <div>1</div>
              <div>COLABORADORES SELECIONADOS</div>
              <div>
                Serão adicionado dias anteriores que os funcionários começaram a
                bater ponto na empresa
              </div>
            </div>
          </div>

          <!-- List User Selected -->
          <div class="col-md-12">
            <div class="col-md-12 box-list-user-selected">
              <div class="col-md-12 padding-null">
                <p class="list-user">
                  Lista de funcionários selecionados.
                  <span v-on:click="removeAllUser()" class="remove-all">
                  <span>Remover todos</span>
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </span>
                </p>
              </div>

              <div v-for="u in listFromUser" class="col-md-3">
                <div class="user-selected">
                  <span>{{ u.name }}</span>
                  <span v-on:click="removeUserFromCode(u.code)" title="Remover da lista"><i
                    class="icon-close"></i></span>
                </div>
              </div>
            </div>
          </div>

          <!-- Info -->
          <div class="col-md-12">
            <div class="info-card-blue">
              <div>4</div>
              <div>Data inicio e fim</div>
              <div>Preencha data de inicio e fim dos pontos</div>
            </div>
          </div>

          <!-- Values -->
          <div class="col-md-12">
            <form name="form" class="form-filter" novalidate>
              <!-- Inputs -->
              <div class="col-md-12 padding-null">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Inicial</label>
                    <datepicker ref="programaticOpen1" v-model="initialDate" :language="ptBR"
                                :format="customFormatter"/>
                    <i v-on:click="openCalendar1()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="input-group input-with-date">
                    <label>Data Final</label>
                    <datepicker ref="programaticOpen2" v-model="finalDate" :language="ptBR" :format="customFormatter"/>
                    <i v-on:click="openCalendar2()" class="fa fa-calendar" aria-hidden="true"></i>
                  </div>
                </div>

                <!-- Button Search -->
                <div class="col-md-12 offset-top-20 offset-bottom-20">
                  <button v-bind:disabled="loadingSend" v-on:click="sendPointRetro()" class="default-btn-bue"
                          type="button">
                    <div v-if="loadingSend" class="loading-btn">
                      <div class="spinner-btn">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                      </div>
                    </div>
                    <span v-else>Enviar</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import topMenu from "../../components/default/topMenu.vue";
import modalChurn from "../../modals/modalChurn.vue";
import pageHeader from "../../components/default/pageHeader.vue";
import fullLoading from "../../components/default/fullLoading.vue";
import validField from "../../components/default/validField.vue";
import swal from "sweetalert";
import datepicker from "vuejs-datepicker";
import ptBR from "vuejs-datepicker/dist/locale/translations/pt-BR";
import moment from "moment";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";
import axios from 'axios';
import { boletoPriceError } from "./boletoPrice";

import {
  required,
  minLength
} from "vuelidate/lib/validators";
import {
  mask
} from "vue-the-mask";
import {
  SET_CHAT_ENABLED,
  POINT_REPORT_DETAIL,
  COMPANY_SHOW_BALANCE,
  GET_DATA_TO_FUNIL,
  CORE_PERSON_GROUP,
  ASSIGN_HISTORY,
  SEND_EMAIL_SUB,
  GET_SUB_PLANS2,
  DELETE_TRIAL_USAGE,
  NEED_PHOTO_MARQTAB,
  NEED_LOCATION_MARQTAB,
  SET_CALENDAR_ENABLED,
  SET_PAUSE,
  WS_IMPORT,
  USER_IMPORT,
  FIX_BALANCE,
  UPDATE_COMPANY_FREE,
  PAYMENT,
  COMPANY_PAYMENT_INFO,
  CHANGE_BLOCK,
  CLIENT_SET_ONBOARDING,
  UPDATE_EXPIRATION,
  UPDATE_COMPANY_PAID,
  ADD_COMPANY_NOTES,
  CREATE_POINT_DAY,
  COMPANY_HOW_HOT,
  SET_DP_ENABLED,
  SET_JOB_ENABLED,
  GET_SUB_BY_COMPANY,
  SET_ONBOARDING_ENABLED,
  SET_REFUND_ENABLED,
  SET_CHECKIN_ENABLED,
  CHANGE_ASSIGN_HISTORY,
  FEATURES_ALL,
  CANCEL_INVOICE2,
  UPDATE_PAYMENT_HISTORY_STATUS,
  SYNC_PAYMENT_STATUS,
  DELETE_PAYMENT,
  GENERATE_INVOICE,
  GET_INVOICE,
  UPDATE_INVOICES,
  FEATURE_ALL,
  DESACTIVE_ACTIVE,
  IS_DEBUG,
  GET_SUB_PLANS,
  CHANGE_DADE_FINANCIAL,
  GET_LIST_HISTORY,
  GET_LIST_PLAN,
  GET_UNIT_MASTER,
  ENABLE_BENEFITS,
  ENABLE_PIX_OUT,
  GET_AI_CREDITS,
  ADD_AI_CREDITS,
  CHANGE_ID_IUGU,
  UPDATE_ASAAS,
  UPDATE_BUSINESS_UNIT,
  GET_CHURN_CATEGORY,
  CHANGE_BUSINESS_CONTACT,
  DORES_SELECT_BOX,
  OBJETIVOS_SELECT_BOX,
  FEATURES_COURTESY_SELECT_BOX,
  IMPORT_COLLABORATORS,
  IMPORT_COLLABORATORS_PT,
  IMPORT_COLLABORATORS_PT_EXAMPLE,
  IMPORT_COLLABORATORS_EXAMPLE,
  IMPORT_DATA_BENEFITS_OF_EMPLOYEES,
  IMPORT_EXAMPLE_DATA_BENEFITS_OF_EMPLOYEES,
  SET_PIN_COMPANY,
  UPDATE_PLAN_NAME,
  GET_REPORT_POINTS,
  USER_ROLE_MASTER,
  UPDATE_COMPANY_PROFILE,
  SET_BACKOFFICEV2,
  CHANGE_TICKETS_TICKETS,
  PUT_EDIT_INVOICES,
  UPLOAD_INVOICE_MASTER,
  UPLOAD_PAYMENT_MASTER,
  UPDATE_COMPANY_LOCALE,
  SYNC_SUBSCRIPTION,
  SYNC_SUBSCRIPTION_ASAAS,
  UPDATE_SUBSCRIPTION_INACTIVE,
  UPDATE_SUBSCRIPTION_ANTECIPATION,
  CREATE_MOCK_DATA, GET_FEATURES, FORCE_SUBSCRIPTION_GAIN,
  UPDATE_BILLING_TARGET
} from "../../../../urlConfig";

import {
  REQUEST_SERVICE
} from "../../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../../msgAlertService";
import ModalChangeEmail from "../../modals/modalChangeEmail";
import modalSubscriptionDetail from "../../modals/modalSubscriptionDetail";
import modalChangeTimezone from "../../modals/modalChangeTimezone";
import modalApplyRecalcPoints from "../../modals/modalApplyRecalcPoints";
import modalWorkshiftTimezoneBulk from "../../modals/modalWorkshiftTimezoneBulk";
import companyNuanceBadges from "../../components/layouts/companyNuanceBadges.vue";
import companyTagsChips from "../../components/layouts/companyTagsChips.vue";
import modalManageCompanyTags from "../../modals/modalManageCompanyTags.vue";
import ModalChangeTotalEmployee from "../../modals/modalChangeTotalEmployee";
import ModalPlanType from "../../modals/modalPlanType";
import modalGiveGain from "../../modals/modalGiveGain";
import ModalChangeGps from "../../modals/modalChangeGPS";
import {
  VMoney
} from "v-money";
import ModalFeatureEdit from "../../modals/modalFeatureEdit";
import ModalPaymentHistory from "../../modals/modalPaymentHistory";
import ModalFeatureType from "../../modals/modalFeatureType";
import ModalQuestionSend from "../../modals/modalQuestionSend.vue";
import BtnChange from "../../components/buttons/btnChange.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import TooltipDefault from "../../components/tooltip/tooltip-default.vue";
import BtnDefault from "../../components/buttons/btnDefault.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import BtnBlue from "../../components/buttons/btnBlue.vue";
import DatapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import inputText from "../../components/inputs/inputText.vue";
import ModalPassword from "../../modals/modalPassword.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";

export default {
  name: "company-detail",
  components: {
    InputSelect,
    ModalPassword,
    BtnCustom,
    DatapickerGlobal,
    BtnBlue,
    BtnSearch,
    BtnDefault,
    TooltipDefault,
    ModalDefault,
    BtnChange,
    ModalQuestionSend,
    ModalFeatureType,
    ModalPaymentHistory,
    ModalFeatureEdit,
    ModalChangeGps,
    modalChangeTimezone,
    modalApplyRecalcPoints,
    modalWorkshiftTimezoneBulk,
    companyNuanceBadges,
    companyTagsChips,
    modalManageCompanyTags,
    ModalChangeTotalEmployee,
    modalGiveGain,
    ModalChangeEmail,
    modalSubscriptionDetail,
    modalChurn,
    topMenu,
    pageHeader,
    fullLoading,
    validField,
    datepicker,
    ModalPlanType,
    inputText,
    InputCheckbox,
  },
  directives: {
    mask,
    money: VMoney,
  },
  data() {
    return {
      emissionDate: null,
      newUserAdminId: '',
      clearPersonalInfo: false,
      userAdminName: '',
      userAdminId: '',
      clickDisable: false,
      initDateReport: '',
      endDateReport: '',
      loadingExcel: false,
      loadingChangePlan: false,
      loadingSyncSubscription: false,
      loadingSyncSubscriptionAsaas: false,
      loadingInactiveSubscription: false,
      loadingAnticipation: false,
      loadingChangeBillingCompany: false,
      loadingChangeBillingSubscription: false,
      changeBillingCompanyData: {
        billing: 0,
        notes: '',
        password: ''
      },
      changeBillingSubscriptionData: {
        billing: 0,
        notes: '',
        subscriptionId: '',
        password: ''
      },
      tooltipOpenned: false,
      tooltipProfileOpenned: false,
      modalPassword: "",
      modalPasswordBenefits: "",
      benefitsModalAction: 'benefits',
      dataPoint: "",
      dataPlan: "",
      params1: {
        companyId: "",
        init: new Date(moment().subtract(60, "days")),
        end: new Date(moment().subtract(0, "days")),
        logCompanyEmployeeCountType: "0",
      },
      params2: {
        companyId: "",
        init: new Date(moment().subtract(60, "days")),
        end: new Date(moment().subtract(0, "days")),
        filter: "100",
      },
      callCheckRequest: "",
      dataSubscription: {
        planTypeStr: "",
        companyPlanStr: "",
        maxTotalEmployeeInContract: "",
        recurringDayStr: "",
        lastBankSlipPaidDateStr: "",
      },
      money1: {
        decimal: ".",
        thousands: ",",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
      },
      loadingListEmployee: false,
      showEmployers: false,
      showBillet: false,
      failRequest: false,
      loadingList: false,
      loadingPlan: false,
      showSubscriptions: false,
      showPayment: false,
      showNormalization: false,
      showBackoffice: true,
      showPlans: true,
      showNotes: true,
      showNoteses: true,
      loadingNps: false,
      showNps: false,
      showHistory: false,
      showHistoryPlan: false,
      loadingFinancial: false,
      showFeatures: false,
      showBenefits: false,
      showMarqIA: false,
      loadingMarqIA: false,
      marqIACredits: {
        monthly:    { total: 0, used: 0, percentage: 0 },
        additional: { total: 0, used: 0, percentage: 0 },
        overall:    { total: 0, used: 0, percentage: 0 },
        plan: null,
        renewsAt: null,
        byFeature: [],
      },
      loadingAddCredits: false,
      marqIAQuantityToAdd: null,
      marqIAUnlimited: false,
      isDebug: IS_DEBUG,
      companyId: this.$route.params.idCompany,
      dataNps: {
        getRequest: true,
      },
      context: this.$route.params.context,
      ptBR: ptBR,
      loading: true,
      loadingNormalization: false,
      loadingFree: false,
      loadinDadeList: false,
      loadingOnboarding: false,
      loadingPaying: false,
      loadingDays: false,
      loadingPayment: false,
      loadingAssign: false,
      loadingChangeAssign: false,
      loadingNovation: false,
      loadingNotes: false,
      loadingRefund: false,
      isUsingRefund: false,
      loadingClientOnboarding: false,
      isUsingOnboarding: false,
      loadingJob: false,
      isUsingJobs: false,
      callNewFinancialEmail: "",
      callResetPayment: "",
      callReloadFunction: "",
      callReloadFunction2: "",
      callReloadFunction3: "",
      callNewTotalEmployee: "",
      checkAll: false,
      checked: false,
      loadingUserMaster: false,
      loadingSend: false,
      loadingEmp: false,
      loadingBalance: false,
      loadingScale: false,
      loadingBenefits: false,
      loadingPixOut: false,
      loadingFace: false,
      loadingChangeIugu: false,
      loadingChangeIuguSub: false,
      loadingChangeAsaasCustomer: false,
      loadingChangeAsaasSubscription: false,
      normalization: {
        initialDate: "",
        finalDate: "",
      },
      initialDate: "",
      finalDate: "",
      loadingCheckin: false,
      loadingChangeUnit: false,
      loadingDp: false,
      loadingBloq: false,
      isBlock: false,
      isWorkshiftImportEnabled: false,
      isBenefitsWarning: false,
      isUserImportEnabled: false,
      isBalanceEnabled: false,
      isUsingFaceRecognition: false,
      needPhotoToMarQTab: false,
      needLocationToMarQTab: false,
      isUsingChat: false,
      isCalendarEnabled: false,
      backofficev2Enable: false,
      loadingBackofficev2: false,
      loadingCalendar: false,
      loadingChat: false,
      loadingPhotoTab: false,
      loadingLocationTab: false,
      loadingPin: false,
      showDPMenu: false,
      isUsingCheckin: false,
      isPauseEnabled: false,
      loadingPause: false,
      days: "",
      notes: "",
      dataCompany: "",
      qtdEmployer: 30,
      dataCompanyModal: "",
      dataModalFeature: "",
      dataModalHistoryPayment: "",
      dataModalFeatureType: "",
      dataModalUpsellFeatures: "",
      dataPlanType: "",
      dataGive: "",
      uriBoleto: "",
      expireDate: "",
      newBusinessUnit: "",
      datafinancialInfo: {
        financialInfo: {
          cnpj: "",
          representationName: "",
          zipCode: "",
          street: "",
          number: "",
          complement: "",
          neighborhood: "",
          city: "",
          state: "",
        },
      },
      subscriptions: [{
        businessUnitCNPJ: "",
        businessUnitName: "",
      },],
      dataPaymentCompany: {
        subscription: {
          initDateStr: "",
        },
        company: {
          bussinessInfo: {},
          address: {},
          phone: {},
        },
        lastPayment: {},
        payments: [],
        companyNewPlan: ''
      },
      errorPrice: {
        planType: "",
        priceToCharge: "",
        recurringPrice: "",
        expireAt: "",
        recurringDay: "",
        startAt: "",
        totalEmployee: "",
        month: "",
        planId: "",
        invoiceDate: "",
        pricePerEmployee: "",
      },
      errorPrice2: {
        subscriptionId: "",
        price: "",
        month: "",
        year: "",
        expireAt: "",
        invoiceDate: "",
        subscriptionPaymentHistoryType: "",
        notes: "",
        paymentDate: "",
        bankSlipUri: "",
      },
      errorNovation: {
        subscriptionId: "",
        ePlanType: "",
        renew: "",
        totalEmployees: "",
        priceToCharge: "",
        recurringPrice: "",
        startAt: "",
        planId: "",
        employeeRenewPrice: "",
      },
      errorPrice3: {
        subscriptionId: "",
        price: "",
        pricePerEmployee: "",
        expireAt: "",
      },
      subscriptionId: "",
      subscriptionId2: "",
      changeDataAssign: {
        companyId: this.$route.params.idCompany,
        subscriptionId: "",
        pricePerEmployee: "",
        price: "",
        expireAt: "",
        notes: "",
      },
      dataAssign: {
        companyId: this.$route.params.idCompany,
        subscriptionPaymentHistoryType: "",
        subscriptionId: "",
        price: "",
        month: "",
        year: "",
        planId: "",
        expireAt: "",
        notes: "",
        generateInvoice: "",
        invoiceDate: "",
        invoiceNotes: "",
        paymentUploadMode: "manual",
        bankSlipUri: "",
        paymentDate: "",
      },
      selectedPaymentFile: null,
      uploadingPayment: false,
      tooltipPaymentExternalOpenned: false,
      updateStatusPayment: null,
      updateStatusForm: {paymentStatus: '', notes: '', paidAt: null},
      updateStatusError: {},
      loadingUpdatePaymentStatus: false,
      paymentStatusOptions: [
        {value: 0, label: 'Pendente'},
        {value: 1, label: 'Pago'},
        {value: 2, label: 'Cancelado'},
        {value: 3, label: 'Expirado'},
        {value: 4, label: 'Transação negada'},
        {value: 5, label: 'Reembolsado'},
        {value: 6, label: 'Parcialmente pago'},
        {value: 7, label: 'Autorizado'},
        {value: 8, label: 'Em protesto'},
        {value: 9, label: 'Chargeback'},
        {value: 10, label: 'Carência'},
        {value: 99, label: 'Indefinido'},
      ],
      dataNovation: {
        ePlanType: "",
        renew: "false",
        totalEmployees: "",
        priceToCharge: "",
        recurringPrice: "",
        startAt: "",
        planId: "",
        employeeRenewPrice: "",
      },
      dataPrice: {
        businessUnitId: "",
        planId: "",
        month: "",
        generateInvoice: "",
        companyId: this.$route.params.idCompany,
        planType: "",
        priceToCharge: "",
        recurringPrice: "",
        expireAt: "",
        recurringDay: "",
        startAt: "",
        totalEmployee: "",
        pricePerEmployee: "",
        invoiceDate: "",
        invoiceNotes: "",
      },
      listFromUser: [],
      showTestPeriod: false,
      untilTestPeriod: "",
      loadingTestPeriod: false,
      loadingFatura: false,
      syncingPaymentStatus: {},
      listDataSub: [],
      listPlansType: [],
      listActiveFeatures: [],
      moduleJourneyControl: null,
      modulePersonalDepartment: null,
      modulePeopleDevelopment: null,
      moduleCommunicationAndCulture: null,
      moduleCorporateBenefits: null,
      moduleExtra: null,
      loadingFeatures: false,
      loadingFeaturesActived: false,
      unit: [],
      modalInputIugu: '',
      idSubsIugu: '',
      modalInputIuguSub: '',
      idSubsIuguSub: '',
      modalInputAsaasCustomer: '',
      idSubsAsaasCustomer: '',
      modalInputAsaasSubscription: '',
      idSubsAsaasSubscription: '',
      deletePaymentId: '',
      deletePaymentPassword: '',
      deletePaymentNotes: '',
      deletePaymentPasswordError: '',
      deletePaymentNotesError: '',
      loadingDeletePayment: false,
      doresItens: '',
      objetivosItens: '',
      featuresCourtesyItens: '',
      loadingImportCollaborators: false,
      loadingImportCollaboratorsPortugal: false,
      loadingImportCollaboratorsDataBenefits: false,
      valueCurrentPlan: '',
      valueCurrentProfile: '',
      isActive: '',
      generateNote: null,
      cancelValueNote: null,
      typeChangeNote: 0,
      titleModalPassword: '',
      loadingEditInvoice: false,
      invoiceGenerateError: false,
      loadingChangeLocale: false,
      validateError: '',
      companyLocale: 0,
      companyLocaleName: '',
      anticipationSubscriptionData: {
        id: '',
        notes: '',
        hasInvoiceAnticipation: false,
        anticipationInDays: null,
      },
      inactiveSubscriptionData: {
        id: '',
        notes: '',
        disable: true,
      },
      dataSendInvoice: {
        companyId: '',
        id: '',
        invoiceGenerated: false,
        uri: '',
        rpSn: null
      },
      invoiceUploadMode: 'manual',
      selectedInvoiceFile: null,
      uploadingInvoice: false,
      trueOrFalse: [
        {
          id: false,
          name: 'Não'
        },
        {
          id: true,
          name: 'Sim'
        }
      ],
      locale: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 0,
          name: 'Brasil'
        },
        {
          id: 1,
          name: 'Portugal'
        },
        {
          id: 2,
          name: 'Espanha'
        },
        {
          id: 3,
          name: 'Estados Unidos'
        },
      ],
      planType: [
        {
          id: '',
          name: 'Selecione'
        },
        {
          id: 1,
          name: 'Mensal'
        },
        {
          id: 2,
          name: 'Bimestral'
        },
        {
          id: 3,
          name: 'Trimestral'
        },
        {
          id: 4,
          name: 'Semestral'
        },
        {
          id: 5,
          name: 'Anual'
        },
        {
          id: 6,
          name: 'Bianual'
        }
      ],
      forceSubscriptionGain: {
        id: '',
        notes: '',
        receiptUri: '',
        initDate: null,
        planType: null,
      },
      loadingForceSubscriptionGain: false,
      mockData: {
        show: false,
        initDate: '',
        endDate: '',
        total: '0',
      },
      loadingMockData: false
    };
  },
  computed: {
    isUnlimitedPlan() {
      return this.marqIACredits.plan && this.marqIACredits.plan.creditsPerMonth === 0;
    },
  },
  methods: {
    sendForceSubscriptionGain() {
      this.loadingForceSubscriptionGain = true;
      this.forceSubscriptionGain.initDate = moment(this.forceSubscriptionGain.initDate).format("YYYY-MM-DD");

      REQUEST_SERVICE.requestContext('POST', FORCE_SUBSCRIPTION_GAIN, this.context, this.forceSubscriptionGain).then(response => {
        this.loadingForceSubscriptionGain = false;
        this.forceSubscriptionGain = {
          id: '',
          notes: '',
          receiptUri: '',
          initDate: null,
          planType: null,
        };
        $('#forceSubscriptionGain').modal('hide');
        swal("Sucesso!", response.data, "success");
      }).catch((reason) => {
        this.loadingForceSubscriptionGain = false;
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      })
    },
    anticipationSubscription() {
      this.loadingAnticipation = true;
      REQUEST_SERVICE.requestContext('PUT', UPDATE_SUBSCRIPTION_ANTECIPATION, this.context, this.anticipationSubscriptionData).then(response => {
        this.loadingAnticipation = false;
        this.anticipationSubscriptionData = {
          id: '',
          notes: '',
          hasInvoiceAnticipation: false,
          anticipationInDays: null,
        }
        $('#anticipationSubscription').modal('hide');
        swal("Sucesso!", response.data, "success");
      }).catch(() => {
        this.loadingAnticipation = false;
        swal("Aviso", 'Ops! Algo deu errado, tente novamente.', "error");
      })
    },
    syncSubscription(value) {
      swal({
        title: "Aviso",
        text: "Deseja forçar a sincronização dos boletos IUGU?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((res) => {
        if (res) {
          this.loadingSyncSubscription = true;
          REQUEST_SERVICE.requestContext('GET', SYNC_SUBSCRIPTION + value.id, this.context).then(response => {
            this.loadingSyncSubscription = false;
            swal("Sucesso!", response.data, "success");
          }).catch(() => {
            this.loadingSyncSubscription = false;
            swal("Aviso", 'Ops! Algo deu errado, tente novamente.', "error");
          })
        }
      })
    },
    syncSubscriptionAsaas(value) {
      if (this.loadingSyncSubscriptionAsaas) return;
      swal({
        title: "Aviso",
        text: "Deseja forçar a sincronização dos boletos ASAAS? A consulta é feita na conta ASAAS da assinatura (MarQ ou BOH).",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((res) => {
        if (!res) return;
        this.loadingSyncSubscriptionAsaas = true;
        REQUEST_SERVICE.requestContext('GET', SYNC_SUBSCRIPTION_ASAAS + value.id, this.context).then((response) => {
          this.loadingSyncSubscriptionAsaas = false;
          const data = this.parseGatewaySyncResponse(response);
          const notVerified = Array.isArray(data.notVerified) ? data.notVerified : [];
          const errors = Array.isArray(data.errors) ? data.errors : [];
          let text = data.message || "Sincronização concluída.";
          if (notVerified.length) text += "\n\nNão verificados:\n" + notVerified.join("\n");
          if (errors.length) text += "\n\nErros:\n" + errors.join("\n");
          swal("Sincronização ASAAS", text, notVerified.length || errors.length ? "warning" : "success");
          this.getPaymentInfo();
        }).catch((reason) => {
          this.loadingSyncSubscriptionAsaas = false;
          swal("Aviso", this.gatewaySyncErrorMessage(reason), "error");
        });
      });
    },
    parseGatewaySyncResponse(response) {
      let data = response && response.data;
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          data = {message: data};
        }
      }
      return data && typeof data === 'object' ? data : {};
    },
    gatewaySyncErrorMessage(reason) {
      const response = reason && reason.response;
      const data = response && response.data;
      const erros = data && Array.isArray(data.erros) ? data.erros : [];
      const values = erros.map(e => typeof e === 'string' ? e : (e && (e.value || e.Value))).filter(v => v);
      if (values.length) return values.join("\n");
      if (response && response.status) return "Não foi possível completar a operação (HTTP " + response.status + "). Tente novamente.";
      return "Não foi possível comunicar com o servidor. Verifique a conexão e tente novamente.";
    },
    changeLocale() {
      if (this.companyLocale === '') {
        swal("Aviso", 'Informe a localidade desejada!', "error");
        return;
      }

      this.loadingChangeLocale = true;
      const newUrl = `${UPDATE_COMPANY_LOCALE}/${this.companyId}/${this.companyLocale}`
      REQUEST_SERVICE.requestContext('PUT', newUrl, this.context).then(response => {
        this.loadingChangeLocale = false;
        $('#changeLocale').modal('hide');
        swal("Sucesso!", "O local da empresa foi alterado com sucesso.", "success");
      }).catch(reason => {
        this.loadingChangeLocale = false;
        swal("Aviso", 'Ops! Algo deu errado, tente novamente.', "error");
      })
    },
    openModalChangeLocale() {
      $('#changeLocale').modal();
    },
    createMockData() {
      this.loadingMockData = true;
      const body = {
        companyId: this.companyId,
        init: Number(this.mockData.initDate.replaceAll("-", "")),
        end: Number(this.mockData.endDate.replaceAll("-", "")),
        keyWord: 's2',
        totalEmployees: Number(this.mockData.total),
        WhoCreatedId: JSON.parse(window.localStorage.getItem("mamUserMasterInfo")).id
      }
      const newUrl = CREATE_MOCK_DATA;

      axios.post(newUrl, body, {
        headers: {
          'Content-Type': 'application/json',
          companyId: this.companyId,
        }
      })
        .then((res) => {
          $('#createMockData').modal('hide');
          swal("Sucesso!", "Os dados foram criados com sucesso.", "success");
          this.loadingMockData = false;
        })
        .catch((error) => {
          $('#createMockData').modal('hide');
          swal("Aviso", 'Ops! Algo deu errado, tente novamente.', "error");
          this.loadingMockData = false;
        });
    },
    openModalMockData() {
      $('#createMockData').modal();
    },
    handleInvoiceFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedInvoiceFile = file;
      }
    },
    uploadInvoiceFile() {
      if (!this.selectedInvoiceFile) {
        swal("Aviso", "Por favor, selecione um arquivo para upload.", "error");
        return Promise.reject('No file selected');
      }

      this.uploadingInvoice = true;
      const contextCode = this.dataPaymentCompany && this.dataPaymentCompany.company && this.dataPaymentCompany.company.contextCode
        ? this.dataPaymentCompany.company.contextCode
        : this.context;

      return REQUEST_SERVICE.fileUploadV2(UPLOAD_INVOICE_MASTER, this.selectedInvoiceFile, contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD_INVOICE_MASTER:", response);
          this.uploadingInvoice = false;

          // O endpoint retorna uma string com a URL
          const uploadedUrl = typeof response.data === 'string' ? response.data : response.data.url || response.data.uri;

          if (!uploadedUrl) {
            throw new Error('URL não retornada pelo servidor');
          }

          this.dataSendInvoice.uri = uploadedUrl;
          return uploadedUrl;
        })
        .catch((reason) => {
          this.uploadingInvoice = false;
          UTIL_SERVICE.console("ERROR UPLOAD_INVOICE_MASTER:", reason);
          const errorMessage = reason.response && reason.response.data
            ? (reason.response.data.erros && reason.response.data.erros[0]
              ? reason.response.data.erros[0].value
              : reason.response.data.message || reason.response.data)
            : 'Erro ao fazer upload do arquivo. Tente novamente ou contate nosso suporte.';
          swal("Aviso", errorMessage, "error");
          return Promise.reject(reason);
        });
    },
    editInvoice() {
      this.invoiceGenerateError = false;

      // Se o modo é upload e há arquivo selecionado, fazer upload primeiro (substitui URI antiga)
      if (this.dataSendInvoice.invoiceGenerated && this.invoiceUploadMode === 'upload' && this.selectedInvoiceFile) {
        return this.uploadInvoiceFile()
          .then(() => {
            // Após upload bem-sucedido, continuar com o envio
            this.submitInvoiceUpdate();
          })
          .catch(() => {
            // Erro já foi tratado no uploadInvoiceFile
          });
      }

      // Validação para modo manual ou quando não há arquivo selecionado no modo upload
      if (this.dataSendInvoice.invoiceGenerated && !this.dataSendInvoice.uri) {
        if (this.invoiceUploadMode === 'upload') {
          swal("Aviso", "Por favor, selecione um arquivo para upload.", "error");
        } else {
          this.invoiceGenerateError = true;
        }
        return;
      } else {
        if (this.dataSendInvoice.uri) {
          let regex = /^(http|https|Http|Https|rtsp|Rtsp):\/\//i;
          let validate = regex.test(this.dataSendInvoice.uri);
          if (!validate) {
            this.validateError = 'Preencha um link válido!';
            return this.invoiceGenerateError = true;
          }
        }
        this.submitInvoiceUpdate();
      }
    },
    submitInvoiceUpdate() {
      this.loadingEditInvoice = true;
      let obj = this.dataSendInvoice;
      const contextCode = this.dataPaymentCompany && this.dataPaymentCompany.company && this.dataPaymentCompany.company.contextCode
        ? this.dataPaymentCompany.company.contextCode
        : this.context;

      REQUEST_SERVICE.requestContext('PUT', PUT_EDIT_INVOICES, contextCode, obj).then(response => {
        UTIL_SERVICE.console("RESULT", "PUT_EDIT_INVOICES");
        $('#editInvoice').modal('hide');
        swal("Sucesso!", "A fatura foi alterada com sucesso.", "success");
        this.loadingEditInvoice = false;
        obj = null;
        // Recarregar dados se necessário
        if (this.getPaymentInfo) {
          this.getPaymentInfo();
        }
      }).catch(reason => {
        $('#editInvoice').modal('hide');
        this.loadingEditInvoice = false;
        obj = null;
        if (reason.response && reason.response.data && reason.response.data.erros) {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        } else {
          const errorMessage = reason.response && reason.response.data
            ? (reason.response.data.message || reason.response.data)
            : 'Erro ao atualizar a fatura. Tente novamente ou contate nosso suporte.';
          swal("Aviso", errorMessage, "error");
        }
      })
    },
    validateEditInvoice(password) {
      if (password === 'NotasFinc2024') {
        $('#editInvoice').modal();
      } else {
        swal("Aviso", "Senha incorreta!", "error");
      }
    },
    validateInactiveSubscription(password) {
      if (password === '2025MarQinat@') {
        $('#inactiveSubscription').modal();
      } else {
        swal("Aviso", "Senha incorreta!", "error");
      }
    },
    validateAnticipationSubscription(password) {
      if (password === 'antecMarQ2025!') {
        $('#anticipationSubscription').modal();
      } else {
        swal("Aviso", "Senha incorreta!", "error");
      }
    },
    inactiveSubscription() {
      this.loadingInactiveSubscription = true;
      REQUEST_SERVICE.requestContext('PUT', UPDATE_SUBSCRIPTION_INACTIVE, this.context, this.inactiveSubscriptionData).then((response) => {
        this.loadingInactiveSubscription = false;
        this.inactiveSubscriptionData = {
          id: '',
          notes: '',
          disable: true,
        };
        $('inactiveSubscription').modal('hide');
        swal("Sucesso!", response.data, "success");
      }).catch(() => {
        this.loadingInactiveSubscription = false;
        swal("Aviso", 'Ops! Algo deu errado, tente novamente.', "error");
      })
    },
    openEditInvoice(value) {
      this.dataSendInvoice.companyId = this.companyId;
      this.dataSendInvoice.id = value.id;
      this.dataSendInvoice.invoiceGenerated = value.invoiceGenerated;
      this.dataSendInvoice.uri = value.bankSlipUri;
      value.rpSn ? this.dataSendInvoice.rpSn = value.rpSn : '';
      this.titleModalPassword = 'Editar fatura';
      this.typeChangeNote = 3;
      this.invoiceUploadMode = 'manual';
      this.selectedInvoiceFile = null;
      this.uploadingInvoice = false;

      $('#password-modal').modal();
    },
    cleanModal() {
      this.invoiceGenerateError = false;
      this.dataSendInvoice = {
        companyId: '',
        id: '',
        invoiceGenerated: false,
        uri: '',
        rpSn: ''
      };
      this.invoiceUploadMode = 'manual';
      this.selectedInvoiceFile = null;
      this.uploadingInvoice = false;
      if (this.$refs.invoiceFileInput) {
        this.$refs.invoiceFileInput.value = '';
      }
    },
    formatPrice(value) {
      const valueStr = value.toString();
      if (!valueStr.includes('.')) {
        const valueUpdate = valueStr.concat('.00');
        return valueUpdate
      } else {
        return value;
      }
    },
    openModalPasswordAnticipation(id) {
      this.titleModalPassword = 'Antecipação NFs';
      this.typeChangeNote = 5;
      this.anticipationSubscriptionData.id = id;
      $('#password-modal').modal();
    },
    openModalForceGain(id) {
      this.forceSubscriptionGain.id = id;
      $('#forceSubscriptionGain').modal();
    },
    openModalChangeBillingCompany() {
      this.changeBillingCompanyData.billing = this.dataPaymentCompany.billingTarget || 0;
      this.changeBillingCompanyData.notes = '';
      this.changeBillingCompanyData.password = '';
      $('#changeBillingCompany').modal();
    },
    openModalChangeBillingSubscription(subscription) {
      this.changeBillingSubscriptionData.billing = subscription.billingTarget || 0;
      this.changeBillingSubscriptionData.notes = '';
      this.changeBillingSubscriptionData.password = '';
      this.changeBillingSubscriptionData.subscriptionId = subscription.id;
      $('#changeBillingSubscription').modal();
    },
    submitChangeBillingCompany() {
      if (this.changeBillingCompanyData.password !== 'birl') {
        swal("Aviso", "Senha incorreta!", "error");
        return;
      }
      this.loadingChangeBillingCompany = true;
      const body = {
        Billing: this.changeBillingCompanyData.billing,
        Notes: this.changeBillingCompanyData.notes,
        CompanyId: this.companyId
      };
      REQUEST_SERVICE.requestContext('PUT', UPDATE_BILLING_TARGET, this.dataPaymentCompany.company.contextCode, body)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_BILLING_TARGET:", response.data);
          this.loadingChangeBillingCompany = false;
          $('#changeBillingCompany').modal('hide');
          this.dataPaymentCompany.billingTarget = this.changeBillingCompanyData.billing;
          swal("Sucesso!", "Faturamento alterado com sucesso!", "success");
        })
        .catch((reason) => {
          this.loadingChangeBillingCompany = false;
          if (reason.response && reason.response.data && reason.response.data.erros) {
            reason.response.data.erros.map((value) => {
              swal("Aviso", value.value, "error");
            });
          } else {
            swal("Aviso", "Ops! Algo deu errado, tente novamente.", "error");
          }
        });
    },
    submitChangeBillingSubscription() {
      if (this.changeBillingSubscriptionData.password !== 'birl') {
        swal("Aviso", "Senha incorreta!", "error");
        return;
      }
      this.loadingChangeBillingSubscription = true;
      const body = {
        Billing: this.changeBillingSubscriptionData.billing,
        Notes: this.changeBillingSubscriptionData.notes,
        SubscriptionId: this.changeBillingSubscriptionData.subscriptionId
      };
      REQUEST_SERVICE.requestContext('PUT', UPDATE_BILLING_TARGET, this.dataPaymentCompany.company.contextCode, body)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_BILLING_TARGET:", response.data);
          this.loadingChangeBillingSubscription = false;
          $('#changeBillingSubscription').modal('hide');
          // Update the subscription billingTarget in the list
          const subscription = this.subscriptions.find(s => s.id === this.changeBillingSubscriptionData.subscriptionId);
          if (subscription) {
            subscription.billingTarget = this.changeBillingSubscriptionData.billing;
          }
          swal("Sucesso!", "Faturamento alterado com sucesso!", "success");
        })
        .catch((reason) => {
          this.loadingChangeBillingSubscription = false;
          if (reason.response && reason.response.data && reason.response.data.erros) {
            reason.response.data.erros.map((value) => {
              swal("Aviso", value.value, "error");
            });
          } else {
            swal("Aviso", "Ops! Algo deu errado, tente novamente.", "error");
          }
        });
    },
    openModalPasswordInactiveSubscription(id) {
      this.inactiveSubscriptionData.id = id;
      this.titleModalPassword = 'Inativar assinatura';
      this.typeChangeNote = 4;
      $('#password-modal').modal();
    },
    openModalPasswordGenerateNote() {
      $('#generateNoteDate').modal('hide');
      $('#password-modal').modal();
    },
    openPasswordModal(value) {
      this.generateNote = value;
      this.titleModalPassword = 'Gerar nota';
      this.typeChangeNote = 1;
      $('#generateNoteDate').modal();
    },
    openPasswordModalCancel(value) {
      this.cancelValueNote = value;
      this.titleModalPassword = 'Cancelar nota';
      this.typeChangeNote = 2;
      $('#password-modal').modal();
    },
    changeUserMaster() {
      this.loadingUserMaster = true;

      if (this.newUserAdminId && this.newUserAdminId !== this.userAdminId) {
        let obj = {
          oldUserMasterId: this.userAdminId,
          newUserMasterId: this.newUserAdminId
        }

        if (this.clearPersonalInfo) {
          obj.clearPersonalInfo = this.clearPersonalInfo;
        }

        UTIL_SERVICE.console('Data send', obj);
        REQUEST_SERVICE.requestContext('PUT', USER_ROLE_MASTER, this.context, obj).then((response) => {
          UTIL_SERVICE.console('RESULT EDIT_USER_MASTER', response.data);

          this.loadingUserMaster = false;
          $('#changeUserMaster').modal('hide');
          swal("Aviso", "Alterado com Sucesso!", "success");
          this.getPaymentInfo();

        }).catch((reason) => {
          this.loadingUserMaster = false;
          $('#changeUserMaster').modal('hide');
          ALERT_SERVICE.showMsgError(reason.response.data.erros);
        })
      } else {
        $('#changeUserMaster').modal('hide');
        swal("Aviso", "Verifique se o campo foi preenchido corretamente!", "error");
        this.loadingUserMaster = false;
      }
    },
    openModalChangeUser() {
      $('#changeUserMaster').modal();
      $('html').css('overflow', 'hidden');
    },
    changeUserClosed() {
      $('html').css('overflow', 'auto');
    },
    createReportExcel() {

      this.clickDisable = true;
      this.loadingExcel = true;

      let url = GET_REPORT_POINTS;
      let init = moment(this.initDateReport).format('YYYYMMDD')
      let end = moment(this.endDateReport).format('YYYYMMDD')

      url += '?init=' + init + '&end=' + end;
      url += '&companyId=' + this.companyId;

      REQUEST_SERVICE.requestContext('GET', url, this.context).then((response) => {

        let binaryData = [];
        binaryData.push(response.data);
        let urlResponse = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'Registros-de-ponto.csv';
        a.click();

        $('#reportPoints').modal('toggle');
        this.loadingExcel = false;
        this.clickDisable = false;

      }).catch((reason) => {
        this.loadingExcel = false;
        this.clickDisable = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    reportPointsClosed() {
      $('html').css('overflow', 'auto');
    },
    openModalReportPoints() {
      $('#reportPoints').modal();
      $('html').css('overflow', 'hidden');
    },
    setNewPlan() {
      this.loadingChangePlan = true;

      let obj = {
        companyId: this.dataPaymentCompany.company.id
      }

      if (this.valueCurrentPlan === 'Essencial')
        obj.planId = '006AE79EAC754C518548BC5F05B77CF2'
      if (this.valueCurrentPlan === 'Básico')
        obj.planId = '00875CC4401649EEB36F253AB234525E'
      if (this.valueCurrentPlan === 'Profissional')
        obj.planId = '00AD8417796E41269871612954AA8696'
      if (this.valueCurrentPlan === 'Premium')
        obj.planId = '012ABCA6249047FFA16A9B2818E20A2F'


      REQUEST_SERVICE.requestContext("PUT", UPDATE_PLAN_NAME, this.dataPaymentCompany.company.contextCode, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_PLAN_NAME:", response.data);

          this.dataPaymentCompany.companyNewPlan = this.valueCurrentPlan;
          this.loadingChangePlan = false;
          this.tooltipOpenned = !this.tooltipOpenned;
          swal("Aviso!", response.data, 'success')
        })
        .catch((reason) => {
          this.loadingChangePlan = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    setNewProfile() {
      this.tooltipProfileOpenned = false;
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja executar essa ação na empresa: " + this.dataPaymentCompany.company.name + "\n\n\n Qual motivo?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
        content: {
          element: "div",
          attributes: {
            innerHTML: `<input type="text" id="inputProfile" class="swal-content__input" placeholder="Digite o motivo?">`,
          }
        },
      }).then((value) => {
        const observation = document.querySelector("#inputProfile");
        if (value) {
          if (observation.value) {
            let obj = {
              companyId: this.companyId,
              companyTier: this.valueCurrentProfile,
              observation: observation.value,
            }

            REQUEST_SERVICE.requestContext('PUT', UPDATE_COMPANY_PROFILE, this.context, obj).then((response) => {
              UTIL_SERVICE.console("RESULT UPDATE_COMPANY_PROFILE", response.data);

              swal("Sucesso", "Perfil alterado com sucesso!", "success").then(() => {
                this.getPaymentInfo();
              })
            }).catch((reason) => {
              swal("Erro", reason.response.data.exceptionMessage
                , "error");
            })

          } else {
            swal("Alerta", "Preencha o motivo para continuar!", "warning");
          }
        }
      })
    },
    valuePlan(value) {
      this.valueCurrentPlan = value;
    },
    valueProfile(value) {
      this.valueCurrentProfile = value;
    },
    downloadExample() {
      window.open(IMPORT_COLLABORATORS_EXAMPLE, '_blank');
    },
    downloadExamplePortugal() {
      window.open(IMPORT_COLLABORATORS_PT_EXAMPLE, '_blank');
    },
    downloadExampleImportOnlyDataBenefits() {
      window.open(IMPORT_EXAMPLE_DATA_BENEFITS_OF_EMPLOYEES, '_blank');
    },
    openFileSelector(id) {
      document.getElementById(id).click();
    },
    handleFileUpload(event) {
      const files = event.target.files;
      let fileAttach = files[0];

      if (!fileAttach.type === "text/csv") {
        return swal("Aviso", "Importação de colaboradores somente com arquivos CSV", "error");
      }

      if (!files.length)
        return;

      let url = IMPORT_COLLABORATORS + '?id=' + this.$route.params.idCompany + '&nd=0';

      this.loadingImportCollaborators = true;

      REQUEST_SERVICE.fileUploadV2(url, fileAttach, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT IMPORT_COLLABORATORS: ", response);

        let binaryData = [];
        binaryData.push(response.data);
        let urlResponse = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'Resultado-importacao-de-colaboradores.csv';
        a.click();

        swal("Aviso", "Verifique o arquivo CSV baixado para saber o resultado da importação", "warning");
        this.loadingImportCollaborators = false;
      }).catch((reason) => {
        this.loadingImportCollaborators = false
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    handleFileUploadPortugal(event) {
      const files = event.target.files;
      let fileAttach = files[0];

      if (!files.length)
        return;

      if (!fileAttach.type === "text/csv") {
        return swal("Aviso", "Importação de colaboradores somente com arquivos CSV", "error");
      }

      // Layout PT (separador ';'): Nome; Email; NIF; Telefone; Senha
      let url = IMPORT_COLLABORATORS_PT + '?id=' + this.$route.params.idCompany;

      this.loadingImportCollaboratorsPortugal = true;

      // 3º parâmetro (this.context) é enviado como header Contentsetting (shard da empresa)
      REQUEST_SERVICE.fileUploadV2(url, fileAttach, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT IMPORT_COLLABORATORS_PT: ", response);

        this.loadingImportCollaboratorsPortugal = false;

        // O backend serializa o resultado como string JSON; normalizamos para objeto.
        let data = response.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch (e) { data = {}; }
        }

        const notifs = (data && data.notifications) || [];
        const imported = (data && data.imported) || 0;

        if (notifs.length) {
          const msg = notifs.map(n => n.value || n.Value || n).join("\n");
          swal("Importação concluída com avisos", `${imported} colaborador(es) importado(s).\n${msg}`, "warning");
        } else {
          swal("Sucesso", `${imported} colaborador(es) de Portugal importado(s).`, "success");
        }
      }).catch((reason) => {
        this.loadingImportCollaboratorsPortugal = false;
        const erros = reason && reason.response && reason.response.data && reason.response.data.erros;
        if (erros && erros.length) {
          erros.map((value) => { swal("Aviso", value.value, "error"); });
        } else {
          swal("Aviso", "Falha ao importar. Verifique o arquivo e tente novamente.", "error");
        }
      });
    },
    handleFileUploadDataBenefits(event) {
      const files = event.target.files;
      let fileAttach = files[0];

      if (!fileAttach.type === "text/csv") {
        return swal("Aviso", "Importação de colaboradores somente com arquivos CSV", "error");
      }

      if (!files.length)
        return;

      let url = IMPORT_DATA_BENEFITS_OF_EMPLOYEES + '?companyid=' + this.$route.params.idCompany;

      this.loadingImportCollaboratorsDataBenefits = true;
      REQUEST_SERVICE.fileUploadV2(url, fileAttach, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT IMPORT_COLLABORATORS: ", response);

        let binaryData = [];
        binaryData.push(response.data);
        let urlResponse = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'Resultado-importacao-dados-de-beneficios.csv';
        a.click();

        swal("Aviso", "Verifique o arquivo CSV baixado para saber o resultado da importação dos dados dos benefícios", "warning");
        this.loadingImportCollaboratorsDataBenefits = false;
      }).catch((reason) => {
        this.loadingImportCollaboratorsDataBenefits = false
        reason.response.data.erros.map((value, index) => {
          swal("Aviso", value.value, "error");
        });
      });
    },
    getHistory() {
      if (this.params1.init && this.params1.end) {
        moment.locale("pt-br");

        this.loadingList = true;

        let url = GET_LIST_HISTORY;
        url += "?init=" + moment(this.params1.init).format("YYYY-MM-DD");
        url += "&end=" + moment(this.params1.end).format("YYYY-MM-DD");
        url += "&companyId=" + this.$route.params.idCompany;

        if (this.params1.logCompanyEmployeeCountType)
          url +=
            "&logCompanyEmployeeCountType=" +
            this.params1.logCompanyEmployeeCountType;

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_LIST_HISTORY:", response.data);

            this.dataPoint = response.data;
            this.failRequest = false;
            this.loadingList = false;
          })
          .catch((reason) => {
            this.failRequest = true;
            this.loadingList = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "Preencha as datas para pesquisar", "error");
      }
    },
    validationModal() {
      this.modalPassword = "";
      document.querySelector("[id='input-password']").value = "";
      $("#password-modal-churn").modal();
    },
    passwordValidation() {
      if (this.modalPassword === "MMAARRQQchurn") {
        $("#password-modal-churn").toggle("");

        this.dataCompanyModal = {};
        this.dataCompanyModal.id = this.$route.params.idCompany;
        this.dataCompanyModal.context = this.context;
        this.dataCompanyModal.type = 1;

        $("#modalChurn").modal();
        this.modalPassword = "";
      } else {
        $("#password-modal-churn").toggle("");

        swal("Aviso", "Senha Errada!", "error");
        this.modalPassword = "";
      }
    },
    getHistoryPlan() {
      if (this.params2.init && this.params2.end) {
        moment.locale("pt-br");

        this.loadingPlan = true;

        let url = GET_LIST_PLAN;
        url += "?init=" + moment(this.params2.init).format("YYYY-MM-DD");
        url += "&end=" + moment(this.params2.end).format("YYYY-MM-DD");
        url += "&companyId=" + this.$route.params.idCompany;

        if (this.params2.filter) {
          url += "&filter=" + this.params2.filter;
        }

        UTIL_SERVICE.console("URL SEARCH:", url);
        REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_LIST_PLAN:", response.data);

            this.dataPlan = response.data;
            this.failRequest = false;
            this.loadingPlan = false;
          })
          .catch((reason) => {
            this.failRequest = true;
            this.loadingPlan = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "Preencha as datas para pesquisar", "error");
      }
    },
    getSelectUnitMaster() {
      let url = GET_UNIT_MASTER;
      url += "?i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_UNIT_MASTER:", response.data);

          this.unit = response.data;
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getDadeFinancial() {
      this.loadinDadeList = true;
      let url = CHANGE_DADE_FINANCIAL + "?i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.$route.params.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_DADE_FINANCIAL:", response.data);

          this.datafinancialInfo = response.data;
          this.loadinDadeList = false;
          this.showNotes = false;

          if (
            this.datafinancialInfo.financialInfo.cnpj ||
            this.datafinancialInfo.financialInfo.representationName ||
            this.datafinancialInfo.financialInfo.zipCode ||
            this.datafinancialInfo.financialInfo.street
          ) {
            this.showNotes = true;
            this.showNoteses = false;
          }
          this.loadinDadeList = false;
        })
        .catch((reason) => {
          this.loadinDadeList = false;
          this.loading = false;
        });
    },
    changeMonthYearNotes(data) {
      this.loading = true;

      REQUEST_SERVICE.requestContext("POST", UPDATE_INVOICES, this.context, {
        id: data.id,
        notes: data.notes,
        year: data.year,
        month: data.month,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_INVOICES:", response.data);

          this.loading = true;
          this.getPaymentInfo();

          swal("Aviso", response.data, "success");
        })
        .catch((reason) => {
          this.loading = false;

          swal({
            title: "Ops...",
            text: reason.response.data.erros[0].value,
            button: "Confirmar",
            icon: "error",
          });
        });
    },
    openModalHistoryPayment(data) {
      this.dataModalHistoryPayment = data;
      this.dataModalHistoryPayment.math = Math.floor(Math.random() * 500);

      $("#modalPaymentHistory").modal();
    },
    handleNoteChange(password) {
      switch (this.typeChangeNote) {
        case 1:
          if (this.generateNote !== null) this.createNote(password);
          break;
        case 2:
          if (this.cancelValueNote !== null) this.cancelNote(password);
          break;
        case 3:
          this.validateEditInvoice(password);
          break;
        case 4:
          this.validateInactiveSubscription(password);
          break;
        case 5:
          this.validateAnticipationSubscription(password);
          break;
        case 6:
          this.validateUpdatePaymentStatus(password);
          break;
        default:
          return;
      }
    },
    openModalUpdatePaymentStatus(n) {
      this.updateStatusPayment = {id: n.id};
      this.updateStatusForm = {
        paymentStatus: String(n.paymentStatusInt !== undefined ? n.paymentStatusInt : ''),
        notes: '',
        paidAt: null
      };
      this.updateStatusError = {};
      this.typeChangeNote = 6;
      this.titleModalPassword = 'Alterar status da fatura';
      $('#password-modal').modal();
    },
    validateUpdatePaymentStatus(password) {
      if (password !== 'forcePay') {
        swal("Aviso", "Senha incorreta!", "error");
        return;
      }
      $('#password-modal').modal('hide');
      $('#updatePaymentStatusModal').modal();
    },
    cleanUpdateStatusModal() {
      this.updateStatusPayment = null;
      this.updateStatusForm = {paymentStatus: '', notes: '', paidAt: null};
      this.updateStatusError = {};
    },
    submitUpdatePaymentStatus() {
      this.updateStatusError = {};
      const status = this.updateStatusForm.paymentStatus;
      if (status === '' || status === undefined) {
        this.updateStatusError.paymentStatus = 'Selecione o novo status.';
        return;
      }
      if (status === '1' && !this.updateStatusForm.paidAt) {
        this.updateStatusError.paidAt = 'Data do pagamento é obrigatória quando o status é Pago.';
        return;
      }
      this.loadingUpdatePaymentStatus = true;
      const body = {
        id: this.updateStatusPayment.id,
        paymentStatus: parseInt(this.updateStatusForm.paymentStatus, 10),
        notes: this.updateStatusForm.notes || '',
      };
      if (parseInt(this.updateStatusForm.paymentStatus, 10) === 1 && this.updateStatusForm.paidAt) {
        body.paidAt = moment(this.updateStatusForm.paidAt).toISOString();
      }
      REQUEST_SERVICE.requestContext('PUT', UPDATE_PAYMENT_HISTORY_STATUS, this.context, body)
        .then((response) => {
          this.loadingUpdatePaymentStatus = false;
          $('#updatePaymentStatusModal').modal('hide');
          this.cleanUpdateStatusModal();
          if (this.getPaymentInfo) this.getPaymentInfo();
          swal("Aviso", response.data && response.data.message ? response.data.message : "Status atualizado com sucesso.", "success");
        })
        .catch((reason) => {
          this.loadingUpdatePaymentStatus = false;
          const msg = reason.response && reason.response.data && reason.response.data.erros && reason.response.data.erros[0]
            ? reason.response.data.erros[0].value
            : (reason.response && reason.response.data && reason.response.data.message) || 'Erro ao atualizar status.';
          swal("Aviso", msg, "error");
        });
    },
    openCalendarUpdateStatusPaidAt() {
      if (this.$refs.programaticOpenUpdateStatusPaidAt) this.$refs.programaticOpenUpdateStatusPaidAt.showCalendar();
    },
    syncPaymentStatus(n) {
      if (!n || !n.id || this.syncingPaymentStatus[n.id]) return;
      this.$set(this.syncingPaymentStatus, n.id, true);
      REQUEST_SERVICE.requestContext('POST', SYNC_PAYMENT_STATUS, this.context, {id: n.id}).then((response) => {
        this.$set(this.syncingPaymentStatus, n.id, false);
        const data = this.parseGatewaySyncResponse(response);
        const message = data.message || "";
        switch (data.result) {
          case "synced":
            swal("Status atualizado", "De " + (data.oldStatusName || "-") + " para " + (data.newStatusName || "-") + " (" + (data.gateway || "gateway") + ")", "success");
            this.getPaymentInfo();
            break;
          case "unchanged":
            swal("Status já está atualizado", message, "info");
            break;
          case "conflict":
            swal("Atenção", message || "Há divergência entre o status no gateway e o status registrado.", "warning");
            break;
          case "notfound":
          case "nogateway":
          case "noinvoiceid":
            swal("Aviso", message || "Não foi possível localizar a cobrança no gateway.", "warning");
            break;
          default:
            swal("Aviso", message || "Não foi possível sincronizar o status.", "error");
        }
      }).catch((reason) => {
        this.$set(this.syncingPaymentStatus, n.id, false);
        swal("Aviso", this.gatewaySyncErrorMessage(reason), "error");
      });
    },
    cancelNote(password) {
      if (password) {
        let url = CANCEL_INVOICE2 + this.cancelValueNote.id;
        url += '?password=' + password;
        REQUEST_SERVICE.requestContext("GET", url, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT CANCEL_INVOICE:", response.data);

            swal("Aviso", response.data, "warning");
          })
          .catch((reason) => {
            swal("Aviso", "A senha está incorreta, tente novamente.");
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "Preencha a senha para continuar!", "error");
      }
    },
    createNote(password) {
      if (password) {
        let url = GENERATE_INVOICE + this.generateNote.id;
        url += '?password=' + password;
        url += '&emissionDate=' + moment(this.emissionDate).format("YYYY-MM-DD");

        REQUEST_SERVICE.requestContext("GET", url, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GENERATE_INVOICE:", response.data);

            this.generateNote.invoiceGenerated = true;
            this.generateNote.invoiceUri = "";

            swal("Aviso", response.data, "warning");
          })
          .catch((reason) => {
            swal("Aviso", "A senha está incorreta, tente novamente.");
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      } else {
        swal("Aviso", "Preencha a senha para continuar!", "error");
      }
    },
    getLinkNote(data) {
      let url = GET_INVOICE + data.id;

      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_INVOICE:", response.data);
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openDetail(id) {
      this.callCheckRequest = {
        random: Math.floor(Math.random() * 500),
        id: id,
        dataCompany: this.dataPaymentCompany,
      };

      $("#modalSubscriptionDetail").modal();
    },
    sendEmailFatura(id) {
      if (id) {
        if (!this.loadingFatura) {
          this.loadingFatura = true;
          let url = SEND_EMAIL_SUB + id;
          REQUEST_SERVICE.requestContext("GET", url, this.context)
            .then((response) => {
              UTIL_SERVICE.console("RESULT SEND_EMAIL_SUB:", response.data);

              swal("Aviso", response.data, "success");
              this.loadingFatura = false;
            })
            .catch((reason) => {
              this.loadingFatura = false;
              reason.response.data.erros.map((value, index) => {
                swal("Aviso", value.value, "error");
              });
            });
        }
      } else {
        swal("Aviso", "ID necessário para concluir operação.", "error");
      }
    },
    goToFunil() {
      let url = GET_DATA_TO_FUNIL + this.companyId;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_DATA_TO_FUNIL:", response.data);

          window.open(
            "/empresa-detalhes-funil/" +
            response.data.pipelineId +
            "/" +
            response.data.id,
            "_blank"
          );
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    getSubByCompany() {
      let url = GET_SUB_BY_COMPANY + this.companyId;

      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT GET_SUB_BY_COMPANY:", response.data);

          this.changeDataAssign.pricePerEmployee = this.formatPrice(response.data[0].pricePerEmployee);

          this.listDataSub = response.data;
          this.listDataSub.forEach(value => {
            value.totalCost = this.formatPrice(value.totalCost);
          })
        })
        .catch((reason) => {
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openBillet() {
      this.loadSubsPlan();
      this.getSubByCompany();
      this.showBillet = !this.showBillet;
      this.dataNovation.employeeRenewPrice = this.dataSubscription.pricePerEmployee

      if (!this.unit.length) {
        this.getSelectUnitMaster();
      }
    },
    openEmployers() {
      this.showEmployers = !this.showEmployers;

      if (!this.dataCompany) {
        this.getInfo();
      }
    },
    openDataPayment() {
      this.showPayment = !this.showPayment;
    },
    openDataNormalization() {
      this.showNormalization = !this.showNormalization;
    },
    openTestPeriod() {
      this.showTestPeriod = !this.showTestPeriod;
    },
    openDataBackoffice() {
      this.showBackoffice = !this.showBackoffice;
    },
    openDataPlans() {
      this.showPlans = !this.showPlans;
    },
    openDataNotes() {
      this.showNotes = !this.showNotes;
    },
    loadSubsPlan() {
      if (!this.listPlansType.length) {
        REQUEST_SERVICE.requestContext("GET", GET_SUB_PLANS2, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT GET_SUB_PLANS2:", response.data);

            this.listPlansType = [];
            response.data.map((v, index) => {
              this.listPlansType.push(v);
            });
          })
          .catch((reason) => {
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      }
    },
    openDataHistory() {
      this.showHistory = !this.showHistory;
    },
    openHistory() {
      this.showHistoryPlan = !this.showHistoryPlan;
    },
    openDataNps() {
      this.showNps = !this.showNps;

      if (this.dataNps.getRequest) {
        this.getNpsCompany();
      }
    },
    openDataFeatures() {
      this.showFeatures = !this.showFeatures;

      if (this.showFeatures) {
        this.getListFeatures();
      }
    },
    openDataBenefits() {
      this.showBenefits = !this.showBenefits;
    },
    openDataMarqIA() {
      this.showMarqIA = !this.showMarqIA;
      if (this.showMarqIA) {
        this.getAICredits();
      }
    },
    getAICredits() {
      this.loadingMarqIA = true;
      const url = GET_AI_CREDITS + this.companyId;
      axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          companyId: this.companyId,
        }
      }).then((response) => {
        this.marqIACredits = response.data;
        this.loadingMarqIA = false;
      }).catch(() => {
        this.loadingMarqIA = false;
        swal("Aviso", "Erro ao buscar créditos MarQ IA.", "error");
      });
    },
    openAddCreditsModal() {
      this.marqIAQuantityToAdd = null;
      this.marqIAUnlimited = false;
      $("#modal-add-ai-credits").modal();
    },
    confirmAddCredits() {
      this.loadingAddCredits = true;
      const credits = this.marqIAUnlimited ? 0 : this.marqIAQuantityToAdd;
      const userId = JSON.parse(window.localStorage.getItem("mamUserMasterInfo")).id;
      const url = ADD_AI_CREDITS + "?companyId=" + this.companyId + "&quantity=" + credits;
      axios.post(url, {}, {
        headers: {
          'Content-Type': 'application/json',
          companyId: this.companyId,
          uID: userId,
        }
      })
        .then(() => {
          this.loadingAddCredits = false;
          $("#modal-add-ai-credits").modal("hide");
          swal("Sucesso!", "Créditos adicionados com sucesso.", "success");
          this.getAICredits();
        })
        .catch(() => {
          this.loadingAddCredits = false;
          swal("Aviso", "Erro ao adicionar créditos. Tente novamente.", "error");
        });
    },
    openValidateBenefitsModal() {
      this.benefitsModalAction = 'benefits';
      this.modalPasswordBenefits = "";
      document.querySelector("[id='input-password-benefits']").value = "";
      $("#password-modal-benefits").modal();
    },
    openValidatePixOutModal() {
      this.benefitsModalAction = 'pixout';
      this.modalPasswordBenefits = "";
      document.querySelector("[id='input-password-benefits']").value = "";
      $("#password-modal-benefits").modal();
    },
    passwordValidationBenefits() {
      if (this.modalPasswordBenefits === "beneflex@k") {
        $("#password-modal-benefits").toggle("");

        if (this.benefitsModalAction === 'pixout') {
          this.enablePixOut();
          return;
        }

        swal("Atenção", {
          text: 'Alterar status da empresa para:',
          icon: 'warning',
          className: 'swal-password',
          buttons: {
            marq: {
              text: "Marqponto",
              value: 0,
            },
            benefits: {
              text: "Benefícios",
              value: 1,
            },
            marqbenefits: {
              text: "Marq+Beneficios",
              value: 2,
            },
          },
        })
          .then((value) => {

            // values 1 and two are the beneflex values, when the user select one of those it will open a modal to select the card distributor
            if (value === 1 || value === 2) {
              this.showSelectAlert(value);
            } else if (value === 0) {
              this.changeBenefitsStatus(0, 0);
            }
            // switch (value) {
            //   case 0:
            //   this.changeBenefitsStatus(0);
            //     break;

            //   case 1:
            //     // this.changeBenefitsStatus(1);
            //     break;

            //   case 2:
            //     // this.changeBenefitsStatus(2);
            //     break;

            //   default:
            //     swal("Cancelado", "", "error");

            // }
          });
      } else {
        $("#password-modal-benefits").toggle("");

        swal("Aviso", "Senha Errada!", "error");
        this.modalPasswordBenefits = "";
      }
    },
    showSelectAlert(previousValue) {
      let selectedValue = 1;

      // Create the content element directly
      const contentDiv = document.createElement('div');
      contentDiv.innerHTML = `
          <select
            id="valueSelect"
            style="
              padding: 8px 16px;
              border-radius: 4px;
              border: 1px solid #ddd;
              font-size: 16px;
              width: 200px;
            "
          >
            <option value=1>Swap</option>
            <option value=2>Dock</option>
          </select>
      `;

      // Add event listener before showing the alert
      const backButton = contentDiv.querySelector('#backButton');
      if (backButton) {
        backButton.onclick = () => {
          swal.close();
          // this.showSelectAlert();
        };
      }

      const select = contentDiv.querySelector('#valueSelect');
      if (select) {
        select.onchange = (e) => {
          selectedValue = e.target.value;
        };
      }

      swal({
        title: "Selecione um fornecedor",
        content: contentDiv,
        buttons: {
          cancel: {
            text: "Cancelar",
            value: null,
            visible: true,
          },
          confirm: {
            text: "Confirmar",
            value: true,
          }
        }
      })
        .then(willConfirm => {
          if (willConfirm) {
            this.changeBenefitsStatus(previousValue, Number(selectedValue))
          }
        });
    },

    changeBenefitsStatus(status, cardSupplier) {
      this.loadingBenefits = true;

      let statusStr = '';
      const obj = {
        companyId: this.$route.params.idCompany,
        moduleType: status,
        cardSupplier: cardSupplier,
      };

      if (status === 0) {
        statusStr = 'Status alterado para Marqponto'
      }

      if (status === 1) {
        statusStr = 'Status alterado para Benefícios'
      }

      if (status === 2) {
        statusStr = 'Status alterado para Marq+Benefícios'
      }

      REQUEST_SERVICE.requestContext("POST", ENABLE_BENEFITS, this.context, obj)
        .then((response) => {
          UTIL_SERVICE.console("RESULT ENABLE_BENEFITS:", response.data);

          this.isBenefitsWarning = !this.isBenefitsWarning;
          this.loadingBenefits = false;
          swal("Sucesso!", "Status alterado para " + statusStr, "success");

          this.showBenefits = !this.showBenefits;
          this.getPaymentInfo();
        })
        .catch((reason) => {
          this.loadingBenefits = false;
          swal("Aviso", "Ocorreu um erro ao realizar a requisição. Entre em contato com o time de benefícios.", "error");
        });
    },
    enablePixOut() {
      this.loadingPixOut = true;
      const url = ENABLE_PIX_OUT + "?companyId=" + this.companyId;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT ENABLE_PIX_OUT:", response.data);
          this.loadingPixOut = false;
          const enabled = response.data;
          const message = enabled ? "Pix-Out habilitado com sucesso." : "Pix-Out desabilitado com sucesso.";
          swal("Sucesso!", message, "success");
        })
        .catch(() => {
          this.loadingPixOut = false;
          swal("Aviso", "Ocorreu um erro ao atualizar o Pix-Out. Tente novamente.", "error");
        });
    },
    getListFeatures() {
      this.loadingFeatures = true;
      const url = GET_FEATURES + `?companyId=${this.companyId}`;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT FEATURES_ALL:", response.data);

          if (response.data.find((value) => value.name === 'Controle de Jornada')) {
            const features = response.data.find((value) => value.name === 'Controle de Jornada');
            this.moduleJourneyControl = features.childs.filter((value) => value.name !== null);
          }

          if (response.data.find((value) => value.name === 'Departamento Pessoal')) {
            const features = response.data.find((value) => value.name === 'Departamento Pessoal');
            this.modulePersonalDepartment = features.childs.filter((value) => value.name !== null);
          }

          if (response.data.find((value) => value.name === 'Desenvolvimento de Pessoas')) {
            const features = response.data.find((value) => value.name === 'Desenvolvimento de Pessoas');
            this.modulePeopleDevelopment = features.childs.filter((value) => value.name !== null);
          }

          if (response.data.find((value) => value.name === 'Comunicação e Cultura')) {
            const features = response.data.find((value) => value.name === 'Comunicação e Cultura');
            this.moduleCommunicationAndCulture = features.childs.filter((value) => value.name !== null);
          }

          if (response.data.find((value) => value.name === 'Benefícios Corporativos')) {
            const features = response.data.find((value) => value.name === 'Benefícios Corporativos');
            this.moduleCorporateBenefits = features.childs.filter((value) => value.name !== null);
          }

          if (response.data.find((value) => value.name === 'Funcionalidades extras')) {
            const features = response.data.find((value) => value.name === 'Funcionalidades extras');
            this.moduleExtra = features.childs.filter((value) => value.name !== null);
          }

          this.loadingFeatures = false;
        })
        .catch((reason) => {
          console.log(reason)
          this.loadingFeatures = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openValueFeature(f) {
      this.dataModalFeature = f;
      this.dataModalFeature.math = Math.floor(Math.random() * 500);

      $("#modalFeatureEdit").modal();
    },
    addFeature(f) {
      this.loadingFeatures = true;
      console.log('FEATURE', f)

      REQUEST_SERVICE.requestContext("POST", FEATURE_ALL, this.context, {
        featureId: f.id,
        price: f.price,
        notes: f.notes,
        companyId: this.companyId,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT FEATURE_ALL ADD:", response.data);
          [
            ...this.moduleJourneyControl,
            ...this.modulePersonalDepartment,
            ...this.modulePeopleDevelopment,
            ...this.moduleCommunicationAndCulture,
            ...this.moduleCorporateBenefits,
            ...this.moduleExtra,
          ].find((v) => v.id === f.id).enabled = true;
          this.loadingFeatures = false;
          swal("Aviso", "Permissão adicionada com sucesso.", "success");
        })
        .catch((reason) => {
          this.loadingFeatures = false;
          swal({
            title: "Ops...",
            text: reason.response.data.erros[0].value,
            button: "Confirmar",
            icon: "error",
          });
        });
    },
    removeFeature(f) {
      REQUEST_SERVICE.requestContext(
        "DELETE",
        FEATURE_ALL + `/${this.companyId}/${f.id}`,
        this.context
      )
        .then((response) => {
          UTIL_SERVICE.console("5 DELETE:", response.data);

          f.enabled = false;
          this.loadingFeatures = false;
          swal("Aviso", "Permissão removida com sucesso.", "success");
        })
        .catch((reason) => {
          this.loadingFeatures = false;
          swal({
            title: "Ops...",
            text: reason.response.data.erros[0].value,
            button: "Confirmar",
            icon: "error",
          });
        });
    },
    checkAddOrRemoveFeature(v) {
      console.log(v)
      if (v.enabled) {
        this.loadingFeatures = true;
        this.removeFeature(v);
      } else {
        this.openValueFeature(v);
      }
    },
    getNpsCompany() {
      if (!this.loadingNps) {
        this.loadingNps = true;
        REQUEST_SERVICE.requestContext(
          "GET",
          `${COMPANY_HOW_HOT}${this.companyId}`,
          this.context
        )
          .then((response) => {
            UTIL_SERVICE.console("RESULT COMPANY_HOW_HOT:", response.data);

            this.dataNps = response.data;
            this.loadingNps = false;
          })
          .catch((reason) => {
            this.loadingNps = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      }
    },
    getInfo() {
      if (!this.loadingListEmployee) {
        this.loadingListEmployee = true;
        let url = POINT_REPORT_DETAIL + "?t=kkkk";
        url += "&pageQtd=" + this.qtdEmployer;
        url += "&i=" + this.$route.params.idCompany;

        REQUEST_SERVICE.requestContext("GET", url, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT POINT_REPORT_DETAIL:", response.data);

            this.dataCompany = response.data;

            this.loadingListEmployee = false;
          })
          .catch((reason) => {
            this.loadingListEmployee = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      }
    },
    changeProfile(value) {
      if (value >= 100) return 'A';
      if (value >= 50 && value <= 99) return 'B';
      if (value >= 21 && value <= 49) return 'C';
      if (value >= 11 && value <= 20) return 'D';
      if (value <= 10) return 'E';
    },
    getPaymentInfo() {
      this.loading = true;
      let url =
        COMPANY_PAYMENT_INFO + "?t=kkkk&i=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_PAYMENT_INFO:", response.data);

          this.dataPaymentCompany = response.data;

          if (this.dataPaymentCompany.isActive) {
            this.isActive = 0;
          } else {
            this.isActive = 1;
          }

          if (response.data.company.notes)
            this.notes = response.data.company.notes;

          if (response.data.subscriptions)
            this.subscriptions = response.data.subscriptions;

          if (response.data.subscription)
            this.dataSubscription = response.data.subscription;

          this.userAdminId = response.data.userAdminId;
          this.userAdminName = response.data.userAdminName;
          this.valueCurrentPlan = response.data.companyNewPlan
          this.companyLocale = response.data.locale;
          switch (true) {
            case response.data.locale === 0:
              this.companyLocaleName = 'Brasil';
              break;
            case response.data.locale === 1:
              this.companyLocaleName = 'Portugal';
              break;
            case response.data.locale === 2:
              this.companyLocaleName = 'Espanha';
              break;
            case response.data.locale === 3:
              this.companyLocaleName = 'Estados Unidos';
              break;
            default:
              this.companyLocaleName = 'Não informado';
          }

          this.isBlock = response.data.company.isBlockedMarqboard;
          this.isPauseEnabled = response.data.company.isUsingPause;
          this.isWorkshiftImportEnabled =
            response.data.company.isWorkshiftImportEnabled;
          this.isBalanceEnabled = response.data.company.isBalanceEnabled;
          this.isUserImportEnabled = response.data.company.isUserImportEnabled;
          this.isUsingFaceRecognition =
            response.data.company.isUsingFaceRecognition;
          this.isCalendarEnabled = response.data.company.isCalendarEnabled;
          this.backofficev2Enable = response.data.usingV2;

          this.needPhotoToMarQTab = response.data.needPhotoToMarQTab;
          this.needLocationToMarQTab = response.data.needLocationToMarQTab;
          this.isUsingChat = response.data.isUsingChat;

          this.isUsingRefund = response.data.isUsingRefund;
          this.isUsingOnboarding = response.data.isUsingOnboarding;
          this.isUsingJobs = response.data.isUsingOpportunityPortal;
          this.showDPMenu = response.data.showDPMenu;
          this.valueCurrentProfile = response.data.companyTier;

          this.isUsingCheckin = response.data.isUsingCheckin;

          this.setValueTypesMotive()
          this.getDadeFinancial();
          this.loading = false;
        })
        .catch((reason) => {
          this.loading = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeUploadScale() {
      this.loadingScale = true;
      let url = WS_IMPORT + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT WS_IMPORT:", response.data);

          this.isWorkshiftImportEnabled = !this.isWorkshiftImportEnabled;
          this.loadingScale = false;
        })
        .catch((reason) => {
          this.loadingScale = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeNeedPhotoToMarQTab() {
      this.loadingPhotoTab = true;
      let url =
        NEED_PHOTO_MARQTAB + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_SHOW_BALANCE:", response.data);

          this.needPhotoToMarQTab = !this.needPhotoToMarQTab;
          this.loadingPhotoTab = false;
        })
        .catch((reason) => {
          this.loadingPhotoTab = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeNeedLocationToMarQTab() {
      this.loadingLocationTab = true;
      let url =
        NEED_LOCATION_MARQTAB + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_SHOW_BALANCE:", response.data);

          this.needLocationToMarQTab = !this.needLocationToMarQTab;
          this.loadingLocationTab = false;
        })
        .catch((reason) => {
          this.loadingLocationTab = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsCalendarEnabled() {
      this.loadingCalendar = true;
      let url =
        SET_CALENDAR_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_SHOW_BALANCE:", response.data);

          this.isCalendarEnabled = !this.isCalendarEnabled;
          this.loadingCalendar = false;
        })
        .catch((reason) => {
          this.loadingCalendar = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changePauseEnabled() {
      this.loadingPause = true;
      let url = SET_PAUSE + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_PAUSE:", response.data);

          this.isPauseEnabled = !this.isPauseEnabled;
          this.loadingPause = false;
        })
        .catch((reason) => {
          this.loadingPause = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsChatEnabled() {
      this.loadingChat = true;
      let url = SET_CHAT_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_CHAT_ENABLED:", response.data);

          this.isUsingChat = !this.isUsingChat;
          this.loadingChat = false;
        })
        .catch((reason) => {
          this.loadingChat = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsRefundEnabled() {
      this.loadingRefund = true;
      let url =
        SET_REFUND_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_REFUND_ENABLED:", response.data);

          this.isUsingRefund = !this.isUsingRefund;
          this.loadingRefund = false;
        })
        .catch((reason) => {
          this.loadingRefund = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsOnboardingEnabled() {
      this.loadingOnboarding = true;
      let url =
        SET_ONBOARDING_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_ONBOARDING_ENABLED:", response.data);

          this.isUsingOnboarding = !this.isUsingOnboarding;
          this.loadingOnboarding = false;
        })
        .catch((reason) => {
          this.loadingOnboarding = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsJobEnabled() {
      this.loadingJob = true;
      let url = SET_JOB_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_JOB_ENABLED:", response.data);

          this.isUsingJobs = !this.isUsingJobs;
          this.loadingJob = false;
        })
        .catch((reason) => {
          this.loadingJob = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsCheckinEnabled() {
      this.loadingCheckin = true;
      let url =
        SET_CHECKIN_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_CHECKIN_ENABLED:", response.data);

          this.isUsingCheckin = !this.isUsingCheckin;
          this.loadingCheckin = false;
        })
        .catch((reason) => {
          this.loadingCheckin = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIsDPEnabled() {
      this.loadingDp = true;
      let url = SET_DP_ENABLED + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT SET_DP_ENABLED:", response.data);

          this.showDPMenu = !this.showDPMenu;
          this.loadingDp = false;
        })
        .catch((reason) => {
          this.loadingDp = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeBalanceEnabled() {
      this.loadingBalance = true;
      let url =
        COMPANY_SHOW_BALANCE + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT COMPANY_SHOW_BALANCE:", response.data);

          this.isBalanceEnabled = !this.isBalanceEnabled;
          this.loadingBalance = false;
        })
        .catch((reason) => {
          this.loadingBalance = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeUploadEmployer() {
      this.loadingEmp = true;
      let url = USER_IMPORT + "?t=kkkk&c=" + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT USER_IMPORT:", response.data);

          this.isUserImportEnabled = !this.isUserImportEnabled;
          this.loadingEmp = false;
        })
        .catch((reason) => {
          this.loadingEmp = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeFaceRecognition() {
      this.loadingFace = true;
      let url =
        CORE_PERSON_GROUP +
        "?i=" +
        JSON.parse(window.localStorage.getItem("mamUserMasterInfo")).id +
        "&companyId=" +
        this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CORE_PERSON_GROUP:", response.data);

          swal("Aviso", response.data, "success");
          this.isUsingFaceRecognition = !this.isUsingFaceRecognition;
          this.loadingFace = false;
        })
        .catch((reason) => {
          this.loadingFace = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeBlock() {
      this.loadingBloq = true;
      let url = CHANGE_BLOCK + this.dataPaymentCompany.company.id;
      REQUEST_SERVICE.requestContext("PUT", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_BLOCK:", response.data);
          this.loadingBloq = false;
          this.isBlock = this.isBlock = !this.isBlock;
          this.dataPaymentCompany.company.isBlockedMarqboard = this.isBlock;

          swal("Aviso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingBloq = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    clientOnboarding() {
      this.loadingClientOnboarding = true;

      let url = CLIENT_SET_ONBOARDING + this.$route.params.idCompany;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT CLIENT_SET_ONBOARDING:", response.data);
          this.loadingClientOnboarding = false;

          swal("Aviso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingClientOnboarding = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openTotalPlanEmployee(value) {
      this.dataPlanType = {};
      this.dataPlanType.plan = value;

      $("#modalPlanType").modal();
    },
    makeFree() {
      this.loadingFree = true;
      let url = UPDATE_COMPANY_FREE + "?i=" + this.companyId + "&plan=1";
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_COMPANY_FREE:", response.data);
          this.loadingFree = false;
          this.dataPaymentCompany.isFree = true;

          swal("Aviso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingFree = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    addDays() {
      this.loadingDays = true;
      let url =
        UPDATE_EXPIRATION +
        "?days=" +
        this.days +
        "&i=" +
        this.dataPaymentCompany.company.id;
      REQUEST_SERVICE.requestContext("GET", url, this.context)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_EXPIRATION:", response.data);
          this.loadingDays = false;

          swal("Aviso", response.data, "success");

          this.getPaymentInfo();
        })
        .catch((reason) => {
          this.loadingDays = false;
          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    sendNovation() {
      this.loadingNovation = true

      this.errorNovation.ePlanType = "";
      this.errorNovation.totalEmployees = "";
      this.errorNovation.priceToCharge = "";
      this.errorNovation.recurringPrice = "";
      this.errorNovation.startAt = "";
      this.errorNovation.planId = "";
      this.errorNovation.employeeRenewPrice = "";

      if (
        this.dataNovation.ePlanType &&
        this.dataNovation.totalEmployees &&
        this.dataNovation.startAt &&
        this.dataNovation.planId &&
        this.dataNovation.priceToCharge !== "R$ 0.00" &&
        this.dataNovation.recurringPrice !== "R$ 0.00" &&
        this.dataNovation.employeeRenewPrice !== "R$ 0.00"
      ) {
        let objToSend = {
          companyId: this.$route.params.idCompany,
          ePlanType: this.dataNovation.ePlanType,
          planId: this.dataNovation.planId,
          totalEmployees: this.dataNovation.totalEmployees,
          id: this.subscriptionId2.id,
          renew: true,
          pricePerEmployee: this.dataNovation.employeeRenewPrice
        };

        objToSend.startAt = moment(this.dataNovation.startAt).format(
          "YYYY-MM-DD"
        );
        objToSend.priceToCharge = this.dataNovation.priceToCharge.replace(
          "R$ ",
          ""
        );
        objToSend.recurringPrice = this.dataNovation.recurringPrice.replace(
          "R$ ",
          ""
        );
        objToSend.pricePerEmployee = this.dataNovation.employeeRenewPrice.replace(
          "R$ ",
          ""
        );

        UTIL_SERVICE.console("data send:", objToSend);
        REQUEST_SERVICE.requestContext(
          "PUT",
          CHANGE_ASSIGN_HISTORY,
          this.context,
          objToSend
        )
          .then((response) => {
            UTIL_SERVICE.console(
              "RESULT CHANGE_ASSIGN_HISTORY:",
              response.data
            );

            this.loadingNovation = false
            swal("Successo!", "Renovação feita com sucesso", "success");

            this.getPaymentInfo();

            this.showBillet = !this.showBillet;
            this.dataNovation.renew = !this.dataNovation.renew;
            this.dataNovation.ePlanType = '';
            this.dataNovation.planId = '';
            this.dataNovation.priceToCharge = '';
            this.dataNovation.recurringPrice = '';
            this.dataNovation.startAt = '';
            this.dataNovation.totalEmployees = '';

          })
          .catch((reason) => {
            this.loadingNovation = false

            swal({
              title: "Ops...",
              text: reason.response.data.erros[0].value,
              button: "Confirmar",
              icon: "error",
            });
          });
      } else {
        swal({
          title: "Ops...",
          text: "Preencha todos os campos",
          button: "Confirmar",
          icon: "error",
        });

        if (!this.dataNovation.ePlanType)
          this.errorNovation.ePlanType = "Valor obrigatório.";

        if (!this.dataNovation.totalEmployees)
          this.errorNovation.totalEmployees = "Valor obrigatório.";

        if (!this.dataNovation.startAt)
          this.errorNovation.startAt = "Valor obrigatório.";

        if (this.dataNovation.priceToCharge === "R$ 0.00")
          this.errorNovation.priceToCharge = "Valor obrigatório.";

        if (this.dataNovation.recurringPrice === "R$ 0.00")
          this.errorNovation.recurringPrice = "Valor obrigatório.";
      }
    },
    changeAssign() {
      this.errorPrice3.subscriptionId = "";
      this.errorPrice3.price = "";
      this.errorPrice3.expireAt = "";
      this.errorPrice3.pricePerEmployee = "";

      if (
        this.changeDataAssign.subscriptionId &&
        this.changeDataAssign.expireAt &&
        this.changeDataAssign.price !== "R$ 0.00" &&
        this.changeDataAssign.pricePerEmployee !== "R$ 0.00"
      ) {
        if (!this.loadingChangeAssign) {
          this.loadingChangeAssign = true;

          let objToSend = {
            companyId: this.$route.params.idCompany,
            subscriptionId: this.changeDataAssign.subscriptionId,
            notes: this.changeDataAssign.notes,
          };

          objToSend.expireAt = moment(this.changeDataAssign.expireAt).format(
            "YYYY-MM-DD"
          );
          objToSend.price = this.changeDataAssign.price.replace("R$ ", "");
          objToSend.pricePerEmployee =
            this.changeDataAssign.pricePerEmployee.replace("R$ ", "");
          UTIL_SERVICE.console("data send:", objToSend);
          REQUEST_SERVICE.requestContext(
            "PUT",
            CHANGE_ASSIGN_HISTORY,
            this.context,
            objToSend
          )
            .then((response) => {
              UTIL_SERVICE.console(
                "RESULT CHANGE_ASSIGN_HISTORY:",
                response.data
              );

              this.loadingChangeAssign = false;
              swal("Aviso", "Assinatura alterada com sucesso", "success");
            })
            .catch((reason) => {
              this.loadingChangeAssign = false;

              swal({
                title: "Ops...",
                text: reason.response.data.erros[0].value,
                button: "Confirmar",
                icon: "error",
              });
            });
        }
      } else {
        if (!this.changeDataAssign.subscriptionId)
          this.errorPrice3.subscriptionId = "Valor obrigatório.";

        if (!this.changeDataAssign.pricePerEmployee === "R$ 0.00")
          this.errorPrice3.pricePerEmployee = "Valor obrigatório.";

        if (!this.changeDataAssign.expireAt)
          this.errorPrice3.expireAt = "Valor obrigatório.";

        if (this.changeDataAssign.price === "R$ 0.00")
          this.errorPrice3.price = "Valor obrigatório.";
      }
    },
    /**
     * Pagamento externo (9) registra o que ja foi pago, nao emite boleto: so
     * exige valor. Os outros tipos geram boleto e respeitam o minimo. Usado
     * no envio (sendAssign) e no watcher de dataAssign.price, para os dois
     * concordarem sobre qual mensagem mostrar.
     */
    priceErrorFor(value) {
      return this.dataAssign.subscriptionPaymentHistoryType === "9"
        ? (boletoPriceError(value) === "Valor obrigatório." ? "Valor obrigatório." : "")
        : boletoPriceError(value);
    },
    sendAssign() {
      this.errorPrice2.subscriptionId = "";
      this.errorPrice2.price = "";
      this.errorPrice2.month = "";
      this.errorPrice2.year = "";
      this.errorPrice2.expireAt = "";
      this.errorPrice2.invoiceDate = "";
      this.errorPrice2.notes = "";
      this.errorPrice2.subscriptionPaymentHistoryType = "";
      this.errorPrice2.paymentDate = "";
      this.errorPrice2.bankSlipUri = "";

      const priceError = this.priceErrorFor(this.dataAssign.price);

      if (
        this.dataAssign.generateInvoice === "true" &&
        !this.dataAssign.invoiceDate
      ) {
        this.errorPrice2.invoiceDate = "Valor obrigatório.";
        return;
      }

      // Validações específicas para Pagamento Externo (tipo 9)
      if (this.dataAssign.subscriptionPaymentHistoryType === "9") {
        if (!this.dataAssign.paymentDate) {
          this.errorPrice2.paymentDate = "Valor obrigatório.";
          return;
        }

        // Validação para modo manual
        if (this.dataAssign.paymentUploadMode === "manual") {
          if (!this.dataAssign.bankSlipUri) {
            this.errorPrice2.bankSlipUri = "Valor obrigatório.";
            return;
          }
          // Validar formato de URL
          let regex = /^(http|https|Http|Https|rtsp|Rtsp):\/\//i;
          let validate = regex.test(this.dataAssign.bankSlipUri);
          if (!validate) {
            this.errorPrice2.bankSlipUri = "Preencha um link válido!";
            return;
          }
        }

        // Validação para modo upload
        if (this.dataAssign.paymentUploadMode === "upload") {
          if (!this.selectedPaymentFile && !this.dataAssign.bankSlipUri) {
            this.errorPrice2.bankSlipUri = "Por favor, selecione um arquivo para upload.";
            return;
          }
        }
      }

      if (
        this.dataAssign.subscriptionId &&
        this.dataAssign.price &&
        this.dataAssign.month &&
        this.dataAssign.year &&
        this.dataAssign.expireAt &&
        this.dataAssign.subscriptionPaymentHistoryType &&
        this.dataAssign.notes.length >= 3 &&
        !priceError
      ) {
        if (!this.loadingAssign) {
          this.loadingAssign = true;

          // Se for tipo 9 e modo upload, fazer upload primeiro (se ainda não foi feito)
          if (this.dataAssign.subscriptionPaymentHistoryType === "9" &&
            this.dataAssign.paymentUploadMode === "upload" &&
            this.selectedPaymentFile &&
            !this.dataAssign.bankSlipUri) {
            return this.uploadPaymentFile()
              .then(() => {
                // Após upload bem-sucedido, continuar com o envio
                this.submitAssign();
              })
              .catch(() => {
                // Erro já foi tratado no uploadPaymentFile
                this.loadingAssign = false;
              });
          }

          // Validação final antes de enviar
          if (this.dataAssign.subscriptionPaymentHistoryType === "9") {
            if (!this.dataAssign.paymentDate) {
              this.errorPrice2.paymentDate = "Valor obrigatório.";
              this.loadingAssign = false;
              return;
            }
            if (!this.dataAssign.bankSlipUri) {
              this.errorPrice2.bankSlipUri = "Valor obrigatório.";
              this.loadingAssign = false;
              return;
            }
          }

          // Tipo Feature (upsell): antes de gerar, escolher as funcionalidades
          // que a empresa vai pagar. A escolha e opcional.
          if (this.dataAssign.subscriptionPaymentHistoryType === "4") {
            this.loadingAssign = false;
            this.dataModalUpsellFeatures = {
              context: this.context,
              math: Math.floor(Math.random() * 500),
            };
            $("#modalUpsellFeatures").modal();
            return;
          }

          this.submitAssign();
        }
      } else {
        if (!this.dataAssign.subscriptionId)
          this.errorPrice2.subscriptionId = "Valor obrigatório.";

        if (!this.dataAssign.notes || this.dataAssign.notes.length < 3)
          this.errorPrice2.notes = "Valor obrigatório.";

        if (!this.dataAssign.subscriptionPaymentHistoryType)
          this.errorPrice2.subscriptionPaymentHistoryType =
            "Valor obrigatório.";

        if (!this.dataAssign.month)
          this.errorPrice2.month = "Valor obrigatório.";

        if (!this.dataAssign.year) this.errorPrice2.year = "Valor obrigatório.";

        if (!this.dataAssign.expireAt)
          this.errorPrice2.expireAt = "Valor obrigatório.";

        if (this.dataAssign.subscriptionPaymentHistoryType === "9" && !this.dataAssign.paymentDate)
          this.errorPrice2.paymentDate = "Valor obrigatório.";

        if (this.dataAssign.generateInvoice === "true" && !this.dataAssign.invoiceDate)
          this.errorPrice2.invoiceDate = "Valor obrigatório.";

        if (priceError) this.errorPrice2.price = priceError;
      }
    },
    onUpsellFeaturesSelected(featureIds) {
      this.loadingAssign = true;
      this.submitAssign(featureIds);
    },
    submitAssign(featureIds) {
      let objToSend = {
        companyId: this.$route.params.idCompany,
        subscriptionId: this.dataAssign.subscriptionId,
        month: parseInt(this.dataAssign.month),
        year: parseInt(this.dataAssign.year),
        notes: this.dataAssign.notes,
        subscriptionPaymentHistoryType: this.dataAssign.subscriptionPaymentHistoryType,
      };

      if (this.dataAssign.invoiceDate)
        objToSend.invoiceDate = moment(this.dataAssign.invoiceDate).format(
          "YYYY-MM-DD"
        );

      if (this.dataAssign.invoiceNotes)
        objToSend.invoiceNotes = this.dataAssign.invoiceNotes;

      objToSend.expireAt = moment(this.dataAssign.expireAt).format(
        "YYYY-MM-DD"
      );
      objToSend.price = this.dataAssign.price.replace("R$ ", "");

      if (this.dataAssign.generateInvoice === "true")
        objToSend.generateInvoice = true;

      // Campos específicos para Pagamento Externo (tipo 9)
      if (this.dataAssign.subscriptionPaymentHistoryType === "9") {
        objToSend.paymentDate = moment(this.dataAssign.paymentDate).format(
          "YYYY-MM-DD"
        );
        objToSend.bankSlipUri = this.dataAssign.bankSlipUri;
      }

      if (featureIds && featureIds.length) objToSend.featureIds = featureIds;

      UTIL_SERVICE.console("data send:", objToSend);
      REQUEST_SERVICE.requestContext(
        "POST",
        ASSIGN_HISTORY,
        this.context,
        objToSend
      )
        .then((response) => {
          UTIL_SERVICE.console("RESULT ASSIGN_HISTORY:", response.data);

          this.loadingAssign = false;

          // Limpar campos após sucesso
          this.dataAssign.paymentUploadMode = "manual";
          this.dataAssign.bankSlipUri = "";
          this.dataAssign.paymentDate = "";
          this.selectedPaymentFile = null;

          swal(
            "Aviso",
            "Assinatura gerada com sucesso\n" + (response.data.bankSlipUri || ""),
            "success"
          );
        })
        .catch((reason) => {
          this.loadingAssign = false;

          swal({
            title: "Ops...",
            text: reason.response.data.erros[0].value,
            button: "Confirmar",
            icon: "error",
          });
        });
    },
    sendValue() {
      this.errorPrice.planType = "";
      this.errorPrice.priceToCharge = "";
      this.errorPrice.recurringPrice = "";
      this.errorPrice.expireAt = "";
      this.errorPrice.recurringDay = "";
      this.errorPrice.startAt = "";
      this.errorPrice.totalEmployee = "";
      this.errorPrice.pricePerEmployee = "";
      this.errorPrice.invoiceDate = "";
      this.errorPrice.planId = "";
      this.errorPrice.month = "";

      if (
        this.dataPrice.generateInvoice === "true" &&
        !this.dataPrice.invoiceDate
      ) {
        this.errorPrice.invoiceDate = "Valor obrigatório.";
        return;
      }

      if (
        this.dataPrice.planId &&
        this.dataPrice.month &&
        this.dataPrice.planType &&
        this.dataPrice.startAt &&
        this.dataPrice.expireAt &&
        this.dataPrice.recurringDay &&
        this.dataPrice.totalEmployee &&
        this.dataPrice.priceToCharge !== "R$ 0.00" &&
        this.dataPrice.recurringPrice !== "R$ 0.00" &&
        this.dataPrice.pricePerEmployee !== "R$ 0.00"
      ) {
        if (!this.loadingPayment) {
          this.loadingPayment = true;

          let objToSend = {
            companyId: this.$route.params.idCompany,
            planType: this.dataPrice.planType,
            recurringDay: this.dataPrice.recurringDay,
            totalEmployee: this.dataPrice.totalEmployee,
            businessUnitId: null,
          };

          if (this.dataPrice.invoiceDate)
            objToSend.invoiceDate = moment(this.dataPrice.invoiceDate).format(
              "YYYY-MM-DD"
            );

          if (this.dataPrice.businessUnitId)
            objToSend.businessUnitId = this.dataPrice.businessUnitId;

          if (this.dataPrice.invoiceNotes)
            objToSend.invoiceNotes = this.dataPrice.invoiceNotes;

          if (this.dataPrice.planId) objToSend.planId = this.dataPrice.planId;

          if (this.dataPrice.month) objToSend.month = this.dataPrice.month;

          objToSend.startAt = moment(this.dataPrice.startAt).format(
            "YYYY-MM-DD"
          );
          objToSend.expireAt = moment(this.dataPrice.expireAt).format(
            "YYYY-MM-DD"
          );
          objToSend.priceToCharge = this.dataPrice.priceToCharge.replace(
            "R$ ",
            ""
          );
          objToSend.recurringPrice = this.dataPrice.recurringPrice.replace(
            "R$ ",
            ""
          );
          objToSend.pricePerEmployee = this.dataPrice.pricePerEmployee.replace(
            "R$ ",
            ""
          );

          if (this.dataPrice.generateInvoice === "true")
            objToSend.generateInvoice = true;

          this.dataModalFeatureType = objToSend;
          this.dataModalFeatureType.context = this.context;
          this.dataModalFeatureType.math = Math.floor(Math.random() * 500);

          this.loadingPayment = false;

          $("#modalFeatureType").modal();

          // REQUEST_SERVICE.get(DORES_SELECT_BOX)
          //   .then(response => {
          //     UTIL_SERVICE.console("RESULT DORES_SELECT_BOX:", response.data);
          //
          //     this.doresItens = response.data;
          //   })
          //   .catch(reason => {
          //     ALERT_SERVICE.showMsgError(reason.response.data.erros);
          //   });
          //
          // REQUEST_SERVICE.get(OBJETIVOS_SELECT_BOX)
          //   .then(response => {
          //     UTIL_SERVICE.console("RESULT OBJETIVOS_SELECT_BOX:", response.data);
          //
          //     this.objetivosItens = response.data;
          //   })
          //   .catch(reason => {
          //     ALERT_SERVICE.showMsgError(reason.response.data.erros);
          //   });

          // REQUEST_SERVICE.get(FEATURES_COURTESY_SELECT_BOX)
          //   .then(response => {
          //     UTIL_SERVICE.console("RESULT FEATURES_COURTESY_SELECT_BOX:", response.data);
          //
          //     this.featuresCourtesyItens = response.data;
          //   })
          //   .catch(reason => {
          //     ALERT_SERVICE.showMsgError(reason.response.data.erros);
          //   });

          // if (this.$route.params.goalsFulfilled) {
          //   $("#modalFeatureType").modal();
          // } else {
          //   $("#modalQuestionSend").modal();
          // }
        }
      } else {
        if (!this.dataPrice.planType)
          this.errorPrice.planType = "Valor obrigatório.";

        if (!this.dataPrice.planId)
          this.errorPrice.planId = "Valor obrigatório.";

        if (!this.dataPrice.month) this.errorPrice.month = "Valor obrigatório.";

        if (this.dataPrice.priceToCharge === "R$ 0.00")
          this.errorPrice.priceToCharge = "Valor obrigatório.";

        if (this.dataPrice.recurringPrice === "R$ 0.00")
          this.errorPrice.recurringPrice = "Valor obrigatório.";

        if (!this.dataPrice.expireAt)
          this.errorPrice.expireAt = "Valor obrigatório.";

        if (!this.dataPrice.recurringDay)
          this.errorPrice.recurringDay = "Valor obrigatório.";

        if (!this.dataPrice.startAt)
          this.errorPrice.startAt = "Valor obrigatório.";

        if (!this.dataPrice.totalEmployee)
          this.errorPrice.totalEmployee = "Valor obrigatório.";

        if (this.dataPrice.pricePerEmployee === "R$ 0.00")
          this.errorPrice.pricePerEmployee = "Valor obrigatório.";
      }
    },
    sendPointRetro() {
      if (this.initialDate && this.finalDate) {
        if (!this.loadingSend) {
          this.loadingSend = true;
          let objSend = {
            companyId: this.dataPaymentCompany.company.id,
            initDate: moment(this.initialDate).format("YYYY-MM-DD"),
            endDate: moment(this.finalDate).format("YYYY-MM-DD"),
            userIds: [],
          };

          this.listFromUser.map((value, index) => {
            objSend.userIds.push(value.id);
            if (this.listFromUser.length === index + 1) {
              UTIL_SERVICE.console("DATA SEND:", objSend);
              REQUEST_SERVICE.requestContext(
                "POST",
                CREATE_POINT_DAY,
                this.context,
                objSend
              )
                .then((response) => {
                  UTIL_SERVICE.console(
                    "RESULT CREATE_POINT_DAY:",
                    response.data
                  );

                  this.listFromUser = [];
                  this.dataCompany.map((value, index) => {
                    $("#" + value.code).prop("checked", false);
                  });

                  this.loadingSend = false;

                  swal("Aviso", response.data, "success");
                })
                .catch((reason) => {
                  this.loadingSend = false;
                  reason.response.data.erros.map((value, index) => {
                    swal("Aviso", value.value, "error");
                  });
                });
            }
          });
        }
      } else {
        swal("Aviso", "Preencha as datas", "error");
      }
    },
    sendNormalization() {
      if (!this.loadingNormalization) {
        this.loadingNormalization = true;

        let url = FIX_BALANCE;
        url += "?c=" + this.companyId;
        url +=
          "&init=" + moment(this.normalization.initialDate).format("YYYYMMDD");
        url +=
          "&end=" + moment(this.normalization.finalDate).format("YYYYMMDD");

        UTIL_SERVICE.console("DATA SEND:", url);
        REQUEST_SERVICE.requestContext("GET", url, this.context)
          .then((response) => {
            UTIL_SERVICE.console("RESULT FIX_BALANCE:", response.data);

            this.loadingNormalization = false;

            swal("Aviso", response.data, "success");
          })
          .catch((reason) => {
            this.loadingNormalization = false;
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          });
      }
    },
    sendTestPeriod() {
      swal({
        title: "Aviso",
        text: "Você tem certeza que deseja excluir o período até:" +
          moment(this.untilTestPeriod).format("DD/MM/YYYY"),
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((valueInput) => {
        if (valueInput) {
          if (!this.loadingTestPeriod) {
            this.loadingTestPeriod = true;

            let url = DELETE_TRIAL_USAGE;
            url += "?c=" + this.companyId;
            url +=
              "&until=" + moment(this.untilTestPeriod).format("YYYY-MM-DD");

            UTIL_SERVICE.console("DATA SEND:", url);
            REQUEST_SERVICE.requestContext("GET", url, this.context)
              .then((response) => {
                UTIL_SERVICE.console(
                  "RESULT DELETE_TRIAL_USAGE:",
                  response.data
                );

                this.loadingTestPeriod = false;

                swal("Aviso", response.data, "success");
              })
              .catch((reason) => {
                this.loadingTestPeriod = false;
                reason.response.data.erros.map((value, index) => {
                  swal("Aviso", value.value, "error");
                });
              });
          }
        }
      });
    },
    changeTotalEmpoyee() {
      this.dataCompanyModal = this.dataPaymentCompany;
      this.dataCompanyModal.idCompany = this.$route.params.idCompany;
      this.dataCompanyModal.context = this.context;

      $("#modalChangeTotalEmployee").modal();
    },
    changeGiveGain() {
      this.dataGive = {};
      this.dataGive.IsTrial = value;

      $("#modalGiveGain").modal();
    },
    changeEmail() {
      this.dataCompanyModal = this.dataPaymentCompany;
      this.dataCompanyModal.context = this.context;

      $("#modalChangeEmail").modal();
    },
    changeGps() {
      this.dataCompanyModal = this.dataPaymentCompany;
      this.dataCompanyModal.context = this.context;

      $("#modalChangeGps").modal();
    },
    changeTimezone() {
      this.dataCompanyModal = "";
      this.dataCompanyModal = this.dataPaymentCompany;
      this.dataCompanyModal.context = this.context;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalChangeTimezone").modal();
    },
    openApplyRecalcPoints() {
      this.dataCompanyModal = {};
      this.dataCompanyModal.companyId = this.$route.params.idCompany;
      this.dataCompanyModal.context = this.context;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalApplyRecalcPoints").modal();
    },
    openWorkshiftTimezoneBulk() {
      this.dataCompanyModal = {};
      this.dataCompanyModal.companyId = this.$route.params.idCompany;
      this.dataCompanyModal.context = this.context;
      this.dataCompanyModal.math = Math.floor(Math.random() * 500);

      $("#modalWorkshiftTimezoneBulk").modal();
    },
    goToPhaseRules() {
      this.$router.push({
        path: `/regras-horas-extras/${this.$route.params.idCompany}/${this.context}`
      });
    },
    goToCompanyPhaseRules() {
      this.$router.push({
        path: `/regras-horas-extras-empresa/${this.$route.params.idCompany}/${this.context}`
      });
    },
    goToHE3() {
      this.$router.push({
        path: `/configurar-he3/${this.$route.params.idCompany}/${this.context}`
      });
    },
    goToWorkshiftAdvanced() {
      this.$router.push({
        path: `/config-avancada-turno/${this.$route.params.idCompany}/${this.context}`
      });
    },
    goToBalanceImport() {
      this.$router.push({
        path: `/importacao-saldo/${this.$route.params.idCompany}/${this.context}`
      });
    },
    openChurn() {
      this.dataCompanyModal = {};
      this.dataCompanyModal.id = this.$route.params.idCompany;
      this.dataCompanyModal.context = this.context;
      this.dataCompanyModal.type = 1;

      $("#modalChurn").modal();
    },
    openInadimplente() {
      this.dataCompanyModal = {};
      this.dataCompanyModal.id = this.$route.params.idCompany;
      this.dataCompanyModal.context = this.context;
      this.dataCompanyModal.type = 2;

      $("#modalChurn").modal();
    },
    getIndexesFromList(list) {
      let newList = [];
      for (let i in list) {
        if (
          typeof list[i].code === "number" &&
          newList.indexOf(list[i].code) === -1
        )
          newList.push(list[i].code);
      }
      return newList;
    },
    selectAllCheck() {
      this.checked = !this.checked;
      if (this.checked) {
        let indexes = this.getIndexesFromList(this.listFromUser);
        this.dataCompany.map((value, index) => {
          $("#" + value.code).prop("checked", true);

          if (indexes.indexOf(value.code) === -1) {
            this.listFromUser.push(value);
          }
        });
      } else {
        this.dataCompany.map((value, index) => {
          this.listFromUser = [];
          $("#" + value.code).prop("checked", false);
        });
      }
    },
    addRemoveUser(c) {
      let obj = {
        id: c.id,
        code: c.code,
        name: c.name
      };
      let indexes = this.getIndexesFromList(this.listFromUser);
      if (indexes.indexOf(obj.code) === -1) {
        this.listFromUser.push(obj);
      } else {
        this.listFromUser.splice(indexes.indexOf(obj.code), 1);
      }
    },
    removeAllUser() {
      this.checked = false;
      this.dataCompany.map((value, index) => {
        this.listFromUser = [];
        $("#" + value.code).prop("checked", false);
      });
    },
    removeUserFromCode(code) {
      let indexes = this.getIndexesFromList(this.listFromUser);
      this.listFromUser.splice(indexes.indexOf(code), 1);
      $("#" + code).prop("checked", false);
    },
    changeIuguId(idSub) {
      this.modalInputIugu = ''
      this.idSubsIugu = idSub

      $("#iugu-modal").modal();
    },
    changeIuguIdSub(idSub) {
      this.modalInputIuguSub = ''
      this.idSubsIuguSub = idSub

      $("#iugu-sub-modal").modal();
    },
    changeAsaasId(idSub) {
      this.modalInputAsaasCustomer = ''
      this.idSubsAsaasCustomer = idSub

      $("#asaas-customer-modal").modal();
    },
    changeAsaasIdSub(idSub) {
      this.modalInputAsaasSubscription = ''
      this.idSubsAsaasSubscription = idSub

      $("#asaas-subscription-modal").modal();
    },
    openDeletePayment(payment) {
      this.deletePaymentId = payment.id;
      this.deletePaymentPassword = '';
      this.deletePaymentNotes = '';
      this.deletePaymentPasswordError = '';
      this.deletePaymentNotesError = '';
      this.loadingDeletePayment = false;

      $('#delete-payment-password-modal').modal();
    },
    validateDeletePaymentPassword() {
      // Reset error
      this.deletePaymentPasswordError = '';

      // Validate password
      if (!this.deletePaymentPassword) {
        this.deletePaymentPasswordError = 'Senha é obrigatória';
        return;
      }

      if (this.deletePaymentPassword !== 'deleteFORCE!') {
        this.deletePaymentPasswordError = 'Senha incorreta';
        return;
      }

      // Password is correct, close password modal and open notes modal
      $('#delete-payment-password-modal').modal('hide');
      this.deletePaymentPassword = '';
      this.deletePaymentPasswordError = '';

      // Open notes modal
      setTimeout(() => {
        $('#delete-payment-notes-modal').modal();
      }, 300);
    },
    confirmDeletePayment() {
      // Reset error
      this.deletePaymentNotesError = '';

      // Validate notes
      if (!this.deletePaymentNotes || this.deletePaymentNotes.trim() === '') {
        this.deletePaymentNotesError = 'Observações são obrigatórias';
        return;
      }

      // All validations passed, proceed with deletion
      this.loadingDeletePayment = true;

      const url = DELETE_PAYMENT + this.deletePaymentId;
      const body = {
        Notes: this.deletePaymentNotes.trim()
      };

      UTIL_SERVICE.console("DATA SEND:", url, body);
      REQUEST_SERVICE.requestContext("POST", url, this.context, body)
        .then((response) => {
          UTIL_SERVICE.console("RESULT DELETE_PAYMENT:", response.data);

          this.loadingDeletePayment = false;
          $('#delete-payment-notes-modal').modal('hide');

          // Reset data
          this.deletePaymentId = '';
          this.deletePaymentPassword = '';
          this.deletePaymentNotes = '';
          this.deletePaymentPasswordError = '';
          this.deletePaymentNotesError = '';

          // Reload payment info to update the list
          this.getPaymentInfo();

          swal("Sucesso", response.data || "Fatura deletada com sucesso", "success");
        })
        .catch((reason) => {
          this.loadingDeletePayment = false;

          if (reason.response && reason.response.data && reason.response.data.erros) {
            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "error");
            });
          } else {
            const errorMessage = reason.response && reason.response.data
              ? (reason.response.data.message || reason.response.data)
              : 'Erro ao excluir a fatura. Tente novamente ou contate nosso suporte.';
            swal("Aviso", errorMessage, "error");
          }
        });
    },
    calcRecurringPrice(value, type) {
      let priceClean = value.replace("R$", "").trim();
      if (priceClean.includes(",")) priceClean = priceClean.replace(",", "");
      let priceNumber = Number(priceClean) * 1000;
      let result = 0;

      switch (type) {
        case 2:
          result = priceNumber / 2;
          break;
        case 3:
          result = priceNumber / 3;
          break;
        case 4:
          result = priceNumber / 6;
          break;
        case 5:
          result = priceNumber / 12;
          break;
        case 6:
          result = priceNumber / 24;
          break;
      }

      result = result / 1000;
      return result.toFixed(2);
    },
    calculateRecurringPriceForNovation() {
      if (!this.dataNovation.priceToCharge || !this.dataNovation.ePlanType || this.dataNovation.priceToCharge === "R$ 0.00") {
        return;
      }

      const planType = Number(this.dataNovation.ePlanType);

      if (planType === 1) {
        // Mensal: preço recorrente = preço de cobrança
        this.dataNovation.recurringPrice = this.dataNovation.priceToCharge;
      } else if (planType >= 2 && planType <= 6) {
        // Outros tipos: calcular baseado no tipo
        const calculatedPrice = this.calcRecurringPrice(this.dataNovation.priceToCharge, planType);
        // O v-money espera formato "R$ X,XX" (formato brasileiro com vírgula)
        // calculatedPrice vem como "X.XX", então convertemos para "R$ X,XX"
        const formattedPrice = "R$ " + calculatedPrice.replace(".", ",");
        this.dataNovation.recurringPrice = formattedPrice;
      }
    },
    changeBusinessUnit(value, subId) {
      this.newBusinessUnit = value
      this.idSubsUnit = subId

      if (!this.unit.length) {
        this.getSelectUnitMaster();
      }

      $("#business-unit-modal").modal();
    },
    changeSubscriptionBusinessUnit() {

      this.loadingChangeUnit = true;

      if (this.newBusinessUnit === "") {
        return swal("Aviso", "Escolha uma nova unidade de negocio antes de salvar!", "error");
      }

      let obj = {
        CompanyId: this.companyId,
        businessUnitId: this.newBusinessUnit,
        subscritionId: this.idSubsUnit,
      }

      UTIL_SERVICE.console("DATA SEND:", UPDATE_BUSINESS_UNIT, obj);
      REQUEST_SERVICE.requestContext("POST", UPDATE_BUSINESS_UNIT, this.context, obj)
        .then((response) => {
          UTIL_SERVICE.console("UPDATE_BUSINESS_UNIT:", response.data);

          this.loadingChangeUnit = false;
          this.showSubscriptions = false;

          this.getPaymentInfo();

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeUnit = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIdIugu() {
      this.loadingChangeIugu = true;

      UTIL_SERVICE.console("DATA SEND:", CHANGE_ID_IUGU);
      REQUEST_SERVICE.requestContext("PUT", CHANGE_ID_IUGU, this.context, {
        id: this.idSubsIugu,
        iuguClientId: this.modalInputIugu,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_SUBSCRIPTION_IUGU:", response.data);

          this.loadingChangeIugu = false;
          this.showSubscriptions = !this.showSubscriptions;

          this.getPaymentInfo();

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeIugu = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeIdIuguSub() {
      this.loadingChangeIuguSub = true;

      UTIL_SERVICE.console("DATA SEND:", CHANGE_ID_IUGU);
      REQUEST_SERVICE.requestContext("PUT", CHANGE_ID_IUGU, this.context, {
        id: this.idSubsIuguSub,
        iuguSubscriptionId: this.modalInputIuguSub,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT CHANGE_ID_IUGU:", response.data);

          this.loadingChangeIuguSub = false;
          this.showSubscriptions = !this.showSubscriptions;

          this.getPaymentInfo();

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeIuguSub = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeAsaasCustomerId() {
      this.loadingChangeAsaasCustomer = true;

      UTIL_SERVICE.console("DATA SEND:", UPDATE_ASAAS);
      REQUEST_SERVICE.requestContext("PUT", UPDATE_ASAAS, this.context, {
        Id: this.idSubsAsaasCustomer,
        AsaasCustomerId: this.modalInputAsaasCustomer,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_ASAAS:", response.data);

          this.loadingChangeAsaasCustomer = false;
          this.showSubscriptions = !this.showSubscriptions;

          this.getPaymentInfo();

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeAsaasCustomer = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    changeAsaasSubscriptionId() {
      this.loadingChangeAsaasSubscription = true;

      UTIL_SERVICE.console("DATA SEND:", UPDATE_ASAAS);
      REQUEST_SERVICE.requestContext("PUT", UPDATE_ASAAS, this.context, {
        Id: this.idSubsAsaasSubscription,
        AsaasSubscriptionId: this.modalInputAsaasSubscription,
      })
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPDATE_ASAAS:", response.data);

          this.loadingChangeAsaasSubscription = false;
          this.showSubscriptions = !this.showSubscriptions;

          this.getPaymentInfo();

          swal("Sucesso", response.data, "success");
        })
        .catch((reason) => {
          this.loadingChangeAsaasSubscription = false;

          reason.response.data.erros.map((value, index) => {
            swal("Aviso", value.value, "error");
          });
        });
    },
    openCalendar1: function () {
      this.$refs.programaticOpen1.showCalendar();
    },
    openCalendar2: function () {
      this.$refs.programaticOpen2.showCalendar();
    },
    openCalendar3: function () {
      this.$refs.programaticOpen3.showCalendar();
    },
    openCalendar4: function () {
      this.$refs.programaticOpen4.showCalendar();
    },
    openCalendar5: function () {
      this.$refs.programaticOpen5.showCalendar();
    },
    openCalendar6: function () {
      this.$refs.programaticOpen6.showCalendar();
    },
    openCalendar7: function () {
      this.$refs.programaticOpen6.showCalendar();
    },
    openCalendar8: function () {
      this.$refs.programaticOpen8.showCalendar();
    },
    openCalendar9: function () {
      this.$refs.programaticOpen9.showCalendar();
    },
    openCalendar10: function () {
      this.$refs.programaticOpen10.showCalendar();
    },
    openCalendarPaymentDate: function () {
      this.$refs.programaticOpenPaymentDate.showCalendar();
    },
    handlePaymentFileSelect(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedPaymentFile = file;
        this.dataAssign.bankSlipUri = "";
      }
    },
    uploadPaymentFile() {
      if (!this.selectedPaymentFile) {
        swal("Aviso", "Por favor, selecione um arquivo para upload.", "error");
        return Promise.reject('No file selected');
      }

      this.uploadingPayment = true;
      const contextCode = this.dataPaymentCompany && this.dataPaymentCompany.company && this.dataPaymentCompany.company.contextCode
        ? this.dataPaymentCompany.company.contextCode
        : this.context;

      return REQUEST_SERVICE.fileUploadV2(UPLOAD_PAYMENT_MASTER, this.selectedPaymentFile, contextCode)
        .then((response) => {
          UTIL_SERVICE.console("RESULT UPLOAD_PAYMENT_MASTER:", response);
          this.uploadingPayment = false;

          // O endpoint retorna uma string com a URL
          const uploadedUrl = typeof response.data === 'string' ? response.data : response.data.url || response.data.uri;

          if (!uploadedUrl) {
            throw new Error('URL não retornada pelo servidor');
          }

          this.dataAssign.bankSlipUri = uploadedUrl;
          return uploadedUrl;
        })
        .catch((reason) => {
          this.uploadingPayment = false;
          UTIL_SERVICE.console("ERROR UPLOAD_PAYMENT_MASTER:", reason);
          const errorMessage = reason.response && reason.response.data
            ? (reason.response.data.erros && reason.response.data.erros[0]
              ? reason.response.data.erros[0].value
              : reason.response.data.message || reason.response.data)
            : 'Erro ao fazer upload do arquivo. Tente novamente ou contate nosso suporte.';
          swal("Aviso", errorMessage, "error");
          return Promise.reject(reason);
        });
    },
    openCalendar11: function () {
      this.$refs.programaticOpen11.showCalendar();
    },
    openCalendar12: function () {
      this.$refs.programaticOpen12.showCalendar();
    },
    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setValueTypesMotive() {
      REQUEST_SERVICE.requestContext("GET", GET_CHURN_CATEGORY, this.context).then((response) => {
        UTIL_SERVICE.console("RESULT GET_CHURN_CATEGORY:", response);
        this.$route.params.typesMotive = response.data;

      }).catch((reason) => {
        console.log('Erro ao requisitar typesMotive', reason)
      });
    },
  },
  beforeMount() {
    this.getPaymentInfo();
  },
  validations: {
    days: {
      required,
      minLength: minLength(1),
    },
    notes: {
      required,
    },
    dataPrice: {
      price: {
        required,
      },
      pricePerEmployee: {
        required,
      },
      employees: {
        required,
      },
    },
  },
  watch: {
    'dataAssign.price': function (value) {
      if (!this.errorPrice2.price) return;
      this.errorPrice2.price = this.priceErrorFor(value);
    },
    'dataAssign.subscriptionPaymentHistoryType': function (newVal, oldVal) {
      // Limpar campos específicos de Pagamento Externo quando mudar para outro tipo
      if (oldVal === '9' && newVal !== '9') {
        this.dataAssign.paymentUploadMode = 'manual';
        this.dataAssign.bankSlipUri = '';
        this.dataAssign.paymentDate = '';
        this.selectedPaymentFile = null;
        this.errorPrice2.paymentDate = '';
        this.errorPrice2.bankSlipUri = '';
        this.tooltipPaymentExternalOpenned = false;
      }
      // Inicializar modo quando selecionar tipo 9
      if (newVal === '9' && !this.dataAssign.paymentUploadMode) {
        this.dataAssign.paymentUploadMode = 'manual';
      }
    },
    tooltipProfileOpenned: function () {
      if (this.tooltipOpenned) this.tooltipOpenned = false;
    },
    tooltipOpenned: function () {
      if (this.tooltipProfileOpenned) this.tooltipProfileOpenned = false;
    },
    invoiceUploadMode: function (newVal) {
      if (newVal === 'upload') {
        // Limpar URI quando mudar para modo upload para forçar novo upload
        this.dataSendInvoice.uri = '';
        this.selectedInvoiceFile = null;
        if (this.$refs.invoiceFileInput) {
          this.$refs.invoiceFileInput.value = '';
        }
      }
    },
    generateNote(value) {
      this.openPasswordModal(value);
    },
    cancelValueNote(value) {
      this.openPasswordModalCancel(value);
    },
    subscriptionId: function (value) {
      this.changeDataAssign.price = value.totalCost;
      this.changeDataAssign.subscriptionId = value.id;
      this.changeDataAssign.expireAt = value.initDate;

      if (value.invoiceDate)
        this.changeDataAssign.invoiceNotes = value.invoiceDate;

      if (value.invoiceNotes)
        this.changeDataAssign.invoiceNotes = value.invoiceNotes;

      if (value.notes) this.changeDataAssign.notes = value.notes;
    },
    callNewTotalEmployee: function (value) {
      this.dataPaymentCompany.totalPlanEmployee = value;
    },
    callResetPayment: function (v) {
      this.dataPrice = {
        businessUnitId: '',
        planId: '',
        month: '',
        generateInvoice: '',
        companyId: this.$route.params.idCompany,
        planType: '',
        priceToCharge: '',
        recurringPrice: '',
        expireAt: '',
        recurringDay: '',
        startAt: '',
        totalEmployee: '',
        pricePerEmployee: '',
        invoiceDate: '',
        invoiceNotes: '',
      };
    },
    callReloadFunction: function (value) {
      if (value.id) {
        this.addFeature(value);
      }
    },
    callReloadFunction2: function (value) {
      this.changeMonthYearNotes(value);
    },
    callReloadFunction3: function (value) {
      console.log(value, "okdosakdsakodas");
    },
    callNewFinancialEmail: function (value) {
      if (value) {
        this.dataPaymentCompany.company.financialEmail = value;
      }
    },
    'dataNovation.priceToCharge': function (value) {
      if (value && this.dataNovation.ePlanType) {
        this.calculateRecurringPriceForNovation();
      }
    },
    'dataNovation.ePlanType': function (value) {
      if (value && this.dataNovation.priceToCharge) {
        this.calculateRecurringPriceForNovation();
      }
    },
  },
};
</script>

<style lang="scss">

* {
  font-family: "Montserrat", sans-serif !important;
}

.box-cards-ia {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;

  .card-credits-ia {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border-radius: 8px !important;
    border: 1px solid #D5D7DA;
    background: #FFF;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.07);

    .card-title {
      margin: 0;
      font-weight: 600;
      color: #414651;
    }

    .card-stats {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      span {
        font-size: 22px;
        font-weight: 600;
      }

      p {
        font-weight: 500;
        margin: 0;
        color: #9CA0A7;
      }
    }
  }
}

.marqia-plan-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;

  .marqia-plan-badge {
    padding: 4px 12px;
    border-radius: 4px;
    background: #EAF4FB;
    color: #0F77AE;
    font-weight: 600;
    font-size: 13px;
  }

  .marqia-renews {
    color: #9CA0A7;
    font-size: 13px;
    font-weight: 500;
  }
}

.marqia-features {
  margin-top: 20px;

  .marqia-features-title {
    margin: 0 0 12px;
    font-weight: 600;
    color: #414651;
  }

  .feature-row {
    display: grid;
    grid-template-columns: 180px 1fr 48px 44px;
    align-items: center;
    gap: 12px;
    padding: 6px 0;

    .feature-label {
      color: #414651;
      font-weight: 500;
      font-size: 13px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .feature-bar {
      height: 8px;
      border-radius: 4px;
      background: #EEF2F7;
      overflow: hidden;

      .feature-bar-fill {
        height: 100%;
        border-radius: 4px;
        background: #3598DC;
        transition: width .3s ease;
      }
    }

    .feature-used {
      text-align: right;
      font-weight: 600;
      color: #414651;
      font-size: 13px;
    }

    .feature-pct {
      text-align: right;
      color: #9CA0A7;
      font-weight: 600;
      font-size: 13px;
    }
  }
}

.marqia-obs {
  margin: 16px 0 8px;
  padding: 12px 14px;
  background: #FFF8E1;
  border-left: 4px solid #F5B400;
  border-radius: 4px;
  color: #5B4A00;
  font-size: 13px;
  line-height: 1.4;
}

.inadimplencia-master-banner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 16px;
  width: 100%;
  margin-bottom: 16px;
  padding: 14px 18px;
  border-radius: 8px;
  background: linear-gradient(90deg, #8b1538 0%, #c0392b 45%, #e74c3c 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(192, 57, 43, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.2);

  &__badge {
    flex-shrink: 0;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    background: rgba(0, 0, 0, 0.25);
    border-radius: 4px;
    border: 1px solid rgba(255, 255, 255, 0.35);
  }

  &__text {
    flex: 1;
    min-width: 200px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  }
}

.input-with-date-filter {
  .vdp-datepicker {
    width: 100%;
    background: #EEF2F7;
    border-radius: 4px !important;
    border: 1px solid #EEF2F7;
    transition: .2s;

    font-size: 16px;
    font-weight: 400;
    color: var(--dark-gray);

    &__clear-button {
      position: absolute;
      top: -28px;
      right: 28px;
    }

    &::placeholder {
      font-size: 16px;
      font-weight: 400;
      color: var(--dark-gray);
    }

    &:hover {
      transition: .2s;
      border: 1px solid #cacaca;
    }

    &:focus-visible {
      outline: none;
      transition: .2s;
      border: 1px solid #cacaca;

      &::placeholder {
        transition: .1s;
        color: #EEF2F7;
      }
    }
  }

  i {
    z-index: 10055;
  }
}

.btn-report {
  margin-top: 20px;
}

.botton-a {
  margin-top: 20px;
}

.bg-error {
  width: 20%;
  padding: 5px 5px;
  background: #2ACC6B !important;
  border-radius: 4px !important;
  color: #FFF;
  display: inline-block;
  text-align: center;
}

.bg-error-a {
  width: 20%;
  padding: 5px 5px;
  background: #FF445D !important;
  border-radius: 4px !important;
  color: #FFF;
  display: inline-block;
  text-align: center;
}

.bg-warning {
  width: 20%;
  padding: 5px 5px;
  background: #FDD944 !important;
  border-radius: 4px !important;
  color: #FFF;
  display: inline-block;
  text-align: center;
}

.bg-green {
  background: #2F23D6 !important;
  border-radius: 4px !important;
  color: #FFF;
  width: 20%;
  padding: 5px 5px;
  display: inline-block;
  text-align: center;
}

.bg-default {
  background: #FF445D !important;
  border-radius: 4px !important;
  color: #FFF;
  width: 20%;
  padding: 5px 5px;
  display: inline-block;
  text-align: center;
}

.block-note {
  border-radius: 10px !important;
  margin: 20px 0 !important;
  background: #E6E9EC;
  padding: 14px !important;
  position: relative;

  .change-data {
    cursor: pointer;
    position: absolute;
    right: 14px;
    top: 14px;
  }

  h6 {
    color: #0C0C0C;
    font-size: 18px;
    font-weight: bold;
    display: block;
    margin: 0 0 20px;
  }

  a {
    display: block;
    font-size: 14px;
    color: #323131;
    font-weight: bold;
    margin-left: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid;
    width: 140px;

    &:hover {
      text-decoration: none;
    }
  }
}

.input-with-date {
  width: 100%;

  input {
    width: 100%;
  }
}

.error-msg {
  font-size: 12px;
  color: #E74A4E;
  text-align: left;
  display: block;
}

.change-user-title {
  margin-bottom: 12px;
}

.modal-change-user {
  display: block;
  margin-top: 12px;

  p {
    Font-weight: bold;
    margin: 0 0 12px 0;

    span {
      font-weight: normal;
    }
  }
}

.link-sale-page {
  p {
    display: flex;
    align-items: center;

    ion-icon {
      margin: 0 4px;
    }

    a {
      margin-left: 4px;
      font-weight: 500;
    }
  }
}

.tooltip-body {
  padding: 30px 0 0 5px;

  .body-status {
    display: flex;
    margin-bottom: 10px;
    position: relative;

    .btn-change-plan {
      position: absolute;
      bottom: -10px;
      right: 0;
    }

    .content-input {
      display: flex;
      flex-direction: column;

      input {
        border: none;
        -webkit-appearance: none;
        display: block;
        margin: 0 0 11px 0;
        width: 30px;
        height: 30px;
        border-radius: 50% !important;
        cursor: pointer;
        vertical-align: middle;
        box-shadow: rgba(126, 141, 167, 0.5) 0 1px 1px, inset rgba(126, 141, 167, 0.5) 0 0 0 1px;
        background-color: var(--classic-white);
        background-image: -webkit-radial-gradient(var(--high-blue) 0%, var(--high-blue) 33%, var(--classic-white) 40%, var(--classic-white) 70%);
        background-repeat: no-repeat;
        -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
        -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
        outline: none;
      }

      input:checked {
        -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
        -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
      }

      input:disabled {
        background-color: var(--classic-gray);
        cursor: no-drop;
      }

      input:active {
        -webkit-transform: scale(1.5);
        -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
      }


      /* The up/down direction logic */

      input,
      input:active {
        background-position: 0 24px;
      }

      input:checked {
        background-position: 0 0;
      }

      input:checked ~ input,
      input:checked ~ input:active {
        background-position: 0 -24px;
      }
    }

    .content-span {
      display: flex;
      flex-direction: column;

      span {
        font-size: 13px;
        font-weight: 400;
        text-decoration: underline;
      }

      .span-trial {
        margin: 6px 0 10px 25px;
      }

      .span-onboarding {
        margin: 12px 0 10px 25px;
      }

      .span-mid {
        margin: 13px 0 10px 25px;
      }

      .span-ongoing {
        margin: 13px 0 10px 25px;
      }
    }
  }

  .btn-change {
    position: absolute;
    bottom: 20px;
    right: 30px;
    text-decoration: none;
    background: var(--high-blue);
    padding: 9px 30px;
    color: var(--classic-white);
    border-radius: 4px !important;

    &:hover {
      background: #20179E;
    }
  }
}

.link {
  display: inline-block;
  margin-top: 20px;
  color: #3598DC;
  border-bottom: 1px solid #3598DC;
  cursor: pointer;

  &:hover,
  &:focus,
  &:active {
    font-weight: 600;
    text-decoration: none;
    color: #0F77AE;
    border-bottom: 1px dashed #0F77AE;
  }
}

.custom-scrollbar {
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #9C9797;
    border: 0 solid #9C9797;
  }
}

.search-employers {
  position: absolute;
  right: 0;
  margin-top: 10px;

  .user-disabled {
    cursor: pointer;
    color: #837D7D;
    border-bottom: 1px solid #BDB3B3;

    &:hover {
      text-decoration: none;
    }
  }

  form {
    margin-top: 20px;
  }

  label {
    display: block;
    font-weight: 600;
    letter-spacing: 1px;
  }

  input {
    display: inline-block;
    -webkit-border-radius: 4px !important;
    -moz-border-radius: 4px !important;
    border-radius: 4px !important;
    width: 50%;
  }

  button {
    background: #3598DC;
    color: #FFFFFF;
    text-decoration: none;
    margin-right: 30px;
    border-radius: 4px !important;
    border: none;
    font-weight: 600;
    display: inline-block;
    height: 33px;
    line-height: 34px;
    margin-left: 0;
    padding: 0 14px;
  }
}

.content-normalization {
  p {
    text-align: left;
    line-height: 24px;

    span {
      display: block;
    }
  }

  .title {
    min-height: 30px;
    padding: 0;
    margin-bottom: 0;

    p {
      font-size: 16px;
      color: #054F91;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: 10px;

      i {
        margin-right: 5px;
      }

      span {
        float: right;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          border-bottom: 1px solid;
        }
      }

      @media only screen and (max-device-width: 340px) {
        font-size: 14px;
      }
    }
  }
}

.tt-employers {
  .caption {
    width: 100%;
  }

  h3 {
    font-size: 18px;
    color: #054F91;
    text-transform: uppercase;
    font-weight: bold;
    display: block;
    margin-top: 10px;
    padding: 0 14px 0 0;

    i {
      margin-right: 5px;
    }

    span {
      float: right;
      font-size: 14px;
      cursor: pointer;

      &:hover {
        border-bottom: 1px solid;
      }
    }

    @media only screen and (max-device-width: 340px) {
      font-size: 14px;
    }
  }
}

.billet {
  padding: 20px 20px 30px;

  .titles {
    font-weight: 600;
    margin-bottom: 20px;
    display: block;
    border-bottom: 1px solid #E6E9EC;
    padding-bottom: 10px;
  }

  .title {
    p {
      font-size: 16px;
      color: #054F91;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: 10px;
      margin-bottom: 0;

      i {
        margin-right: 5px;
      }

      span {
        float: right;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          border-bottom: 1px solid;
        }
      }

      @media only screen and (max-device-width: 340px) {
        font-size: 14px;
      }
    }
  }
}

.checkbox {
  text-align: left;
  margin-left: 30px;
  padding-bottom: 40px;
}

.checkbox-plans {
  padding-bottom: 0 !important;
}

.checkbox label {
  display: inline-block;
  vertical-align: middle;
  position: relative;
  padding-top: 2px;
  padding-left: 5px;
  top: 0 !important;
}

.checkbox label::before {
  content: "";
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  top: 1px;
  left: 0;
  margin-left: -20px;
  border: 1px solid #CCCCCC;
  border-radius: 3px;
  background-color: #FFF;
  -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
}

.checkbox label::after {
  display: inline-block;
  position: absolute;
  width: 20px;
  height: 20px;
  left: 0;
  top: 0;
  margin-left: -20px;
  padding-left: 3px;
  padding-top: 2px;
  font-size: 14px;
  color: #3598DC;
}

.checkbox input[type="checkbox"] {
  opacity: 0;
  z-index: 1;
  height: 20px;
  width: 20px;
}

.checkbox input[type="checkbox"]:focus + label::before {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

.checkbox input[type="checkbox"]:checked + label::after {
  font-family: "FontAwesome", serif;
  content: "\f00c";
}

.checkbox input[type="checkbox"]:disabled + label {
  opacity: 0.65;
}

.checkbox input[type="checkbox"]:disabled + label::before {
  background-color: #EEEEEE;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox-info input[type="checkbox"]:checked + label::before {
  background-color: #FFF;
  border-color: #01A0DD;
}

.checkbox-info input[type="checkbox"]:checked + label::after {
  color: #01A0DD;
}

// ================================= PAGE PAYMENT
.box-nps {
  background-color: #FFFFFF;
  padding: 15px 20px 25px;
  margin-top: 0;
  margin-bottom: 25px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 10px !important;

  .title {
    min-height: 48px;
    padding: 0;
    margin-bottom: 10px;

    p {
      font-size: 18px;
      color: #054F91;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: 10px;

      i {
        margin-right: 5px;
      }

      span {
        float: right;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          border-bottom: 1px solid;
        }
      }

      @media only screen and (max-device-width: 340px) {
        font-size: 14px;
      }
    }
  }

  .info-nps {
    p {
      display: block;

      span {
        font-weight: 600;
      }
    }
  }

  .detail-nps {
    position: relative;
    overflow: auto;
    height: 220px;
    margin-bottom: 30px;

    .content {
      border-radius: 4px !important;
      border: 1px dashed;
      margin-bottom: 20px;
      padding: 14px 20px;
    }

    p {
      display: inline-block;
      margin: 0 40px 0 0;

      &:last-child {
        display: block;
        margin-top: 10px;
        margin-right: 0;
      }
    }
  }

  .month-nps {
    border: 1px dashed;
    border-radius: 4px !important;

    p {
      display: block;
    }
  }
}

.box-features {
  background-color: #FFFFFF;
  padding: 15px 20px 25px;
  margin-top: 0;
  margin-bottom: 25px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 10px !important;

  input[type="checkbox"][disabled] {
    cursor: pointer !important;
  }

  input[type="checkbox"]:disabled + label {
    opacity: unset !important;
  }

  .inline-block {
    display: inline-block;
    cursor: pointer;
    padding: 7px 20px 8px 40px !important;
    min-width: 200px;
    border: 1px solid #E6E9EC;
    border-radius: 25px !important;
    margin-left: 20px;
    margin-bottom: 20px;
    width: 300px;

    label {
      cursor: pointer;

      &:after {
        top: -1px;
        margin-left: -23px;
      }

      &:before {
        border-radius: 25px !important;
        margin-left: -24px;
      }
    }
  }

  .inline-checked {
    background: #00A651;

    label {
      color: #FFF !important;

      &:after {
        color: #00A651 !important;
      }
    }
  }

  .title {
    min-height: 48px;
    padding: 0;
    margin-bottom: 10px;

    p {
      font-size: 18px;
      color: #054F91;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: 10px;

      i {
        margin-right: 5px;
      }

      span {
        float: right;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          border-bottom: 1px solid;
        }
      }

      @media only screen and (max-device-width: 340px) {
        font-size: 14px;
      }
    }
  }

  .info-nps {
    p {
      display: block;

      span {
        font-weight: 600;
      }
    }
  }

  .detail-nps {
    position: relative;
    overflow: auto;
    height: 220px;
    margin-bottom: 30px;

    .content {
      border-radius: 4px !important;
      border: 1px dashed;
      margin-bottom: 20px;
      padding: 14px 20px;
    }

    p {
      display: inline-block;
      margin: 0 40px 0 0;

      &:last-child {
        display: block;
        margin-top: 10px;
        margin-right: 0;
      }
    }
  }

  .month-nps {
    border: 1px dashed;
    border-radius: 4px !important;

    p {
      display: block;
    }
  }

  .btn-benefits {
    button {
      background: #3598DC;
      color: #FFFFFF;
      text-decoration: none;
      margin-right: 30px;
      padding: 8px 20px;
      border-radius: 4px !important;
      border: none;
      min-width: 130px;
      font-weight: 600;
      display: inline-block;

      &:hover {
        background-color: #0F77AE;
      }
    }
  }

  .plans {
    .col-xs-12, .col-sm-12, .col-md-12, {
      padding: 0;
    }

    .first-col {
      padding-left: 0;
    }

    .last-col {
      padding-right: 0;
    }

    .extra-col {
      padding-left: 0;
      display: block !important;
    }

    .feature-type-plans {
      color: var(--dark-gray);
      font-size: 21px;
      font-weight: 400;

      span {
        font-weight: 700;
      }
    }

    .features-plans {
      display: flex;
      flex-direction: column;

      .modules {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 16px;
        margin: 16px 0 28px 0;
      }

      .plans-header {
        color: var(--dark-gray);

        .plans-title {
          font-weight: 600;
          font-size: 18px;
          padding-bottom: 8px;
          margin: 16px 0 8px 0;
          border-bottom: 1px solid var(--classic-gray);
        }

        .plans-subtitle {
          font-weight: 700;
          font-size: 14px;
        }
      }

      .new-checkbox {
        position: relative;
        display: flex;
        align-items: center;
        padding: 8.5px 8px;
        border: 1px solid #E6E9EC;
        border-radius: 18px !important;

        .tooltip-feature {
          position: absolute;
          background: #000;
          border-radius: 8px !important;
          font-size: 11px;
          padding: 6px;
          left: 50%;
          top: 50px;
          transform: translateX(-50%);
          max-width: 200px;
          color: #fff;
          display: none;
          z-index: 9999;

          &:before {
            content: "";
            display: block;
            width: 0;
            height: 0;
            border-left: 6px solid transparent;
            border-right: 6px solid transparent;
            border-bottom: 10px solid black;
            position: absolute;
            top: -9px;
            left: 50%;
            transform: translateX(-50%);
          }
        }

        &:hover {
          .tooltip-feature {
            display: block;
          }
        }

        ion-icon {
          width: 14px;
          min-width: 14px;
          margin-left: auto;
          color: #3a424e80;
        }
      }

      .switch-plans {
        input {
          display: none;
        }

        label {
          display: flex;
          align-items: center;
          width: 34px;
          height: 21px;
          background-color: #E6E9EC;
          position: relative;
          cursor: pointer;
          border-radius: 1.6rem !important;
          margin: 0;

          &::after {
            content: "";
            position: absolute;
            left: .3rem;
            width: 15px;
            height: 15px;
            border-radius: 50% !important;
            background: #9BAACF;
            transition: all .4s ease;
          }

          &::before {
            content: "";
            width: 100%;
            height: 100%;
            border-radius: inherit !important;
            background: #2F23D6;
            opacity: 0;
            transition: all .4s ease;
          }
        }
      }

      & input:checked {
        & ~ label {
          &::before {
            opacity: 1;
          }

          &::after {
            left: 1.6rem;
            background: #FFFFFF;
          }
        }
      }

      .checkbox-label {
        margin: 0 0 0 10px;
        font-weight: 400;
        font-size: 13px;
        color: #3A424E;
      }
    }
  }
}

.border-npsAverange-red {
  border: 2px solid red;
}

.border-npsAverange-orange {
  border: 2px solid orange;
}

.border-npsAverange-green {
  border: 2px solid green;
}

.box-detail-company {
  background-color: #FFFFFF;
  padding: 15px 20px 25px;
  margin-top: 0;
  margin-bottom: 25px;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 10px !important;

  &.box-detail-company--inadimplente {
    border-left: 6px solid #c0392b;
    box-shadow: 0 2px 10px rgba(192, 57, 43, 0.22), 0 0 0 1px rgba(192, 57, 43, 0.12);
  }

  .company-info {
    h3 {
      margin-top: 0;
      margin-bottom: 30px;
      color: #201E1E;

      span {
        font-weight: 700;
        border-bottom: 1px solid;
        padding-bottom: 10px;
        display: block;
        padding-left: 4px;
        padding-right: 4px;

        small {
          padding: 6px 12px;
          border-radius: 4px !important;
          color: #FFF;
          margin-right: 10px;
          display: inline-block;
        }
      }
    }

    div {
      margin-bottom: 10px;
      font-size: 13px;

      strong {
        color: #6B6969;
        font-weight: 700;
      }

      span {
        color: #6B6969;
      }
    }

    .btn-change-email {
      border-radius: 4px !important;
      font-weight: 600;
      text-align: center;
      border: 1px solid #3598DC;
      margin-left: 10px;
      padding: 0 30px;
      line-height: 21px;
      cursor: pointer;
      background: #FFF;

      span {
        color: #3598DC !important;
      }

      &:hover {
        background: #3598DC;

        span {
          color: #FFFFFF !important;
        }
      }
    }

    .btn-example-import {
      border-radius: 4px !important;
      font-weight: 600;
      text-align: center;
      border: 1px solid #3598DC;
      padding: 0 30px;
      line-height: 21px;
      cursor: pointer;
      background: #FFF;

      span {
        color: #3598DC !important;
      }

      &:hover {
        background: #3598DC;

        span {
          color: #FFFFFF !important;
        }
      }
    }

    .btn-import-collaborators {
      border-radius: 4px !important;
      font-weight: 600;
      text-align: center;
      border: 1px solid #2ACC6B;
      padding: 0 30px;
      line-height: 21px;
      cursor: pointer;
      background: #FFF;

      span {
        color: #2ACC6B !important;
      }

      &:hover {
        background: #2ACC6B;

        span {
          color: #FFFFFF !important;
        }

        .loading-btn {
          .spinner-btn {
            > div {
              background-color: #FFFFFF;
            }
          }
        }
      }

      .loading-btn {
        .spinner-btn {
          width: 160.96px;
          margin-bottom: 0;

          > div {
            margin-bottom: 0;
            margin-top: 3px;
            background-color: #2ACC6B;
          }
        }
      }
    }

    .input-import-collaborators {
      display: none;
    }

    .show-turn {
      border-radius: 4px !important;
      font-weight: 600;
      text-align: center;
      border: 1px solid #3598DC;
      line-height: 21px;
      cursor: pointer;
      background: #FFF;
      display: inline-block;
      padding: 0 20px;
      margin: 10px 0;

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        border: 1px solid #23527C;

        a {
          color: #23527C;
          text-decoration: none;
        }
      }
    }
  }

  .company-action {
    .content-obs {
      margin-top: -36px;

      label {
        color: #7B7878;
        font-weight: 500;
        margin-left: 4px;
      }

      textarea {
        border-radius: 4px !important;
        padding: 12px;
      }

      .field-txt-invalid {
        position: relative;
      }

      button {
        background: #3598DC;
        color: #FFFFFF;
        text-decoration: none;
        margin-right: 30px;
        padding: 8px 20px;
        border-radius: 4px !important;
        border: none;
        min-width: 130px;
        font-weight: 600;
        display: inline-block;

        &:hover {
          background-color: #0F77AE;
        }
      }
    }

    .content-inadimplente {
      display: inline-block;
      min-width: 250px;
      float: right;

      button {
        width: 90%;
      }
    }

    .content-churn {
      display: inline-block;
      width: 250px;
      float: right;

      button {
        background-color: #E30606;
        width: 100%;
        color: #FFF;
        text-transform: uppercase;
        font-weight: 600;
        text-align: center;
        border: none;
        padding: 8px 20px;
        -webkit-border-radius: 4px !important;
        -moz-border-radius: 4px !important;
        border-radius: 4px !important;

        &:hover {
          background: #C70303;
        }
      }
    }

    .action {
      display: inline-block;
      padding-right: 20px;
      padding-left: 20px;
      border-right: 1px dashed #CED0D1;

      .minh {
        min-height: 40px;
      }

      p {
        margin: 11px 0;
        color: #9B9B9B;
        font-size: 14px;
      }

      button {
        background: #3598DC;
        margin-top: 10px;
        color: #FFFFFF;
        text-decoration: none;
        margin-right: 14px;
        min-width: 144px;
        padding: 8px 20px;
        border-radius: 4px !important;
        border: none;
        display: inline-block;

        &:hover {
          background-color: #0F77AE;
        }
      }

      .form-group {
        margin-bottom: 5px;

        label {
          color: #9B9B9B;
          font-weight: 500;
          margin-left: 4px;
        }

        .field-txt-invalid {
          position: absolute;
          margin-top: 3px;
        }

        input {
          -webkit-border-radius: 4px !important;
          -moz-border-radius: 4px !important;
          border-radius: 4px !important;
        }
      }

      .btn-with-input {
        position: absolute;
        top: 13px;
        right: 0;
      }

      .checkbox {
        margin-left: 0;
      }

      .checkbox label {
        padding-top: 4px;

        .danger {
          border-bottom: 1px solid #D9534F;
          padding-left: 5px;
          padding-right: 5px;
          padding-bottom: 3px;
          margin-left: 10px;
          color: #D9534F;
        }

        .default {
          border-bottom: 1px solid;
          padding-left: 5px;
          padding-right: 5px;
          padding-bottom: 3px;
          margin-left: 10px;
        }
      }

      .checkbox {
        padding-left: 20px;
      }

      .checkbox label {
        display: inline-block;
        vertical-align: middle;
        position: relative;
        padding-top: 2px;
        padding-left: 5px;
        top: 0 !important;
        color: #9B9B9B;
        font-size: 14px;
      }

      .checkbox label a {
        cursor: pointer;
        border-bottom: 1px solid #B4B4B4;
      }

      .checkbox label a:hover {
        color: #009DD9;
        border-bottom: 1px solid #009DD9;
        text-decoration: none;
      }

      .checkbox label::before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 20px;
        height: 20px;
        top: 3px;
        left: 0;
        margin-left: -23px;
        border: 1px solid #CCCCCC;
        border-radius: 3px;
        background-color: #FFF;
        -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
        -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
        transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      }

      .checkbox label::after {
        display: inline-block;
        position: absolute;
        width: 20px;
        height: 20px;
        left: -1px;
        top: 2px;
        margin-left: -20px;
        padding-left: 1px;
        padding-top: 1px;
        font-size: 14px;
        color: #009DD9;
      }

      .checkbox input[type="checkbox"] {
        opacity: 0;
        z-index: 1;
        height: 20px;
        width: 20px;
      }

      .checkbox input[type="checkbox"]:focus + label::before {
        outline: thin dotted;
        outline: 5px auto -webkit-focus-ring-color;
        outline-offset: -2px;
      }

      .checkbox input[type="checkbox"]:checked + label::after {
        font-family: "FontAwesome", serif;
        content: "\f00c";
      }

      .checkbox input[type="checkbox"]:disabled + label {
        opacity: 0.65;
      }

      .checkbox input[type="checkbox"]:disabled + label::before {
        background-color: #EEEEEE;
        cursor: not-allowed;
      }

      .checkbox.checkbox-circle label::before {
        border-radius: 50%;
      }

      .checkbox.checkbox-inline {
        margin-top: 0;
      }

      .checkbox-info input[type="checkbox"]:checked + label::before {
        background-color: #FFF;
        border-color: #01A0DD;
      }

      .checkbox-info input[type="checkbox"]:checked + label::after {
        color: #01A0DD;
      }

      &:first-child {
        padding-left: 0;
      }

      &:last-child {
        border-right: none;
      }
    }

    .btn-warning {
      background-color: #E6B239 !important;

      &:hover {
        background-color: #D6A022 !important;
      }
    }

    .btn-danger {
      background-color: #E30606 !important;

      &:hover {
        background: #C70303 !important;
      }
    }

    .face-active {
      display: block;
      color: #9B9B9B;
      font-size: 14px;
      border: 1px solid #DCD7D7;
      padding: 8px 0;
      border-radius: 4px !important;
      text-align: center;
      font-weight: 600;
      line-height: 23px;
    }
  }

  .face-area {
    p {
      font-weight: 600;
      text-align: left;
      margin: 25px 0 0;
      display: inline-block;
      border: 1px solid;
      padding: 3px 15px;
      border-radius: 4px !important;
    }

    button {
      background: #3598DC;
      margin-top: 30px;
      color: #FFFFFF;
      text-decoration: none;
      margin-right: 14px;
      min-width: 144px;
      padding: 8px 20px;
      border-radius: 4px !important;
      border: none;
      display: inline-block;

      &:hover {
        background-color: #0F77AE;
      }
    }
  }

  .add-date-from-billet {
    button {
      background: #3598DC;
      color: #FFFFFF;
      text-decoration: none;
      margin-right: 30px;
      padding: 8px 20px;
      border-radius: 4px !important;
      border: none;
      min-width: 130px;
      font-weight: 600;
      display: inline-block;

      &:hover {
        background-color: #0F77AE;
      }
    }
  }

  .title {
    min-height: 48px;
    padding: 0;
    margin-bottom: 10px;

    .title-initial {
      display: flex;
      align-items: center;

      .company-benefits {
        padding: 2px 8px;
        border-radius: 4px !important;
        display: inline-block;
        text-align: center;
        margin: 0 2px 2px 1rem;
        color: #FFFFFF;
        cursor: auto;

        &:hover {
          border: none;
        }
      }

      .company-defaulting {
        margin-left: 10px;
        padding: 6px 14px;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #fff !important;
        background: linear-gradient(180deg, #e74c3c 0%, #c0392b 100%);
        border-radius: 4px;
        box-shadow: 0 2px 6px rgba(192, 57, 43, 0.5);
        border: 1px solid rgba(0, 0, 0, 0.12);
      }
    }

    p {
      font-size: 18px;
      color: #054F91;
      text-transform: uppercase;
      font-weight: bold;
      display: block;
      margin-top: 10px;

      i {
        margin-right: 5px;
      }

      span {
        float: right;
        font-size: 14px;
        cursor: pointer;

        &:hover {
          border-bottom: 1px solid;
        }
      }

      @media only screen and (max-device-width: 340px) {
        font-size: 14px;
      }
    }
  }

  .box-import {
    padding: 2px;
  }

  /* Tageamento consolidado no topo (logo abaixo do nome da empresa) */
  .company-tags-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin: 4px 0 18px;

    > strong { color: #6B6969; font-weight: 700; }
  }

  /* Botões de importação distribuídos em 3 colunas */
  .imports-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    align-items: start;
    margin-bottom: 8px;

    .box-import > div { margin-bottom: 6px; }

    .box-import button.btn-import-collaborators,
    .box-import button.btn-example-import {
      width: 100%;
      padding: 6px 10px;
      line-height: 1.25;
      white-space: normal;
      min-height: 40px;
    }

    /* o spinner de loading tem largura fixa; deixa fluida dentro da coluna */
    .btn-import-collaborators .loading-btn .spinner-btn {
      width: 100%;
    }
  }

  @media only screen and (max-width: 991px) {
    .imports-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media only screen and (max-width: 600px) {
    .imports-grid { grid-template-columns: 1fr; }
  }

  .report-points-row { margin-top: 4px; }

  .box-payment-value {
    background-color: #00A651;
    min-height: 100px;
    max-height: 100px;
    display: block;
    margin-bottom: 25px;
    overflow: hidden;

    .visual {
      width: 80px;
      height: 80px;
      display: block;
      float: left;
      padding-top: 10px;
      padding-left: 15px;
      margin-bottom: 15px;
      font-size: 35px;
      line-height: 35px;

      i {
        color: #FFFFFF;
        opacity: 0.1;
        filter: alpha(opacity=10);
        margin-left: -35px;
        font-size: 110px;
        line-height: 110px;
      }
    }

    .details {
      position: absolute;
      right: 15px;
      padding-right: 15px;

      .number {
        color: #FFFFFF;
        padding-top: 25px;
        text-align: right;
        font-size: 34px;
        line-height: 36px;
        margin-bottom: 0;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .desc {
        color: #FFFFFF;
        opacity: 1;
        filter: alpha(opacity=100);
        text-align: right;
        font-size: 16px;
        font-weight: 300;
        margin-top: 5px;
      }
    }
  }

  .box-payment-date {
    background-color: #C29D0B;
    min-height: 100px;
    max-height: 100px;
    display: block;
    margin-bottom: 25px;
    overflow: hidden;

    .visual {
      width: 80px;
      height: 80px;
      display: block;
      float: left;
      padding-top: 10px;
      padding-left: 15px;
      margin-bottom: 15px;
      font-size: 35px;
      line-height: 35px;

      i {
        color: #FFFFFF;
        opacity: 0.1;
        filter: alpha(opacity=10);
        margin-left: -35px;
        font-size: 110px;
        line-height: 110px;
      }
    }

    .details {
      position: absolute;
      right: 15px;
      padding-right: 15px;

      .number {
        color: #FFFFFF;
        padding-top: 25px;
        text-align: right;
        font-size: 34px;
        line-height: 36px;
        margin-bottom: 0;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .desc {
        color: #FFFFFF;
        opacity: 1;
        filter: alpha(opacity=100);
        text-align: right;
        font-size: 16px;
        font-weight: 300;
        margin-top: 5px;
      }
    }
  }

  .box-payment-status {
    background-color: #0F77AE;
    min-height: 100px;
    max-height: 100px;
    display: block;
    margin-bottom: 25px;
    overflow: hidden;

    .visual {
      width: 80px;
      height: 80px;
      display: block;
      float: left;
      padding-top: 10px;
      padding-left: 15px;
      margin-bottom: 15px;
      font-size: 35px;
      line-height: 35px;

      i {
        color: #FFFFFF;
        opacity: 0.1;
        filter: alpha(opacity=10);
        margin-left: -35px;
        font-size: 110px;
        line-height: 110px;
      }
    }

    .details {
      position: absolute;
      right: 15px;
      padding-right: 15px;

      .number {
        color: #FFFFFF;
        padding-top: 25px;
        text-align: right;
        font-size: 34px;
        line-height: 36px;
        margin-bottom: 0;
        font-weight: 600;
        letter-spacing: 1px;
      }

      .desc {
        color: #FFFFFF;
        opacity: 1;
        filter: alpha(opacity=100);
        text-align: right;
        font-size: 16px;
        font-weight: 300;
        margin-top: 5px;
      }
    }
  }

  .payment-history {
    .link {
      color: #3598DC;
      border-bottom: 1px solid #3598DC;
      cursor: pointer;

      &:hover,
      &:focus,
      &:active {
        font-weight: 600;
        text-decoration: none;
        color: #0F77AE;
        border-bottom: 1px dashed #0F77AE;
      }
    }

    .payment-tab {
      position: relative;
      margin-bottom: 1px;
      width: 100%;
      color: #FFFFFF;
      overflow: hidden;

      input {
        position: absolute;
        opacity: 0;
        z-index: -1;
      }

      label {
        position: relative;
        display: block;
        padding: 15px 1.5em;
        color: #7B7878;
        cursor: pointer;
        transition: all 0.3s;
        background-color: transparent;
        border-bottom: 1px solid #EEEEEE;
        font-size: 16px;
        text-transform: initial;
        font-weight: normal;

        span {
          float: right;
          margin-right: 30px;

          @media only screen and (max-device-width: 414px) {
            float: left;
            display: block;
            padding-top: 2px;
          }
        }

        &::after {
          position: absolute;
          right: 0;
          top: 2px;
          font-size: 16px;
          display: block;
          width: 3em;
          height: 3em;
          line-height: 3;
          text-align: center;
          -webkit-transition: all 0.35s;
          -o-transition: all 0.35s;
          transition: all 0.35s;

          @media only screen and (max-device-width: 414px) {
            top: 3px;
            right: -10px;
          }
        }

        @media only screen and (max-device-width: 414px) {
          font-size: 14px;
          padding-bottom: 27px;
        }
      }

      .tab-content {
        max-height: 0;
        overflow: hidden;
        -webkit-transition: max-height 0.25s;
        -o-transition: max-height 0.25s;
        transition: max-height 0.25s;
        transition-duration: 0.5s !important;

        .info {
          color: #7B7878;

          div {
            .fault {
              background: #E74A4E;
            }

            .success {
              background: #00A651;
            }

            &:first-child {
              i {
                border-radius: 100px !important;
                float: left;
                height: 27px;
                width: 27px;
                color: #FFFFFF;
                font-size: 18px;
                text-align: center;
                position: absolute;
                left: 34px;
                top: 75px;
                padding: 6.4px 0 4px 0;

                @media only screen and (max-device-width: 414px) {
                  top: 86px;
                }
              }

              span {
                color: #7B7878;
              }
            }

            &:last-child {
              margin-left: 55px;

              h3 {
                font-size: 16px;
                font-weight: 700;
                color: #201E1E;
                text-transform: uppercase;
                margin: 20px 30px;

                span {
                  color: #201E1E;
                  border-bottom: 1px solid #201E1E;
                }

                @media only screen and (max-device-width: 414px) {
                  margin: 20px 0;
                }
              }

              p {
                color: #7B7878;
                font-size: 14px;
                margin: 0 30px 5px;

                &:last-child {
                  margin: 0 30px 20px;

                  @media only screen and (max-device-width: 414px) {
                    margin: 10px 0 20px 0;
                  }
                }

                @media only screen and (max-device-width: 414px) {
                  margin: 10px 0;
                }
              }

              @media only screen and (max-device-width: 414px) {
                margin: 0 0;
              }
            }
          }
        }
      }

      input:checked ~ .tab-content {
        max-height: 100vh;
      }

      input[type="checkbox"] + label::after {
        font-family: FontAwesome;
        content: "\f054";
      }

      input[type="radio"] + label::after {
        font-family: FontAwesome;
        content: "\f054";
      }

      input[type="checkbox"]:checked + label::after {
        transform: rotate(+90deg);
      }

      input[type="radio"]:checked + label::after {
        transform: rotate(+90deg);
      }
    }
  }
}

.info {
  font-size: 12px;
}

.boleto {
  margin: 20px 0;
}

.boleto a {
  margin-left: 20px;
  font-size: 18px;
  font-weight: 500;
  color: #111;
  text-decoration: none;
  border-bottom: 1px solid #111;
}

.boleto a:hover {
  font-weight: bold;
  text-decoration: none;
}

.company-info {
  background: #FFFFFF;
  padding: 0 30px;

  .portlet-title {
    padding: 15px 20px 10px;
    min-height: 48px;
    border-bottom: 1px solid #EEE;
    margin-bottom: 10px;

    i {
      font-size: 15px;
      font-weight: 300;
      margin-top: 3px;
      margin-right: 5px;
      display: inline-block;
    }

    span {
      font-size: 16px;
      color: #32C5D2;
      text-transform: uppercase;
      font-weight: bold;
    }
  }

  .portlet-body {
    padding: 10px 20px 20px;

    h3 {
      margin: 0 0 0.7em;
      font-size: 18px;
      font-weight: 700;
      text-decoration: underline;
    }

    div {
      margin-bottom: 4px;

      &:first-child {
        margin-bottom: 10px;
      }
    }
  }
}

.subscription-actions {
  display: flex;
  gap: 8px;
  margin: 12px 0 0 20px;

  button {
    min-width: 100px;
    color: var(--classic-white);
    background: var(--high-blue);
    padding: 8px 14px;
    border-radius: 4px !important;
    font-size: 12px;
    font-weight: 500;
    border: none;

    &:hover {
      background: #20179E;
    }

    span {
      margin-top: 0;
      font-weight: 500;
      color: var(--classic-white) !important;
    }

    .loading-btn {
      margin-left: 54px !important;
      margin-top: 0 !important;

      .spinner-btn {
        position: relative;
        margin-top: 0 !important;

        .rect1 {
          position: absolute;
          top: 3px;
          left: -35px;
        }

        .rect2 {
          position: absolute;
          top: 3px;
          left: -28px;
        }

        .rect3 {
          position: absolute;
          top: 3px;
          left: -21px;
        }

        .rect4 {
          position: absolute;
          top: 3px;
          left: -14px;
        }

        .rect5 {
          margin-top: 0 !important;
          position: absolute;
          top: 3px;
          left: -27px;
        }
      }
    }
  }
}

.historic-payment {
  background: #FFFFFF;
  padding: 0;

  h3 {
    padding: 8px 14px;
    font-size: 16px;

    span {
      float: right;
      font-size: 14px !important;
      cursor: pointer;

      &:hover {
        border-bottom: 1px solid;
      }
    }
  }
}

.border-payment {
  background-size: cover;
  padding: 20px 15px 10px 15px !important;
  background: #265389 no-repeat center;
  color: #FFF;
}

.add-date-billet {
  position: absolute;
  top: 80px;
  right: 40px;

  label {
    font-size: 13px;
    margin-left: 10px;
  }

  input {
    border-radius: 25px !important;
  }

  button {
    border-radius: 25px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    top: 4px;

    &:hover {
      background-color: #054F91;
    }
  }
}

.box-infos {
  position: absolute;
  top: 0;
  right: 0;
  display: flex;
  gap: 12px;
}

.company-plan-str {
  background: #E6E9EC;
  color: #000;
  padding: 6px 10px;
  border-radius: 4px !important;
  font-weight: 600;
  letter-spacing: 1px;
}

.content-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: absolute;
  right: 0;

  .btn-send-fatura {
    float: right;
    border: none;
    padding: 10px 20px;
    border-radius: 4px !important;
    cursor: pointer;
    font-size: 14px;
    background: #265389;
    color: #FFF !important;

    span {
      color: #fff !important;
    }

    &:hover {
      background-color: #054F91;
    }
  }
}

.default-btn {
  button {
    border-radius: 25px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    position: relative;
    top: 4px;

    &:hover {
      background-color: #054F91;
    }
  }
}

.button-b {
  position: absolute;
  right: 50px;
}

.styleCompany {
  float: none !important;
  margin-left: 30px !important;
  color: #6B6969 !important;
}

.billing-tag {
  padding: 5px;
  border: none;
  border-radius: 5px !important;
  float: none !important;
  margin-left: 15px !important;
  color: var(--classic-white);
}

body {
  .iugu-group, .button-group {
    margin: 0 !important;
    padding: 0;

    .iugu-client {
      font-size: 15px !important;
      display: flex;
      flex-direction: column;
      width: 31.25%;
      margin: 0 0 20px;
      padding: 0;
      position: relative;

      .iugu-group-content {
        margin-top: 8px;

        button {
          position: absolute;
          right: 50px;

          width: 25%;
          color: var(--classic-white);
          background: var(--high-blue);
          padding: 4px 9px;
          border-radius: 4px !important;
          font-size: 12px;
          font-weight: 500;
          border: none;

          &:hover {
            background: #20179E;
          }

          span {
            margin-top: 0;
            font-weight: 500;
            color: var(--classic-white) !important;
          }

          .loading-btn {
            margin-left: 30px !important;
            margin-top: 0 !important;

            .spinner-btn {
              position: relative;
              margin-top: 0 !important;

              .rect1 {
                position: absolute;
                top: 3px;
                left: -35px;
              }

              .rect2 {
                position: absolute;
                top: 3px;
                left: -28px;
              }

              .rect3 {
                position: absolute;
                top: 3px;
                left: -21px;
              }

              .rect4 {
                position: absolute;
                top: 3px;
                left: -14px;
              }

              .rect5 {
                margin-top: 0 !important;
                position: absolute;
                top: 3px;
                left: -27px;
              }
            }
          }
        }
      }
    }

    .iugu-subscription {
      font-size: 15px !important;
      display: flex;
      flex-direction: column;
      width: 31.25%;
      margin: 0 0 20px !important;
      padding: 0;
      position: relative;

      .iugu-group-content {
        margin-top: 8px;

        button {
          position: absolute;
          right: 50px;

          width: 25%;
          color: var(--classic-white);
          background: var(--high-blue);
          padding: 4px 9px;
          border-radius: 4px !important;
          font-size: 12px;
          font-weight: 500;
          border: none;

          &:hover {
            background: #20179E;
          }

          span {
            margin-top: 0;
            font-weight: 500;
            color: var(--classic-white) !important;
          }

          .loading-btn {
            margin-left: 30px !important;
            margin-top: 0 !important;

            .spinner-btn {
              position: relative;
              margin-top: 0 !important;

              .rect1 {
                position: absolute;
                top: 3px;
                left: -35px;
              }

              .rect2 {
                position: absolute;
                top: 3px;
                left: -28px;
              }

              .rect3 {
                position: absolute;
                top: 3px;
                left: -21px;
              }

              .rect4 {
                position: absolute;
                top: 3px;
                left: -14px;
              }

              .rect5 {
                margin-top: 0 !important;
                position: absolute;
                top: 3px;
                left: -27px;
              }
            }
          }
        }
      }
    }

    .button-change {
      display: flex;
      flex-direction: column;
      font-size: 15px !important;
      width: 31.25%;
      margin: 0 0 20px !important;
      padding: 0;
      position: relative;

      .button-content {
        margin-top: 5px;

        .button-value {
          font-size: 13px !important;
          font-weight: 600;
          margin-top: 5px;

          display: list-item;
          width: 180px;
          white-space: nowrap;
          overflow: hidden !important;
          text-overflow: ellipsis;
        }

        button {
          position: absolute;
          right: 50px;
          top: 28px;

          width: 25%;
          color: var(--classic-white);
          background: var(--high-blue);
          padding: 4px 9px;
          border-radius: 4px !important;
          font-size: 12px;
          font-weight: 500;
          border: none;

          &:hover {
            background: #20179E;
          }

          span {
            margin-top: 0;
            font-weight: 500;
            color: var(--classic-white) !important;
          }

          .loading-btn {
            margin-left: 30px !important;
            margin-top: 0 !important;

            .spinner-btn {
              position: relative;
              margin-top: 0 !important;

              .rect1 {
                position: absolute;
                top: 3px;
                left: -35px;
              }

              .rect2 {
                position: absolute;
                top: 3px;
                left: -28px;
              }

              .rect3 {
                position: absolute;
                top: 3px;
                left: -21px;
              }

              .rect4 {
                position: absolute;
                top: 3px;
                left: -14px;
              }

              .rect5 {
                margin-top: 0 !important;
                position: absolute;
                top: 3px;
                left: -27px;
              }
            }
          }
        }
      }
    }
  }
}

#password-modal-churn {
  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .btn-register {
    border-radius: 4px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
    margin-top: 10px;
  }

  .close-btn {
    border-radius: 4px !important;
    background-color: #8B8787;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
  }
}

#password-modal-benefits {
  .error-msg {
    font-size: 12px;
    color: #E74A4E;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .btn-register {
    border-radius: 4px !important;
    background-color: #3598DC;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
    margin-top: 10px;
  }

  .close-btn {
    border-radius: 4px !important;
    background-color: #8B8787;
    padding: 7px 35px 7px 35px;
    font-weight: 600;
    text-align: center;
    color: #FFF;
    border: none;
    height: 36px;
  }
}

.error-border {
  border-color: #dc3545 !important;
}

#iugu-modal, #iugu-sub-modal, #asaas-customer-modal, #asaas-subscription-modal, #business-unit-modal, #delete-payment-password-modal, #delete-payment-notes-modal {
  .loading-btn {
    .spinner-btn {
      width: 35px;
      margin-top: 3px;

      .rect1 {
        margin-right: 0 !important;
      }

      .rect2 {
        margin-right: 0 !important;
      }

      .rect3 {
        margin-right: 0 !important;
      }

      .rect4 {
        margin-right: 0 !important;
      }

      .rect5 {
        margin-right: 0 !important;
      }

    }
  }

  .modal-dialog {
    width: 500px;
    margin-top: 15%;

    .content {
      border: none;
      box-shadow: none;
      border-radius: 8px !important;

      .modal-header {
        position: relative;
        padding: 20px 30px;
        border-bottom: none;

        .title-group {
          display: flex;
          align-items: flex-end;

          ion-icon {
            margin-right: 5px;
            font-size: 23px;
            color: var(--dark-gray);
          }

          .title-modal {
            margin: 0;
            text-align: left;
            display: flex;
            align-items: center;
            font-size: 18px;
            font-weight: 700;
            color: var(--classic-black);
          }
        }

        .subtitle {
          span {
            margin-top: 5px;
            margin-left: 4px;
            font-size: 14px;
            font-weight: 400;
            color: var(--dark-gray);
          }
        }

        .close-btn-password {
          position: absolute;
          right: 26px;
          top: 16px;
          height: 20px;
          color: var(--light-red);

          &:hover {
            color: var(--high-red);
          }

          ion-icon {
            font-size: 20px;
            pointer-events: none;
          }
        }
      }

      .modal-body {
        padding: 0 30px 20px;

        .password-validate {
          display: flex;
          position: relative;

          ion-icon {
            position: absolute;
            right: 10px;
            top: 10px;
            font-size: 16px;
            color: var(--dark-gray);
          }

          input, select {
            width: 100%;
            background: #EEF2F7;
            border-radius: 4px !important;
            padding: 6px 12px;
            border: 1px solid #EEF2F7;
            transition: .2s;
            margin-right: 20px;

            font-size: 16px;
            font-weight: 400;
            color: var(--dark-gray);

            &::placeholder {
              font-size: 16px;
              font-weight: 400;
              color: var(--dark-gray);
            }

            &:hover {
              transition: .2s;
              border: 1px solid #CACACA;
            }

            &:focus-visible {
              outline: none;
              transition: .2s;
              border: 1px solid #CACACA;

              &::placeholder {
                transition: .1s;
                color: #EEF2F7;
              }
            }
          }
        }

        .btn-validate {
          background: #2F23D6;
          color: #FFFFFF;
          border-radius: 4px !important;
          border: none;
          padding: 0 20px;

          &:hover {
            background: #20179E;
          }
        }
      }
    }
  }
}

.default-box {
  border-radius: 10px !important;
}

.list-default {
  border-radius: 10px !important;
}

.portlet {
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  border-radius: 10px !important;

  .portlet-title {
    border: none !important;
    margin-bottom: 0 !important;
  }
}

.loader-page-content {
  border-radius: 10px !important;
}

.swal-password {
  .swal-footer {
    display: flex;
    justify-content: space-around;
    margin-bottom: 15px;
  }
}

.spacing-line {
  padding-bottom: 82px !important;
}

.btn-change-billing {
  background-color: #6C5CE7;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  margin-left: 8px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #5B4BD5;
  }
}

.radio-group {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;

  .radio-label {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="radio"] {
      margin-right: 8px;
      cursor: pointer;
    }

    span {
      font-size: 14px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/companyDetail/companyDetail.vue